export default {
  seleccionaNegocio: "Selecionar negócio...",
  filtraPorEtiqueta: "Filtrar por etiqueta",
  noEncontramosResultadosPara: "Não encontramos resultados para ",
  mostrando: "Mostrando",
  resultado: "resultado",
  resultados: "resultados",

  // ALMACÉN
  totalAlmacen: "Total Armazém",
  totalAlmacenDto: "Total Armazém Desc",
  existenciasTeoricas: "Existências Teóricas",
  diferencia: "Diferença",
  noContabilizado: "Não contabilizado",
  seleccioneUnaFechaDeInicioYUnaFechaDeFin:
    "Selecione uma data de início e uma data de fim",

  // INFORMES
  inicio: "Início",
  informes: "Relatórios",
  productos: "Produtos",
  ventasPorNegocio: "Vendas por negócio",
  casas: "Casas",
  facturasSimplificadas: "Faturas simplificadas",
  comprasPorNegocio: "Compras por negócio",
  comprasPorCasas: "Compras por casas",
  gastosPorProveedor: "Despesas por fornecedor",
  gastosPorSubproductos: "Despesas por matérias-primas",
  sage: "SAGE",
  sageplancuentas: "Plano de Contas",
  sageclientes: "Clientes",
  sageefectos: "Efeitos",
  sageasientos: "Lançamento Contábil",

  //CASAS
  nuevaCasa: "Nova casa",
  casa: "Casa",
  negocio: "Negócio",
  desde: "Desde",
  hasta: "Até",
  consultar: "Consultar",
  infoCasas:
    "Este consumo de casas provém das despesas inseridas no intervalo de datas selecionado",
  exportarInforme: "Exportar relatório",
  exportarPdf: "Exportar como PDF",
  exportarExcel: "Exportar como Excel",
  exportarExcelSinSubproductos: "Exportar como Excel com matérias-primas",

  // TABLA
  fecha: "Data",
  subproductos: "Matérias-primas",
  subproducto: "Matéria-prima",
  unidades: "Unidades",
  partes: "Partes",
  precio: "Preço",
  total: "Total",
  infoConsumo:
    "Este consumo de casas provém das despesas inseridas no intervalo de datas selecionado",
  noHay: "Não há",
  gastos: "Despesas",
  rangoDeFechas: "neste intervalo de datas.",
  clickConsultarParaRealizarBusqueda: "Clique no botão Consultar para realizar a pesquisa",
  avisoDatosUltimaConsulta: "Estes dados são da última consulta realizada. Se alterou o negócio, TPV ou datas, clique em \"Consultar\" para os atualizar.",
  ultimaActualizacion: "Última atualização",
  negocioBloqueadoConsultasEnCurso: "Há consultas em curso. Aguarde que terminem para mudar de negócio.",
  configuracion: "Configuração",
  datosFiscales: "Dados fiscais",

  // DATOS FISCALES
  nombreFiscal: "Nome fiscal",

  // FORM CASA
  nombreCasa: "Nome da Casa",
  cifNif: "CIF / NIF",
  direccion: "Endereço",
  provincia: "Província",
  ciudad: "Cidade",
  codigoPostal: "Código postal",
  pais: "País",
  telefono: "Telefone",
  correoElectronico: "Email",
  iban: "IBAN",
  numeroRegistroSanitario: "Número de registro sanitário",
  baja: "Inativo",
  guardar: "Salvar",
  cancelar: "Cancelar",
  replicar: "Replicar em outros negócios",
  replicarCasa: "Replicar casa em outros negócios",
  seleccionarTodos: "Selecionar todos",
  aceptar: "Aceitar",
  casaMin: "casas",

  compras: "Compras",
  agregarCasa: "Adicionar Casa",
  email: "Email",
  acciones: "Ações",
  turnos: "Turnos",
  editar: "Editar",
  enEsteNegocio: " neste negócio.",

  // PLACEHOLDER
  introduzcaNombre: "Digite o nome",
  introduzcaCifNif: "Digite o CIF / NIF",
  introduzcaDireccion: "Digite o endereço",
  introduzcaProvincia: "Digite a província",
  introduzcaCiudad: "Digite a cidade",
  introduzcaCodigoPostal: "Digite o código postal",
  introduzcaTelefono: "Digite o telefone",
  introduzcaCorreo: "Digite o email",
  introduzcaIban: "Digite o IBAN",
  introduzcaNumeroRegistroSanitario: "Digite o número de registro sanitário",
  buscar: "Buscar...",

  // PROVEEDORES
  proveedores: "Fornecedores",
  agregarProveedor: "Adicionar Fornecedor",
  categoria: "Categoria",
  proveedoresMin: "fornecedores",

  // FORM
  nombreProveedor: "Nome do Fornecedor",
  acreedor: "Credor",
  infoAcreedor: "(Se um fornecedor for credor, não aparecerá no Numier TPV)",
  replicarProveedor: "Replicar fornecedor em outros negócios",
  category: "Categoria",
  replicarCategory: "Replicar etiqueta em outros negócios",

  // ETIQUETAS
  etiquetas: "Etiquetas",
  etiqueta: "Etiqueta",
  sinEtiqueta: "Sem etiqueta",
  nuevaEtiqueta: "Nova etiqueta",
  agregarEtiqueta: "Adicionar etiqueta",
  tipo: "Tipo",
  etiquetaPadre: "Etiqueta Pai",
  tipoPadre: "Tipo Pai",

  // FORM
  nombreEtiqueta: "Nome da Etiqueta",

  // SUBPRODUCTOS
  agregarSubproducto: "Adicionar Matéria-prima",
  precioCompra: "Preço de compra",
  escandallo: "Escandallo",
  subproductosCreados: "Matérias-primas criadas",
  nuevaCategoria: "Nova categoria",
  materiaPrima: "Matéria-prima",
  materiasPrimas: "Matérias-primas",

  // FORM
  nuevoProveedor: "Novo Fornecedor",
  nombreSubproducto: "Nome da Matéria-prima",
  codigoBarra: "Código de barras",
  descripcion: "Descrição",
  tipoIva: "Tipo I.V.A.",
  cuotaIVA: "Quota IVA",
  ivaIncluido: "(IVA incluído)",
  descuentoCompra: "Desconto de compra",
  porcentaje: "(% Porcentagem)",
  guardarEnAlmacen: "Salvar em armazém",
  stockMinimo: "Stock mínimo",
  stockOptimo: "Stock ótimo",
  gastosPorProveedoresUnidos: "Despesas por fornecedores unidos",
  caracteresRestantes: "Caracteres restantes",

  // INFORME SUBPRODUCTO
  referencia: "Referência",
  uds: "Uds",
  iva: "IVA",
  importe: "Importe",
  imp: "Imp.",
  sinDto: "SEM DESC.",
  importeConIva: "Importe com IVA",
  importeSinIva: "Importe sem IVA",
  importeSinIvaDto: "Importe sem IVA com Desc",
  precioUdSinIva: "Preço / unidade sem IVA",
  dto: "Desc",
  ttal: "Total",

  // PRODUCTOS
  producto: "Produto",
  precioDeCoste: "Preço de custo",
  tarifa1: "Tarifa 1",
  tarifa2: "Tarifa 2",
  tarifa3: "Tarifa 3",
  tarifa4: "Tarifa 4",
  agregarProductos: "Adicionar produto",
  noHayProductosEnEsteNegocio: "Não há produtos neste negócio",
  sinCategoria: "Sem Categoria",
  cliente: "Cliente",

  // FORM
  nombreProducto: "Nome do produto",
  codigoDeBarra: "Código de barras",
  colorBoton: "Cor do botão",
  descuento: "Desconto",
  precioCoste: "Preço de custo",
  opcionesAlSeleccionarElArticulo: "Opções ao selecionar o produto",
  numeroDeOpcionales: "Número de matérias-primas opcionais",
  impresoraComandasTPV: "Impressora Comandas TPV",
  impresoraComandasPDA: "Impressora Comandas PDA",
  copiaImpresoraComandasTPV: "Cópia Impressora Comandas TPV",
  copiaImpresoraComandasPDA: "Cópia Impressora Comandas PDA",
  impresionPlano: "Impressora Plano ",
  impresionPlanoKDS: "Impressora Plano KDS",
  copiaImpresionPlano: "Cópia Impressora Plano ",
  copiaImpresionPlanoKDS: "Cópia Impressora Plano KDS",
  impresionPlano1: "Impressora Plano 1",
  impresionPlano2: "Impressora Plano 2",
  impresionPlano3: "Impressora Plano 3",
  impresionKDSTPV: "Enviar comanda desde TPV",
  impresionKDSPDA: "Enviar comanda desde PDA",
  copiaImpresionKDSTPV: "Cópia comanda desde TPV",
  copiaImpresionKDSPDA: "Cópia comanda desde PDA",
  pedirPrecio: "Pedir Preço",
  pedirPeso: "Pedir peso",
  pedirImporte: "Pedir Importe",
  promocionable: "Promocionável",
  mostrarPC: "Mostrar no PC",
  mostrarPDA: "Mostrar no PDA",
  noImprimir: "Não imprimir",
  numeroPlato: "Número de prato por defeito",
  seleccionIngredientes: "Ativar seleção de ingredientes",
  introduzcaDescripcion: "Digite a descrição",
  introduzcaCodigoDeBarras: "Digite o código de barras",
  introduzcaPrecioCoste: "Digite o preço de custo",
  opcion1: "Opção 1",
  opcion2: "Opção 2",
  opcion3: "Opção 3",
  opcion4: "Opção 4",
  opcion5: "Opção 5",
  numOpcionales: "Número de matérias-primas opcionais",

  // OPERARARIOS
  operarios: "Operários",
  agregarOperario: "Adicionar operário",
  apellido: "Sobrenome",
  nombreOperarios: "Nome dos Operários",
  pass: "Senha",
  salario: "Salário",
  passTurn: "Senha de turno",
  hombre: "Homem",
  mujer: "Mulher",
  replicarProducto: "Replicar produto em outros negócios",
  introduzcaEscandallo: "Digite o escandallo",
  introduzcaStockMinimo: "Digite o stock mínimo",
  introduzcaStockOptimo: "Digite o stock ótimo",
  introduzcaPrecioCompra: "Digite o preço de compra",
  introduzcaApellido: "Digite o sobrenome",
  introduzcaPass: "Digite a senha",
  introduzcaEmail: "Digite o email",
  introduzcaSalario: "Digite o salário",
  introduzcapassTurn: "Digite a senha de turno",
  replicarOperario: "Replicar operário em outro negócio",
  TPV: "TPV",
  precioMed: "Preço Med.",
  precioMedSinIva: "Preço Med sem IVA",
  porUnidad: "Por unidades",
  porImporte: "Por valor",
  contrasenya: "Senha PDA",
  repartidor: "Entregador",
  buscaRepartidor: "buscarEntregador",
  noMostrarEnVentas: "Não mostrar em vendas",
  noHayOperariosEnEsteNegocio: "Não há operários neste negócio",
  VerDetalles: "Ver detalhes",
  codigoTurno: "Código do turno",
  operarioDatosIncompletos: "Todos os campos são obrigatórios",
  enviarQR: "Enviar QR de turnos",
  descargarTurnoQR: "Baixar PDF com QR de turnos",
  enviarEmailTurnoQR: "Enviar por email QR de turnos",
  emailEnviado: "O email foi enviado corretamente",
  enviado: "Enviado",
  errorActualizar: "Erro ao atualizar o operário",
  errorEnviarEmail: "Não foi possível enviar o email",
  accesoDenegado: "Acesso negado",
  noTienesPermisosParaRealizar: "Você não tem permissão para realizar esta ação",
  emailNoValido: "O email não possui formato válido",
  gestionTurnos: "Turnos por operário",
  gestionTurnosSubtitle:
    "Consulta e gestão dos registros de ponto dos operários",
  gestionTurnosSubtitleConsulta: "Consulta e gestão",
  gestionTurnosSubtitleDeLos: "dos",
  gestionTurnosSubtitleFichajes: "registros de ponto",
  gestionTurnosSubtitleOperarios: "dos operários",

  // CLIENTES
  clientes: "Clientes",
  companyia: "Campanha",
  agregarCliente: "Adicionar cliente",
  nombreCliente: "Nome do cliente",
  saldo: "Saldo",
  infoCliente: "No caso de utilização de cartões de saldo",
  tarifa: "Tarifa",
  descuentoImporte: "Desconto em valor",
  noHayClientesEnEsteNegocio: "Não há clientes neste negócio",
  barCode: "Código de barras",
  cuentaContableSocio: "Conta contábil Sócio",
  cuentaContableLevy: "Conta contábil Levy",

  // IMPRESION
  impresionDeComandas: "Impressão de comandas",
  copiaDeImpresionDeComandas: "Cópia de impressão de comandas",
  impresionPorPlana: "Impressão por plano",
  impresionPorKDS: "Impressão por KDS",
  monitorDeCocina: "Monitor de cozinha",

  // INFORMES
  ventas: "Vendas",
  tarjetas: "Cartões",
  cheque: "Cheque",
  cambio: "Troco",
  recuento: "Contagem",
  descuadre: "Diferença",
  siguienteDia: "Dia seguinte",
  incidencias: "Incidências",
  recaudado: "Arrecadado",
  noHayVentasEnEsteRangoDeFechas: "Não há vendas neste intervalo de datas",
  tickets: "Tickets",
  factura: "Fatura",
  noHayFormasDePagoEnEsteRangoDeFecha:
    "Não há formas de pagamento neste intervalo de datas",
  desglose: "Detalhamento",
  sinBase: "Sem base",
  base: "Base",
  baseTotal: "Base total",
  impuesto: "Imposto",
  facturasEmitidas: "Faturas nominativas",
  mesa: "Mesa",
  cifnif: "CIF/NIF",
  cobro: "Cobrança",
  noHayFacturasEmitidasEnEsteRangoDeFecha:
    "Não há faturas emitidas neste intervalo de datas",
  estadisticasAgencias: "Estatísticas de Agências",
  agencia: "Agência",
  comentario: "Coment.",
  noHayEstadisticasDeAgenciaEnEsteRangoDeFechas:
    "Não há estatísticas de agência neste intervalo de datas",
  desglosesImpuestos: "Impostos por fechamento de caixa",
  desglosesImpuestosAgencia: "Impostos por agência",
  noHayFormasDePagoEnEsteRangoDeFechas:
    "Não há formas de pagamento neste intervalo de datas",
  cuentasAparcadas: "Contas a crédito",
  operacion: "Operação",
  operario: "Operário",
  noExisteDesgloseImpuestos: "Não existe detalhamento de impostos.",
  noHayCuentasAparcadasEnEsteRangoDeFechas:
    "Não há contas a crédito neste intervalo de datas",
  noHayCuentasAnuladasEnEsteRangoDeFechas:
    "Não há contas canceladas neste intervalo de datas",
  cierreCaja: "Fechamento de caixa",
  fechaCierre: "Data de fechamento",
  venta: "Venda",
  totalRecaudado: "Total arrecadado",
  noHayCierresDeCajaEnEsteRangoDeFecha:
    "Não há fechamentos de caixa neste intervalo de datas",
  cierreCajaZ: "Fechamento de Caixa Z",

  // MODAL
  n: "Nº.",
  apertura: "Abertura",
  cierre: "Fechamento",
  totalVenta: "Total Venda",
  efectivo: "Dinheiro",
  tarjetaCheques: "Cartão+Cheques",
  totalTeorico: "Total teórico",
  totalEnArqueo: "Total em conferência",
  cambioSig: "Troco sig",
  volver: "Voltar",
  confirmacionImportacionHeader: "Confirmação de importação",
  confirmacionImportacionText: "Tem certeza de que deseja importar?",
  confirmar: "Confirmar",
  registros: "registros",
  headerError: "ERRO",
  bodyError: "Por favor, insira um arquivo com menos de 10.000 registros",
  en: "Em ",

  // OPERARIOS
  ventasPorOperarios: "Contas cobradas por operário",
  invitaciones: "Convites",
  horas: "Horas",
  sueldo: "Salário",
  categorias: "Categorias",

  // CLIENTES
  ventasPorClientes: "Vendas por cliente",
  companya: "Empresa",
  consumiciones: "Consumos",
  media: "Média",
  valorMedioDelTicket: "Valor médio do talão",
  todosLosClientes: "Todos os clientes",
  todosLosOperarios: "Todos os operadores",
  operariosAplicar: "Operadores aos quais será aplicado",
  rentabilidadInfo: "Preço médio menos o custo das matérias-primas (preço de custo do produto)",
  sinPrecioDeCoste: "Sem preço de custo: calcule-o em Ferramentas ou na ficha do produto",
  buscarCliente: "Pesquisar cliente por nome, código ou NIF…",
  clientesConVentasEnElPeriodo: "com vendas no período",
  noHayClientesConVentas: "Não há clientes com vendas no período",
  ningunClienteCoincide: "Nenhum cliente corresponde à pesquisa",
  seleccionados: "selecionados",
  clientesSeleccionados: "clientes selecionados",
  quitarFiltro: "Remover filtro",
  deLosClientes: "de {total} clientes",
  buscarOperario: "Pesquisar operador...",
  ninguno: "Nenhum",
  mas: "mais",
  ningunOperarioCoincide: "Não há operadores coincidentes",
  ningunOperario: "Nenhum operador",
  deOperarios: "de {total} operadores",
  eligeAlMenosUnOperario: "Escolha pelo menos um operador para aplicar as restrições",
  mediaSesion: "Média por sessão",

  // AGENCIAS
  noHayAgenciasEnEsteMomento: "Não há agências neste momento",
  agencias: "Agências",
  nombreAgencia: "Nome da agência",
  comision: "Comissão",
  replicarAgencias: "Replicar agência",
  agregarAgencias: "Adicionar agência",

  // MODIFICADORES
  nombreModificador: "Nome do modificador",
  grupos: "Grupos",
  variacion: "Variação",
  resta: "Subtração",
  suma: "Adição",
  modificador: "Modificador",
  modificadores: "Modificadores",
  agregarModificador: "Adicionar modificador",
  grupo: "Grupo",
  noHayModificadoresEnEsteNegocio: "Não há modificadores neste negócio",
  almacen: "Armazém",
  todos: "Todos",
  precioCompraConIva: "Preço de compra COM IVA",
  precioCompraSinIva: "Preço de compra SEM IVA",
  precioDescuentoSinIva: "Preço com desconto SEM IVA",
  codigoIdentificacion: "Código de identificação",
  replicarModificador: "Replicar modificador",

  // SOPORTE ONLINE
  soporteOnline: "Suporte Online",
  soporteOnlineDetails: "Suporte Online - Detalhes",
  abierto: "Aberto",
  esperandoRespuesta: "Aguardando resposta",
  respondido: "Respondido",
  cerrado: "Fechado",
  tecnico: "Técnico",
  comercial: "Comercial",
  facturacion: "Faturamento",
  noTicketsEnNegocio: "Não há tickets neste negócio",
  responderTicket: "Responder ticket",
  mensaje: "Mensagem",
  cerrar: "Fechar",
  enviarTicket: "Enviar Ticket",
  nuevoTicket: "Novo ticket",
  asunto: "Assunto",
  estado: "Estado",
  departamento: "Departamento",
  visitas: "Visitas",
  verTicket: "Ver ticket",
  tarjeta: "Cartão",

  // FORMAS DE PAGO
  nueva: "Nova",
  replicarFormaDePago: "Replicar Forma de pagamento",
  nombreFormaPago: "Nome forma de pagamento",
  formaDePago: "Forma de pagamento",
  formasDePago: "Formas de pagamento",
  agregarFormaDePago: "Adicionar forma de pagamento",
  noHayFormasDePagoEnEsteNegocio: "Não há formas de pagamento neste negócio",
  nuevo: "Novo",
  renovado: "Renovado",

  // EDICIÓN MASIVA
  transferirProductosDeCategoria: "Transferir produtos de categoria",
  tranferir: "Transferir",
  impresionDeProductosDeCategorias: "Impressão de produtos por categorias",
  impresoraComanda: "Impressora comanda",
  impresoraComandaTpv: "Impressora comanda TPV",
  impresoraComandaPda: "Impressora comanda PDA",
  copiaImpresionDeComanda: "Cópia de impressão de comandas",
  copiaImpresoraComandasTpv: "Cópia impressora comandas TPV",
  copiaImpresoraComandasPda: "Cópia impressora comandas PDA",
  impresionPorPlano: "Impressão por plano",
  enviarComandaDesdeTpv: "Enviar comanda do TPV",
  enviarComandaDesdePda: "Enviar comanda do PDA",
  respetarOtrasImpresiones: "Respeitar outras impressões?",
  cambioDePrecioProductos: "Alteração de preço de produtos",
  opcion: "Opção",
  tipoDeTarifa: "Tipo de tarifa",
  cambiarPrecio: "Alterar preço",
  ajustes: "Ajustes",
  cambiarImpresionDeGrupo: "Alterar impressão de grupo",
  tranferirProductosDeUnaCategoriaAOtra:
    "Transferir produtos de uma categoria para outra",
  cambiarPreciosAProductos: "Alterar preços de produtos",

  // WIDGETS
  consumoPorHoras: "Vendas por horas",
  productosMasVendidos: "Produtos mais vendidos",
  ultimosTickets: "Últimos tickets",
  verTodos: "Ver todos",
  arqueoDeCaja: "Conferência de caixa",
  cobrado: "Cobrado",

  cajaCerrada: "Caixa fechada",
  licenciaCaducada: "Licença expirada",
  cajonInteligente: "Gaveta inteligente",
  moneda: "Moeda",
  nivelReciclador: "Nível Recicl.",
  totalReciclador: "Total Recicl.",
  nivelCasete: "Nível Cassete",
  totalCasete: "Total Cassete",
  totalMonedas: "Total moedas",
  totalBilletes: "Total notas",
  totalEnDirectoPorNegocio: "Vendas em direto por negócios",
  enCuenta: "Em conta",
  cajaOnline: "Caixas Online",
  planoDeMesas: "Planta de mesas",
  planoDeTaquillas: "Planta de armários",
  nombrePlano: "Nome da planta",
  mesas: "Mesas",
  taquillas: "Armários",
  ocupacion: "Ocupação",
  enPlano: "Em planta",
  desgloseTicket: "Detalhamento do ticket",
  precioMedio: "Preço médio",
  apuntado: "Apontado",
  anulado: "Anulado",
  aparcado: "A crédito",
  indicencias: "Incidências",
  filtrarOperario: "Filtrar operário",
  situacionActualDeLosNivelesDelCajonInteligente:
    "Situação atual dos níveis da gaveta inteligente",
  verDetallesDeNiveles: "Ver detalhes dos níveis",
  noHayCajonInteligenteParaMostrar: "Não há gaveta inteligente para mostrar",
  consulteConSuDistribuidor: "Consulte seu distribuidor",
  comparativaVentasAnteriores: "Comparativo de vendas anteriores",
  graficaDeConsumoRespectoAHistoricoDeSesiones:
    "Gráfico de consumo em relação ao histórico de sessões",
  graficaDeConsumoAgrupadaPorTramosHorarios:
    "Gráfico de consumo agrupado por períodos horários",
  situacionActualDeOcupacionDeMesas: "Situação atual de ocupação das mesas",
  situacionActualDeOcupacionDeTaquillas:
    "Situação atual de ocupação dos armários",
  verPlanoCompleto: "Ver planta completa",
  rankingDeLaSesionActual: "Ranking da sessão atual",
  ultimosMovimientosDeLaCajaPorOperario:
    "Últimos movimentos da caixa por operário",
  estadoActualDeLaCaja: "Estado atual da caixa",
  turnosDeOperarios: "Turnos de operários",
  relacionDeHorasTrabajadasYVentasRealizadasPorOperario:
    "Relação de horas trabalhadas e vendas realizadas por operário",
  horarioInicio: "Hora início",
  horaFin: "Hora fim",
  horasTrabajadas: "Horas trabalhadas",
  noHayTurnosDeOperarioParaMostrar: "Não há turnos de operários para mostrar",
  propuestaDePedido: "Proposta de pedido",
  pedidoAProveedor: "Pedido ao fornecedor",
  atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio:
    "Atenção, há movimentos de armazém que não foram baixados no negócio",
  seleccionarNegocio: "Selecionar negócio",
  seleccionarProveedor: "Selecionar fornecedor",
  generarPedidoEnBlanco: "Gerar pedido em branco",
  generarPedido: "Gerar pedido",
  propuestaDePedidoA: "Proposta de pedido para ",
  buscarMateriaPrimaEnElMismoProveedor:
    "Buscar matéria-prima no mesmo fornecedor",
  precioIVAIncluido: "Preços com IVA incluído",
  ref: "Ref",
  nombre: "Nome",
  existencias: "Existências",
  pedido: "Pedido",
  precioArticuloUnidad: "Preço artigo / und",
  precioPedido: "Preço do pedido",
  sinIVA: "Sem IVA",
  porcentajeIVA: "% IVA",
  precioIVA: "Preço IVA",
  porcentajeDto: "% Desc.",
  totalIVA: "Total IVA",
  observaciones: "Observações",
  noHaySubproductosEnEsteNegocioParaRealizarElPedido:
    "Não há subprodutos neste negócio para realizar o pedido",
  recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo:
    "Lembre-se que para aparecerem, os subprodutos devem estar associados a um fornecedor e configurados o stock mínimo e ótimo",
  guardarPedido: "Salvar pedido",
  totalIVAInc: "Total IVA Inc.",
  pedidosAProveedor: "Pedido ao fornecedor",
  fechaInicio: "Data início",
  fechaFin: "Data fim",
  pedidosConvertidos: "Pedidos convertidos",
  nuevoPedido: "Novo pedido",
  enviarPedidos: "Enviar pedidos",
  convertido: "Convertido",
  convertirEnGasto: "Converter em gasto",
  modificar: "Modificar",
  eliminar: "Eliminar",
  descargarComoPDF: "Baixar como PDF",
  descargarComoPDFSinPrecios: "Baixar como PDF sem preços",
  descargarComoExcel: "Baixar como Excel",
  descargarComoExcelSinPrecios: "Baixar como Excel sem preços",
  enviarPorCorreo: "Enviar por email",
  eliminarListaCorreo: "Eliminar lista de emails",
  anyadirListaCorreo: "Adicionar lista de emails",
  noHayPedidosAEsteProveedorEnEsteRangoDeFecha:
    "Não há pedidos a este fornecedor neste intervalo de datas",
  enviarPedido: "Enviar pedido",
  enviarPedidoA: "Enviar pedido para",
  formato: "Formato",
  PDF: "PDF",
  excel: "Excel",
  conPrecios: "Com preços",
  sinPrecios: "Sem preços",
  convertirPedido: "Converter pedido",
  tipoDeDocumento: "Tipo de documento",
  albaran: "Alvará",
  generarEntradaEnAlmacenAlVerificar: "Gerar entrada no armazém ao verificar",
  gastosDeCasas: "Gastos de casas",
  gastosPorCasa: "Gastos por casa",
  noHayGastosPorCasasEnEsteRangoDeFechas:
    "Não há gastos por casas neste intervalo de datas",
  ventasDeCategorias: "Vendas por categorias",
  ventasCategoriaDe: "Vendas categoria de ",
  volverAGeneral: "Voltar ao geral",
  ventasDeProductos: "Vendas de produtos",
  filtrarPorTPV: "Filtrar por TPV",
  filtrarTPV: "Filtrar TPV",
  turnosDe: "Turnos de ",
  enActivo: "Em ativo",
  ventasDeProductosDe: "Produtos de contas cobradas por ",
  ignorarRecuentosNegativos: "Ignorar contagens negativas",
  ventasOperarios: "Contas cobradas",
  costesDeProductos: "Custos de produtos",
  totalImportesVentas: "Total Importes Vendas",
  totalCoste: "Total custo",
  costes: "Custos",
  costeUd: "Custo unidade",
  coste: "Custo",
  porcentajeCosto: "% Custo",
  varCostoMed: "Var. Custo Med.",
  listaDeInvitaciones: "Lista de convites",
  valor: "Valor",
  volverALaLista: "Voltar à lista",
  ventasDeProductosGlobal: "Vendas de produtos global",
  porUnidades: "Por unidades",
  gastosPorEtiquetas: "Gastos por etiquetas",
  desgloseDeGastos: "Detalhamento de gastos",
  referencias: "Referências",
  concepto: "Conceito",
  gastosDeProveedores: "Gastos de fornecedores",
  sinProveedor: "Sem fornecedor",
  sinCasas: "Sem casas",
  cierreDeCaja: "Fechamento de caixa",
  primerTicket: "Primeiro ticket",
  ultimoTicket: "Último ticket",
  cheques: "Cheques",
  cambioSigDia: "Troco sig. dia",
  ventasPorAgencias: "Vendas por agências",
  ventasPorFormasDePago: "Vendas por forma de pagamento",
  exportarComoHTML: "Exportar como HTML",
  pendiente: "Pendente",
  gasto: "Gasto",
  desgloseDeImpuestos: "Detalhamento de impostos",
  desgloseDelTicket: "Detalhamento do ticket",
  cuentasAnuladas: "Contas anuladas",
  buscarPorHoras: "Buscar por horas",
  buscarBaja: "Mostrar produtos descontinuados",
  buscarSubProductoBaja: "Mostrar matérias-primas descontinuadas",
  buscarCategoriasBaja: "Mostrar categorias descontinuadas",
  buscarEtiquetasBaja: "Mostrar etiquetas descontinuadas",
  mostrarClientesBaja: "Mostrar clientes inativos",
  deBaja: "inativos",
  mostrarVentasAcumuladasPorDia: "Mostrar vendas acumuladas por dia",
  seleccionaUnTpv: "Deve selecionar um TPV para ver os detalhes",
  deshabilitarCheckboxVentasAcumuladasPorDia:
    "Desabilitar o checkbox 'Mostrar vendas acumuladas por dia' para ver os detalhes.",
  graficas: "Gráficos",
  dias: "Dias",
  semanas: "Semanas",
  meses: "Meses",
  ventasPorComensales: "Vendas por clientes",
  numeroDeComensales: "Número de clientes",
  precioMedioPorComensal: "Preço médio por cliente",
  ventasPorRangosHorarios: "Vendas por períodos horários",
  ops: "Ops",
  comensales: "Clientes",
  detalleDeOperaciones: "Detalhe de operações",
  operaciones: "Operações",
  operacionMedia: "Operação média",
  detalleDeComensales: "Detalhe de clientes",
  comensalMedio: "Cliente médio",
  noHayVentasEnLosRangosDeFechasDefinidos:
    "Não há vendas nos intervalos de datas definidos",
  transferencia: "Transferência",
  domiciliacion: "Débito direto",
  fechaGasto: "Data do gasto",
  generarEntradaDeAlmacenAlVerificar: "Gerar entrada no armazém ao verificar",
  listaDeMateriaPrima: "Lista de matéria-prima",
  preciosIVAIncluido: "Preços com IVA incluído",
  precioSinIVA: "Preço sem IVA",
  precioIVAInc: "Preço IVA inc",
  IVA: "IVA",
  totalBase: "Total base",
  totalDocumento: "Total documento",
  seleccioneUnaCasa: "Selecione uma casa",
  anyadirNuevoSubproducto: "Adicionar novo subproduto",
  gestionDeGastos: "Gestão de gastos",
  deCaja: "De caixa",
  fueraDeCaja: "Fora de caixa",
  contabilizado: "Contabilizado",
  si: "Sim",
  no: "Não",
  grafica: "Gráfico",
  lista: "Lista",
  avanzado: "Avançado",
  noHayVentasDeProductosEnEsteRangoDeFechas:
    "Não há vendas de produtos neste intervalo de datas",
  historicoDeProductos: "Histórico de produtos",
  volverA: "Voltar a",
  general: "Geral",
  historialAlmacen: "Histórico de armazém",
  listadoDeExistencia: "Lista de existência",
  listadoDeAlmacen: "Lista de armazém",
  listadoHastaStockOptimo: "Lista até stock ótimo",
  listadoExistenciaBajoMinimo: "Lista de existência abaixo do mínimo",
  exportarValoracion: "Exportar avaliação",
  importeDto: "Valor Desconto",
  detalleDelSubproducto: "Detalhe do subproduto",
  nombreNegocio: "Nome do negócio",
  noHaySubproductosConElMismoNombreEnTusOtrosNegocios:
    "Não há subprodutos com o mesmo nome nos seus outros negócios",
  detalleAlmacen: "Detalhe do armazém",
  entrada: "Entrada",
  inventario: "Inventário",
  salida: "Saída",
  valorDto: "Valor Desc.",
  noHayDatosEnEsteMovimientoDeAlmacen:
    "Não há dados neste movimento de armazém",
  historial: "Histórico",
  noHayMovimientoEnEstaMateriaPrima: "Não há movimento nesta matéria-prima",
  dia: "Dia",
  historialDeAlmacen: "Histórico de armazém",
  inventarios: "Inventários",
  entradas: "Entradas",
  salidas: "Saídas",
  completado: "Concluído",
  verificado: "Verificado",
  descargado: "Baixado",
  diaActual: "Dia atual",
  movimientos: "Movimentos",
  enEsteRangoDeFechas: "neste intervalo de datas",
  rangosHorarios: "Intervalos horários",
  nuevoRangoHorario: "Novo intervalo horário",
  verUnInformeDeRangosHorarios: "Ver relatório de intervalos horários",
  noHayRangosHorariosEnEsteNegocio: "Não há intervalos horários neste negócio",
  nombreRangosHorarios: "Nome intervalos horários",
  vistaMosaico: "Vista mosaico",
  vistaLista: "Vista lista",
  ordenarProductos: "Ordenar produtos",
  BAJA: "DESCONTINUADO",
  frontalDeVenta: "Frontal de venda",
  agregarGasto: "Adicionar gasto",
  entrAlmac: "Entr. Armaz.",
  contab: "Contab",
  tranferencia: "Transferência",
  verificar: "Verificar",
  entradaAlmacen: "Entrada de armazém",
  preciosIVAInluido: "Preços com IVA incluído",
  estaEntradaNoContieneNingunSubproducto:
    "Esta entrada não contém nenhum subproduto",
  cajasOnline: "Caixas online",
  minimo: "Mínimo",
  optimo: "Ótimo",
  posicionGlobal: "Posição global",
  empresa: "Empresa",
  todasLasEmpresas: "Todas as Empresas",
  ventasSinIVA: "Vendas sem IVA",
  neto: "Líquido",
  fechaDeCumpleanyos: "Data de nascimento",
  recargoEquivalencia: "Sobretaxa equivalência",
  anyadirMateriaPrima: "Adicionar matéria-prima",
  partesT1: "Partes T1",
  partesT2: "Partes T2",
  partesT3: "Partes T3",
  partesT4: "Partes T4",
  costeDto: "Custo Desc.",
  agregarMateriasPrimas: "Adicionar matérias-primas",
  frontalDeVentas: "Frontal de vendas",
  unidadesEnOtroNegocios: "Unidades em outros negócios",
  historialMateriaPrima: "Histórico matéria-prima",

  borrarRangoHorario: "Excluir intervalo horário",
  detallesDeLaEntradaEnAlmacen: "Detalhes da entrada no armazém",
  desgloseHorasTrabajadas: "Detalhamento horas trabalhadas",
  verProductosVendidos: "Ver produtos vendidos",
  verTicketsDelProducto: "Ver tickets do produto",
  verTicketsDeEsasInvitaciones: "Ver tickets desses convites",
  verTicketsDeEsaAgencia: "Ver tickets dessa agência",
  gastosPorMateriasPrimas: "Gastos por matérias-primas",
  alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta:
    "Ao descontinuar um produto ele desaparece no TPV para venda, mas continua nos relatórios de venda",
  cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta:
    "Quando um produto é do tipo desconto, seu preço é descontado do total da conta",
  alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo:
    "Ao ativar esta opção, os ingredientes do produto aparecem para seleção",
  alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo:
    "Ao ativar esta opção, pode selecionar o preço do produto ao marcá-lo",
  alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo:
    "Ao ativar esta opção, pode selecionar o peso do produto ao marcá-lo",
  alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo:
    "Ao ativar esta opção, pode selecionar o valor do produto ao marcá-lo",
  alActivarEstaOpcionElProductoNoApareceraEnNumierTPV:
    "Ao ativar esta opção, o produto não aparecerá no Numier TPV",
  alActivarEstaOpcionElProductoNoApareceraEnLaPda:
    "Ao ativar esta opção, o produto não aparecerá no Numier PDA",
  alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada:
    "Ao ativar esta opção, o produto não será impresso no pendente de cobrança nem na fatura simplificada",
  guardarMateriaPrima: "Salvar matéria-prima",
  copiarMateriaPrima: "Copiar matéria-prima",
  seleccioneQueTipoDeMateriasPrimasQuiereCopiar:
    "Selecione que tipo de matérias-primas deseja copiar",
  seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas:
    "Selecione para qual categoria deseja copiar as matérias-primas",
  copiaMateriaPrima: "Cópia matéria-prima",
  notas: "Notas",
  pedidos: "Pedidos",
  atencionLaMediaSinContarLosDiasConVentas:
    "Atenção: A média sem contar os dias com vendas a 0€ é de: ",
  verDesgloseDeImpuestos: "Ver detalhamento de impostos",
  verDetallesDetTicket: "Ver detalhes do ticket",
  facturasNominativas: "Faturas nominativas",
  verDetallesDeGasto: "Ver detalhes do gasto",
  desgloseDeGastosPorEtiquetasHijas:
    "Detalhamento de gastos por etiquetas filhas",
  procedencia: "Procedência",
  suLicenciaDeNumierOnlineEstaAPuntoDeCaducar:
    "Sua licença Numier Online está prestes a expirar",
  cajasOnlineTickets: "Caixas Online Tickets",
  cajasOnlineDetalles: "Caixas Online Detalhes",
  cajasOnlinePlano: "Caixas Online Planta",
  cajasOnlineProductos: "Caixas Online Produtos",
  transferir: "Transferir",
  herramientas: "Ferramentas",
  ver: "Ver",
  detallesDeLaentradaEnAlmacen: "Detalhes da entrada no armazém",
  ups: "Ops",
  laFechaDeInicioNoPuedeSerPosteriorALaDeFin:
    "A data de início não pode ser posterior à data de fim",
  exportarContabilidad: "Exportar contabilidade",

  seleccioneUnProveedor: "Selecione um fornecedor",
  detallesDelPedido: "Detalhes do pedido",
  correoEnviadoCorrectamente: "Email enviado corretamente",
  atencion: "Atenção",
  debeIntroducirUnEmailParaEnviarElPedido:
    "Deve inserir um email para enviar o pedido",
  detalles: "Detalhes",
  gastoVerificadoCorrectamente: "Gasto verificado corretamente",
  estasSeguroDeEliminarElPedido: "Tem certeza de que deseja excluir o pedido?",

  // BUSINESS CENTRAL - MATERIAS PRIMAS
  noSeEncontraronMateriasPrimas: "Nenhuma matéria-prima encontrada",
  noSeEncontraronProductos: "Nenhuma produto encontrada",
  seleccionar: "Selecionar",
  estado: "Estado",
  noDisponible: "Não disponível",
  downgradedProducts: "Produtos descontinuados",
  unknownProduct: "Produto desconhecido",
  affectedRecipes: "Receitas afetadas",
  noRecipesAffected: "Nenhuma receita afetada",
  detalle: "Detalhe",
  noHayBajasQueMostrar: "Não há baixas para mostrar",
  resumenBajas: "Resumo de baixas",
  eliminado: "Eliminado",
  consultarTodo: "Consultar tudo",
  desplegar: "Exibir informações",
  estaOperacionNoSePuedeDeshacer: "Esta operação não pode ser desfeita",
  siEliminarPedido: "Sim, excluir pedido",
  pedidoEliminadoCorrectamente: "Pedido excluído corretamente",
  laReferenciaEsObligatoria: "A referência é obrigatória",
  seleccioneLosNegociosParaHacerelPedido:
    "Selecione os negócios para fazer o pedido",
  noTienesNingunNegocioAsignado: "Você não tem nenhum negócio atribuído",
  noHayProveedoresEnEsteNegocio: "Não há fornecedores neste negócio",
  cuentasRectificadas: "Faturas retificativas",
  noHayCuentasRectificadasEnEsteRangoDeFechas:
    "Não há faturas retificativas neste intervalo de datas",
  pedidosProveedor: "Pedidos fornecedor",
  gestionDePersonal: "Gestão de pessoal",
  configuracionCarta: "Configuração do cardápio",
  importacionExcels: "Importação de Excels",
  carta: "Cardápio digital",
  camaras: "Câmeras",
  perfil: "Perfil",
  cerrarSesion: "Sair",
  desarrolladoPorNexodoDigitalSL: "Desenvolvido por Nexodo Digital S.L.",
  totalValores: "Total valores",
  totalValoresDto: "Total valores Desc.",
  totalValoresRecuento: "Total valores do recenseamento",
  ultimoInventario: "Último inventário",
  filtrarEntreInventarios: "Filtrar entre inventários",
  ultInventario: "Últ. inventário",
  primerInventario: "Primeiro inventário",
  marcaDosInventariosParaVerLosDetallesEntreEllos:
    "Marque dois inventários para ver detalhes entre eles",
  salir: "Sair",
  anadirMovimientoAlmacen: "Adicionar movimento de armazém",
  nuevoInventario: "Novo inventário",
  tienesUnInventarioSinTerminarElDia:
    "Você tem um inventário sem finalizar o dia",
  pulseElBotonRealizarInventarioPara:
    "Pressione o botão 'Realizar inventário' para",
  volverARealizarlo: "refazê-lo",
  siDeseas: "Se desejar",
  comenzarElInventarioDeNuevo: "começar o inventário novamente",
  comaMarqueLaCasillaEliminarDatosDeInventarioActual:
    ", marque a caixa 'Excluir dados do inventário atual'",
  eliminarDatosDelInventarioActual: "Excluir dados do inventário atual",
  realizarInventario: "Realizar inventário",
  accesoDenegado: "Acesso negado",
  soloPuedeComprobar2InventariosAlMismoTiempo:
    "Só pode verificar 2 inventários ao mesmo tempo",
  cargando: "Carregando...",
  configuracionAlmacen: "Configuração do armazém",
  actualizada: "atualizada",
  correctamente: "corretamente",
  noSeAdmitenCamposEnBlanco: "Não são permitidos campos em branco",
  todas: "Todas",
  categoriaClientes: "Categoria de clientes",
  seleccionaCompania: "Selecione companhia",
  agregarCategoriaDeClientes: "Adicionar categoria de clientes",
  categoriaPadre: "Categoria pai",
  elCampoNombreFiscalEsObligatorio: "O campo nome fiscal é obrigatório",
  elCampoCifNifEsObligatorio: "O campo Cif Nif é obrigatório",
  datosActualizados: "Dados atualizados corretamente",
  elCampoNombreEsRequerido: "O campo nome é obrigatório",
  creada: "criada",
  rangoHorario: "Intervalo de horário ",
  soloPuedeCrearUnMaximoDeXRangosHorarios:
    "Só é possível criar no máximo 12 intervalos de horário",
  deAcuerdo: "De acordo",
  eliminado: "eliminado",
  deseaEliminarEsteRangoHorario: "Deseja eliminar este intervalo de horário",
  siBorrarRangoHorario: "Sim, apagar intervalo de horário",
  ordenarProductosAlfabeticamente: "Ordenar produtos alfabeticamente",
  ordenarMateriasPrimasAlfabeticamente:
    "Ordenar matérias-primas alfabeticamente",
  asignarImpresorasSeleccionadasEnBlanco:
    "Atribuir impressoras selecionadas em branco",
  aplicarCambios: "Aplicar alterações",
  ordenarAlfabeticamenteProductos: "Ordenar produtos alfabeticamente",
  ordenar: "Ordenar",
  ordenarAlfabeticamenteSubproductos: "Ordenar subprodutos alfabeticamente",
  seleccioneElTipo: "Selecione o tipo",
  impresionDeProductosEfectuadaCorrectamente:
    "Impressão de produtos realizada com sucesso",
  tienesQueSeleccionarUnaCategoria: "Você precisa selecionar uma categoria",
  ningunaSeleccionada: "Nenhuma selecionada",
  transferenciaDeProductosEfectuadaCorrectamente:
    "Transferência de produtos realizada com sucesso",
  relleneLosCamposObligatorios: "Preencha os campos obrigatórios",
  vistaFrontalTpv: "Vista frontal TPV",
  editarPrecios: "Editar preços",
  cancelarEdicion: "Cancelar edição",
  guardarOrden: "Salvar ordem",
  bajaConBrackets: "[BAIXA]",
  seleccionaUnaCategoria: "Selecione uma categoria...",
  cambiarImpresorasAProductos: "Alterar impressoras dos produtos",
  igualar: "Igualar",
  sumar: "Somar",
  restar: "Subtrair",
  multiplicar: "Multiplicar",
  todasLasTarifas: "Todas as tarifas",
  productosEditadosCorrectamente: "Produtos editados corretamente",
  ordenActualizadoCorrectamente: "Ordem atualizada corretamente",
  componentesDeVenta: "Componentes de venda",
  delNegocioAClientes: "do negócio para clientes",
  clasificacionDe: "Classificação de",
  productosPorFamilia: "produtos por família",
  elementosQue: "Elementos que",
  varianALosProductos: "variam nos produtos",
  paraLaComanda: "para o pedido",
  componentesComprados: "Componentes comprados",
  aProveedoresQueComponenProductos: "a fornecedores que compõem produtos",
  empresas: "Empresas",
  proveedorasDeMateriasPrimasYServicios:
    "fornecedoras de matérias-primas e/ou serviços",
  alNegocio: "ao negócio",
  fabricantesDeMateriasPrimas: "fabricantes de matérias-primas",
  aProveedores: "a fornecedores",
  categoriasQueClasifican: "Categorias que classificam",
  materiasPrimasYProveedores: "matérias-primas e fornecedores",
  personalCon: "Pessoal com",
  acceso: "acesso",
  alSistema: "ao sistema",
  baseDeDatosDe: "Base de dados de",
  consumidores: "consumidores",
  enElNegocio: "no negócio",
  clasificacionDeLa: "Classificação da",
  deLasVentas: "das vendas",
  metodosDeCobro: "Métodos de cobrança",
  enElFrontalDeVenta: "no frontal de venda",
  intervaloDeHorasParaConsultarVentas:
    "Intervalo de horas para consultar vendas",
  configurarAlmacén: "Configurar armazém",
  relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen:
    "Relação de matérias-primas para configuração do armazém",
  herramientasGenerales: "Ferramentas gerais",
  edicionMasiva: "Edição em massa",
  categoriasCarta: "Categorias do cardápio",
  categoriaCarta: "categoria do cardápio",
  orden: "Ordem",
  editada: "editada",
  anadirCategoria: "Adicionar categoria",
  esteNegocioNoTieneAccesoAEsteModulo:
    "Este negócio não tem acesso a este módulo",
  paraMasInformacionContacteConSu:
    "Para mais informações, entre em contato com seu",
  distribuidor: "distribuidor",
  formasDePagoCarta: "Formas de pagamento do cardápio",
  formaDePagoCarta: "forma de pagamento do cardápio",
  informacionCarta: "Informações do cardápio",
  datosDelNegocio: "Dados do negócio",
  nombreMostrado: "Nome exibido",
  telefonoWhatsapp: "Telefone WhatsApp",
  datosPedidos: "Dados dos pedidos",
  tiempoMedioDePreparacionRecogidaMin:
    "Tempo médio de preparação para retirada (min)",
  tiempoMedioDePreparacionDomicilioMin:
    "Tempo médio de preparação para entrega (min)",
  gastosDeEnvio: "Custos de envio",
  pedidoMinimo: "Pedido mínimo",
  interfaz: "Interface",
  textoEntrega: "Texto de entrega",
  textoPresentacion: "Texto de apresentação",
  textoFormasDePago: "Texto sobre formas de pagamento",
  textoHorarios: "Texto de horários",
  datosGuardadosCorrectamente: "Dados salvos corretamente",
  materiasPrimasCarta: "Matérias-primas do cardápio",
  materiaPrimaCarta: "matéria-prima do cardápio",
  referenciaMateriasPrimasTpv: "Referência de matérias-primas no TPV",
  nombreDeLaMateriaPrimaEnElTpv: "Nome da matéria-prima no TPV",
  disponible: "Disponível",
  replicarMateriaPrima: "Replicar matéria-prima",
  replicarMateriasPrimas: "Replicar matérias-primas",
  nombreTpv: "Nome TPV",
  noDisponible: "Não disponível",
  replicarTodasLasMateriasPrimas: "Replicar todas as matérias-primas",
  estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados:
    "Tem certeza de replicar todas as matérias-primas para os negócios selecionados?",
  estaAccionNoSePuedeDeshacer: "Esta ação não pode ser desfeita!",
  siReplicar: "Sim, replicar",
  productosCarta: "Produtos do cardápio",
  productoCarta: "produto do cardápio",
  referenciaProductoTpv: "Referência do produto no TPV",
  nombreDelProductoEnElTpv: "Nome do produto no TPV",
  seleccionaCategoria: "Selecione categoria",
  edicionRapida: "Edição rápida",
  supraCategoria: "SupraCategoria",
  supraCategoriaObligatoria: "Deves selecionar uma SupraCategoria para poder guardar este produto.",
  seleccionaTipo: "Selecione tipo",
  nIngredientesSinCosto: "Nº de ingredientes sem custo",
  maximoExtras: "Máximo de extras",
  alergenos: "Alérgenos",
  nombreTarifa1: "Nome tarifa 1",
  precioTarifa1: "Preço tarifa 1",
  nombreTarifa2: "Nome tarifa 2",
  precioTarifa2: "Preço tarifa 2",
  nombreTarifa3: "Nome tarifa 3",
  precioTarifa3: "Preço tarifa 3",
  nombreTarifa4: "Nome tarifa 4",
  precioTarifa4: "Preço tarifa 4",
  imagen: "Imagem",
  copiarMateriasPrimas: "Copiar matérias-primas",
  basico: "Básico",
  buscarNombreDeLaMateriaPrima: "Buscar nome da matéria-prima",
  seleccionaTipoPunto: "Selecione tipo...",
  bases: "Bases",
  opcionales: "Opcionais",
  extras: "Extras",
  cereales: "Cereais",
  crustaceos: "Crustáceos",
  huevos: "Ovos",
  pescado: "Peixe",
  cacahuetes: "Amendoins",
  soja: "Soja",
  leche: "Leite",
  frutosDeCascara: "Frutos de casca",
  apio: "Aipo",
  mostaza: "Mostarda",
  granosDeSesamo: "Grãos de sésamo",
  dioxidoDeAzufre: "Dióxido de enxofre",
  altramuces: "Tremoços",
  moluscos: "Moluscos",
  cartaASecas: "Cardápio",
  extra: "Extra",
  opcional: "Opcional",

  estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos:
    "Este processo apagará as matérias-primas atuais nas categorias selecionadas dos tipos escolhidos",
  aceptarProceso: "Aceitar processo",
  necesitasMarcarAlMenosUnTipoYUnaCategoria:
    "Você precisa marcar pelo menos um tipo e uma categoria",
  materiaPrimaCopiadaCorrectamente: "Matéria-prima copiada corretamente",
  editado: "editado",
  agregada: "adicionada",
  relacion: "Relação",
  noPuedeHaberDosMateriasPrimasConElMismoTipo:
    "Não pode haver duas matérias-primas com o mesmo tipo",
  estasSeguroDeBorrarLaMateriaPrima: "Tem certeza de apagar a matéria-prima?",
  siDeseoBorrarlo: "Sim, desejo apagar",
  seleccionaUnaCarta: "Selecione um cardápio",
  replicarProductos: "Replicar produtos",
  verCarta: "Ver cardápio",
  verPedido: "Ver pedido",
  verQR: "Ver QR",
  nombreEnTpv: "Nome no TPV",
  cartaYPedido: "Cardápio e pedido",
  replicarTodosLosProductos: "Replicar todos os produtos",
  editarImagen: "Editar imagem",
  esteNegocioNoContieneNingunaCarta: "Este negócio não contém nenhum cardápio",
  estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados:
    "Tem certeza de replicar todos os produtos para os negócios selecionados?",
  sustanciasQue: "Substâncias que",
  componenALosProductos: "compõem os produtos",
  informacionAcercaDel: "Informações sobre",
  negocioMinuscula: "negócio",
  actualizarPedidos: "Atualizar pedidos",
  pendienteDeConfirmacion: "Pendente de confirmação",
  confirmados: "Confirmados",
  enPreparacion: "Em preparação",
  finalizados: "Finalizados",
  recogida: "Retirada",
  domicilio: "Entrega",
  noHayPedidosPendientesDeConfirmacion:
    "Não há pedidos pendentes de confirmação",
  noHayPedidosConfirmados: "Não há pedidos confirmados",
  noHayPedidosEnPreparacion: "Não há pedidos em preparação",
  noHayPedidosTerminados: "Não há pedidos finalizados",
  siBorrarPedido: "Sim, apagar pedido",
  estasSeguroDeSuspenderElServicioEnMesas:
    "Tem certeza de suspender o serviço nas mesas?",
  siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo:
    "Se suspender o serviço nas mesas, não entrarão mais pedidos até reativá-lo",
  siSuspenderElServicioEnMesa: "Sim, suspender o serviço nas mesas",
  estasSeguroDeActivarElServicioEnMesas:
    "Tem certeza de ativar o serviço nas mesas?",
  siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa:
    "Se ativar o serviço, voltarão a entrar pedidos nas mesas",
  siActivarElServicioEnMesa: "Sim, ativar o serviço nas mesas",
  estasSeguroDeSuspenderElServicio: "Tem certeza de suspender o serviço?",
  siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo:
    "Se suspender o serviço, não entrarão mais pedidos até reativá-lo",
  siSuspenderElServicio: "Sim, suspender o serviço",
  estasSeguroDeActivarElServicio: "Tem certeza de ativar o serviço?",
  siActivaElServicioVolveranAEntrarPedidos:
    "Se ativar o serviço, os pedidos voltarão a entrar",
  siActivarElServicio: "Sim, ativar o serviço",
  pedidoAceptadoCorrectamente: "Pedido aceito corretamente",
  pedidoEnPreparacion: "Pedido em preparação",
  pedidoFinalizado: "Pedido finalizado",
  pedidoArchivado: "Pedido arquivado",
  servicioActualizadoCorrectamente: "Serviço atualizado corretamente",
  estasSeguroDeEditarLaObservacion: "Tem certeza de editar a observação?",
  siEditarObservacion: "Sim, editar observação",
  mesasActivadas: "MESAS⠀ATIVADAS⠀",
  mesasDesactivadas: "MESAS⠀DESATIVADAS⠀",
  crearNuevoProveedor: "Criar novo fornecedor",
  crearMateriaPrima: "Criar matéria-prima",
  eliminarMateriaPrima: "Eliminar matéria-prima",
  sinCasaAsignada: "Sem casa atribuída",
  buscarPorRefONombreDeLaMateriaPrima:
    "Buscar por Ref. ou Nome da matéria-prima",
  mensajePorcentajeCompraDisminuido:
    "O preço diminuiu em relação à porcentagem de compra estabelecida",

  seleccioneEtiqueta: "Selecione etiqueta...",
  unidadesStockMinimo: "Unidades estoque mínimo",
  partesStockMinimo: "Partes estoque mínimo",
  anadirProveedor: "Adicionar fornecedor",
  amarillo: "amarelo",
  cajas: "Caixas",
  botellas: "Garrafa(s)",
  barriles: "Barris",
  palets: "Paletes",
  bolsas: "Sacos",
  litros: "Litros",
  rollos: "Rolos",
  visualizar: "Visualizar",
  sinCasa: "Sem casa",
  elProveedorEsObligatorio: "O fornecedor é obrigatório",
  laFechaEsObligatoria: "A data é obrigatória",
  hayUnaMateriaPrimaSinUnidades: "Há uma matéria-prima sem unidades",
  hayUnaMateriaPrimaSinPrecio: "Há uma matéria-prima sem preço",
  guardandoGasto: "Salvando gasto...",
  actualizado: "atualizado",
  creado: "criado",
  laLongitudDelNombreNoPuedeSerMayorDe:
    "O comprimento do nome não pode ser maior que ",
  relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar:
    "Preencha todos os dados marcados com * antes de enviar",
  seleccionaProveedor: "Selecione fornecedor...",
  filtrarPorFecha: "Filtrar por data",
  convertirAlbaranes: "Converter notas de entrega",
  cancelarConversion: "Cancelar conversão",
  convertir: "Converter",
  convertirAlbaranEnFactura: "Converter nota de entrega em fatura",
  refFactura: "Ref. fatura",
  albaranesDeLaFactura: "Notas de entrega da fatura",
  finalizada: "finalizada",
  conversion: "Conversão",
  error: "Erro",
  estaSeguroDeVerificarEsteGasto: "Tem certeza de verificar este gasto?",
  siVerficarGasto: "Sim, verificar gasto",
  estasSeguroDeEliminarElGasto: "Tem certeza de eliminar o gasto?",
  siEliminarGasto: "Sim, eliminar gasto",
  contabilizadoCambiadoCorrectamente: "Contabilizado alterado corretamente",
  gastoEliminadoCorrectamente: "Gasto eliminado corretamente",
  hacerInventario: "Fazer inventário",
  seleccionarTodas: "Selecionar todas",
  inventarioRealizadoCorrectamente: "Inventário realizado corretamente",
  traspaso: "Transferência",
  negocioDeDestino: "Negócio de destino",
  referenciaNecesaria: "Referência necessária",
  elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos:
    "O movimento de estoque deve ter um produto ou produtos atribuídos",
  realizado: "realizado",
  enviarInventario: "Enviar inventário",
  volverAlAlmacen: "Voltar ao estoque",
  inventarioCompletado: "Inventário completado",
  inventarioNoEncontrado: "Inventário não encontrado",
  cargandoInventario: "Carregando inventário",
  inventarioExcluidosTitulo: "Há matérias-primas que não são contabilizadas neste inventário",
  inventarioExcluidosTexto: "O seu código está repetido, por isso não é possível saber a que matéria-prima corresponde a quantidade. Não aparecerão para contar até o código ser corrigido.",
  inventarioExcluidoCodigoCompartido: "O código {codigo} é partilhado por {total} matérias-primas ativas.",
  inventarioExcluidoLineaDuplicada: "O código {codigo} aparece {total} vezes neste inventário.",
  importacion: "Importação",
  importar: "Importar",
  tienesQueSeleccionarUnArchivoDeImportacion:
    "Você precisa selecionar um arquivo de importação",
  importandoVentasDelNegocio: "Importando vendas do negócio...",
  nuevosProductos: "Novos produtos",
  seHanCreadoLosSiguientesProductos: "Os seguintes produtos foram criados",
  importandoMovimientosDeAlmacen: "Importando movimentos de estoque...",

  seleccionaCasa: "Selecione casa...",
  desgloseDeVentasPorProductos: "Detalhamento de vendas por produtos",
  noTienesPermisoParaVisualizarEsteInforme:
    "Você não tem permissão para visualizar este relatório",
  historicoVentasPorCliente: "Histórico de vendas por cliente",
  buscarPorNombreDelCliente: "Buscar por nome do cliente",
  importeSinDto: "Valor sem desconto",
  seleccioneUnClienteValido: "Selecione um cliente válido",
  seleccioneUnNegocioParaVerLosTickets:
    "Selecione um negócio para ver os tickets",
  ventasDeCategoriasPorClientes: "Vendas de categorias por clientes",
  desgloseDeVentasDeLaCategoria: "Detalhamento de vendas da categoria",
  verImporteEnCategoriasHijas: "Ver valor em categorias filhas",
  gestionDePedidos: "Gestão de pedidos",
  cargandoGastos: "Carregando gastos...",
  cargandoDatos: "Carregando Dados",
  tiempoMedioCocina: "Tempo médio cozinha",
  nComandas: "Nº de comandas",
  eliminada: "eliminada",
  tiempoMedio: "Tempo médio",
  noHayComandasEnviadasAlKdsEnEsteRangoDeFechas:
    "Não há comandas enviadas ao KDS neste intervalo de datas",
  tiempoMedioProducto: "Tempo médio por produto",
  nProductos: "Nº de produtos",
  informePersonalizado: "Relatório personalizado",
  nombreDelDispositivo: "Nome do dispositivo",
  dispositivo: "Dispositivo",
  registrosHorarios: "Registros horários",
  marshallEjecutadoCorrectamente: "Marshall executado corretamente",
  mes: "Mês",
  seleccionaUnaSemana: "Selecione uma semana",
  seleccioneUnaFechaValida: "Selecione uma data válida",
  noMayuscula: "NÃO",
  siMayuscula: "SIM",
  editarObservacion: "Editar observação",
  anadirObservacion: "Adicionar observação",
  editarHoraInicioYHoraFin: "Editar hora início e hora fim",
  verLocalizacionEnMapa: "Ver localização no mapa",
  noSeHaEncontradoLocalizacion: "Localização não encontrada",
  inicioJornada: "Jornada iniciada",
  finJornada: "Jornada finalizada",
  geolocalizacionJornada: "Geolocalização da jornada",
  editarHorario: "Editar horário",
  editarHorarioDeTurno: "Editar horário de turno",
  observacion: "Observação",
  turnosOperarios: "Turnos de operários",
  compartirEnlaceTurnos: "Compartilhar link de turnos",
  hazClicConsultar: "Clique no botão Consultar para realizar a pesquisa.",
  calculo: "Cálculo",
  alMinuto: "Por minuto",
  redondear: "Arredondar",
  alSegundo: "Por segundo",
  horaCompleta: "Hora completa",
  haciaArriba30m: "Para cima (30m)",
  haciaArriba45m: "Para cima (45m)",
  verInfoCalculos: "Ver informação de cálculos",
  infoCalculoTurnosTitulo: "Informação sobre o Cálculo de Turnos",
  infoCalculoIntroP1: "O sistema permite calcular o tempo e o salário de três formas. Quando se aplica um arredondamento,",
  infoCalculoIntroDestacado: "o tempo real trabalhado aparecerá sempre entre parênteses e em cinza",
  infoCalculoAlMinutoTitulo: "1. Por minuto",
  infoCalculoAlMinutoDesc: "Descarta os segundos. Se um operário trabalha 1h 30m 45s, contabiliza como",
  infoCalculoAlMinutoSueldo: "O salário é calculado exatamente sobre esses minutos.",
  infoCalculoRedondearTitulo: "2. Arredondar",
  infoCalculoRedondearDesc: "Ajusta o tempo de acordo com a regra selecionada:",
  infoCalculoHoraCompletaDesc: "Não conta os minutos. Se trabalha 1h 55m, paga-se",
  infoCalculoHaciaArribaDesc: "Se os minutos ultrapassam o limiar, arredonda para a hora seguinte.",
  infoCalculoRedondearNota: "* O salário será calculado sobre este tempo já arredondado.",
  infoCalculoAlSegundoTitulo: "3. Por segundo",
  infoCalculoAlSegundoDesc1: "Máxima precisão. Contabiliza o tempo exato (ex.",
  infoCalculoAlSegundoDesc2: ") e o salário inclui até o último cêntimo gerado por esses segundos.",
  enlaceGeneradoExito: "Link gerado corretamente",
  enlaceCopiadoAlPortapapeles: "Link copiado para a área de transferência",
  enlaceExternoTurnosTitle: "Link externo para consulta de turnos",
  enlaceExternoTurnosLabel:
    "Através deste link você poderá consultar os turnos dos operários. Expirará em 24 horas.",
  errorComunicacionBackend: "Erro de comunicação com o servidor.",
  errorNoSeHaPodidoGenerarElEnlace:
    "Desculpe, não foi possível gerar o link, tente novamente",
  enlaceExternoTurnosOperariosTitle: "Turnos de operários de ",
  enlaceExternoTurnosCaducadoTitle: "O link expirou",
  enlaceExternoTurnosCaducadoLabel:
    "Para consultar os turnos dos operários, entre em contato com o administrador do negócio para gerar um novo link.",
  ventasDeProductosMinusculas: "vendas de produtos",
  pedidosGuionPasarelaDePago: "Pedidos - Gateway de Pagamento",
  numPedidos: "Núm. Pedidos",
  costoPorPedido: "Custo por pedido",
  totalComisiones: "Total Comissões",
  totalSinComisiones: "Total sem comissões",
  errorEnLaPeticion: "Erro na requisição",
  rentabilidad: "Rentabilidade",
  buscarPorNombreDelRepartidor: "Buscar por nome do entregador",
  verDesgloseDeTarifas: "Ver detalhamento de tarifas",
  ventasPorMeses: "Vendas por meses",
  ventasHoras: "Vendas por horas",
  ventasPorHorasYMesas: "Vendas por horas e mesas",
  tarifasDelProducto: "Tarifas do produto",
  cantidad: "Quantidade",
  fechaDesde: "Data desde",
  fechaHasta: "Data até",
  seleccionaProcedencia: "Selecione procedência...",
  verDesgloseFacturas: "Ver detalhamento de faturas",
  verDesgloseMateriasPrimas: "Ver detalhamento de matérias-primas",
  seleccionaUnaEtiqueta: "Selecione uma etiqueta",
  buscarPorNombreDeLaMateriaPrima: "Buscar por nome da matéria-prima",
  ventasDeMateriasPrimas: "Vendas de matérias-primas",
  seleccionaTpv: "Selecione TPV...",
  deVentas: "de vendas",
  totalComision: "Total comissão",
  totalSinComision: "Total sem comissão",
  desgloseFacturas: "Detalhamento de faturas",
  facturasDelProveedor: "Faturas do fornecedor",
  retiradas: "Retiradas",
  buscarTicket: "Buscar ticket...",
  baseMayusculas: "BASE",
  numServ: "Núm. Serv.",
  ticketMed: "Ticket Med.",
  necesitasElegirUnTpvParaPoderVerLosDetallesDeEste:
    "Você precisa escolher um TPV para ver os detalhes deste",
  ventasMinusculas: "vendas",
  totales: "Totais",
  noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha:
    "Você não tem nenhum intervalo de datas criado. Deseja criar um?",
  siCrearUnRangoHorario: "Sim, criar intervalo de horário",
  detalleDe: "Detalhe de ",
  cierresDeCaja: "fechamentos de caixa",
  ventasNegocioPorZonaHoraria: "Vendas do negócio por fuso horário",
  porZonaHoraria: " por fuso horário",
  detalleDeVentasSegun: "Detalhe de vendas segundo",
  comensalesMinuscula: " comensais",
  desgloseDe: "Detalhamento de ",
  ticketsCobrados: "tickets cobrados",
  segunTipoDeIVA: "segundo tipo de IVA",
  facturasEmitidas: "Faturas emitidas",
  aClientes: " a clientes",
  desgloseDeVentasSegun: "Detalhamento de vendas segundo ",
  formasDePagoMinusculas: "formas de pagamento",
  agenciasMinusculas: "agências",
  cuentasACredito: "contas a crédito",
  sumatorioDe: "Soma de ",
  impuestos: "impostos",
  porFechas: " por datas",
  cuentasAnuladasMinusculas: "contas anuladas",
  delNegocio: " do negócio",
  cuentasRectificadas: "Faturas retificativas",
  cuentasRectificadasMinusculas: "faturas retificativas",
  retiradasMinusculas: "retiradas",
  ventaDeProductosPorNegocio: "Vendas de produtos por negócio",
  rankingDe: "Ranking de",
  costeDeProductos: "Custo de produtos",
  margenDeCostes: "Margem de custos",
  segunVentasPorRangoDeFecha: "segundo vendas por intervalo de datas",
  historicoDeProducto: "Histórico de produto",
  rankingAgrupadoDe: "Ranking agrupado de",
  enTodosLosNegocios: "em todos os negócios",
  ventasDeCategoriasPorNegocio: "Vendas de categorias por negócio",
  agrupacionDe: "Agrupamento de",
  ventasDeCategoriasMinusculas: "vendas de categorias",
  deProductos: "de produtos",
  invitacionesMinusculas: "convites",
  ventasPorMateriasPrimas: "Vendas por matérias-primas",
  ventasDeMateriasPrimasMinusculas: "vendas de matérias-primas",
  comprasDeMateriasPrimas: "Compras de matérias-primas",
  porRangoDeFecha: "por intervalo de datas",
  comprasAProveedores: "Compras a fornecedores",
  comprasAUnProveedor: "Compras a um fornecedor",
  porRangoDeFechaEn: "por intervalo de datas em",
  todosLosNegocios: "todos os negócios",
  comprasAgrupadasPorEtiquetas: "Compras agrupadas por etiquetas",
  comprasAFabricantes: "Compras a fabricantes",
  comprasAUnFabricante: "Compras a um fabricante",
  ranking: "Ranking",
  detallesDe: "Detalhes de",
  turnos: "turnos",
  ventasPorClientesPlural: "Vendas por cliente",
  deVentasPorClientes: "de vendas por cliente",
  consultaDeVentasPorCliente: "Consulta de vendas por cliente",
  historico: "Histórico",
  deVentasPorCliente: "de vendas por cliente",
  numierPedidos: "Numier Pedidos",
  informeDePasarelaDePago: "Relatório do Gateway de Pagamento",
  desgloseDiarioDeLosPagosATraves: "Detalhamento diário dos pagamentos através",
  pasarelaDePagoStripe: "Gateway de pagamento Stripe",
  clicParaMasInformacion: "Clique para mais informações",
  cantidadMinusculas: "quantidade",
  totalMinusculas: "total",
  tarjetaYCheques: "Cartão e cheques",
  seleccionaOperario: "Selecione operário...",
  necesitasSeleccionarUnProveedorParaPoderHacerUnPedido:
    "Você precisa selecionar um fornecedor para fazer um pedido",
  estePedidoNoEsValido: "Este pedido não é válido",
  quieresRestablecerElPedido: "Deseja restabelecer o pedido?",
  siRestablecerPedido: "Sim, restabelecer pedido",
  datosPersonales: "Dados Pessoais",
  datosDeAcceso: "Dados de Acesso",
  contrasenaAntigua: "Senha Antiga",
  contrasenaNueva: "Nova Senha",
  confirmarContrasena: "Confirmar Senha",
  quieresDarDeAltaUnUsuario: "Deseja registrar um usuário?",
  quieresDarDeBajaUnUsuario: "Deseja cancelar um usuário?",
  licencias: "Licenças",
  fechaCaducidad: "Data de validade",
  ilimitado: "ILIMITADO",
  lasContrasenasNoCoinciden: "As senhas não coincidem",
  seleccionaUsuario: "Selecione usuário...",
  usuario: "Usuário",
  negocios: "Negócios",
  balance: "Balanço",

  teHaParecidoUtilEsteArticulo: "Este artigo foi útil para você?",
  graciasPorTuOpinion: "Obrigado pela sua opinião",
  asignarTurno: "Atribuir turno",
  vacaciones: "Férias",
  descargarPDF: "Baixar PDF",
  enviarHorario: "Enviar Horário",
  incidenciasEnElMes: "incidências no mês",
  diasDeVacacionesEnElMes: "dias de férias no mês",
  diasDeVacacionesEnElAno: "dias de férias no ano",
  nuevoTurno: "Novo turno",
  clonarTurno: "Clonar turno",
  nombreDelTurno: "Nome do turno",
  diasDeLaSemana: "Dias da semana",
  editarTurno: "Editar turno",
  borrarTurno: "Excluir turno",
  evento: "Evento",
  nombreEvento: "Nome do evento",
  hayUnaIncidenciaEnEsteTurno: "Há uma incidência neste turno",
  fechaInicioTurno: "Data início turno",
  fechaFinTurno: "Data fim turno",
  numHorasTurno: "Nº horas do turno",
  fechaInicioTrabajada: "Data início trabalhada",
  fechaFinTrabajada: "Data fim trabalhada",
  numHorasTrabajadas: "Nº horas trabalhadas",
  noIniciado: "Não iniciado",
  noFinalizado: "Não finalizado",
  fechaInicioVacaciones: "Data início férias",
  fechaFinVacaciones: "Data fim férias",
  turnoHorario: "Turno horário",
  nombreTurno: "Nome do turno",
  campoRequerido: "Campo obrigatório",
  introduzcaLosDiasDeLaSemana: "Insira os dias da semana",
  crearTurnoHorarioDeOperario: "Criar turno horário de operário",
  introduzcaLosOperarios: "Insira os operários",
  laboral: "Laboral",
  vacacional: "Vacacional",
  seleccionaTurno: "Selecione turno...",
  seleccionaLosNegociosALosQueQuiereClonarElTurno:
    "Selecione os negócios para os quais deseja clonar o turno",
  seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios:
    "Selecione a data em que deseja copiar os horários",
  seleccioneUnaSemana: "Selecione uma semana",
  lunes: "Segunda-feira",
  martes: "Terça-feira",
  miercoles: "Quarta-feira",
  jueves: "Quinta-feira",
  viernes: "Sexta-feira",
  sabado: "Sábado",
  domingo: "Domingo",
  laFechaSeleccionadaNoEsValida: "A data selecionada não é válida",
  turnoClonadoCorrectamente: "Turno clonado com sucesso",
  correoEnviadoCorrectamente: "E-mail enviado com sucesso",
  estasSeguroDeBorrarElTurnoSeleccionado:
    "Tem certeza de que deseja excluir o turno selecionado?",
  siBorrarTurno: "Sim, excluir turno",
  necesitasCrearAlgunTurnoParaPoderCrearCuadrantes:
    "Você precisa criar algum turno para poder criar escalas",
  estasSeguroDeEditarElTurno: "Tem certeza de que deseja editar o turno?",
  siEditarTurno: "Sim, editar turno",
  hoy: "Hoje",
  turno: "Turno",
  turnoBorradoCorrectamente: "Turno excluído com sucesso",
  informacion: "Informação",
  elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido:
    "O dia não corresponde à configuração do turno escolhido",
  turnoCopiadoCorrectamente: "Turno copiado com sucesso",
  turnoDeOperarioAgregadoCorrectamente:
    "Turno do operário adicionado com sucesso",
  turnoDeOperarioEliminadoCorrectamente:
    "Turno do operário excluído com sucesso",
  turnoDeOperarioEditadoCorrectamente: "Turno do operário editado com sucesso",
  tecnicoConsultasTecnicasIncidencias:
    "Técnico (Consultas técnicas, Incidências...)",
  comercialActivacionDeProductosInformacionServicios:
    "Comercial (Ativação de produtos, Informações, Serviços...)",
  administracionFacturacionReclamaciones:
    "Administração (Faturação, Reclamações...)",
  elAsuntoEsObligatorio: "O assunto é obrigatório",
  elMensajeEsObligatorio: "A mensagem é obrigatória",
  soporteOnlineEnviadoCorrectamente: "Suporte online enviado com sucesso",
  todosLosNegociosMayusculas: "Todos os negócios",
  recordarMisDatos: "Lembrar meus dados",
  paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros:
    "Para qualquer incidente ou mais informações, entre em contato conosco",
  iniciarSesion: "Iniciar sessão",
  haOlvidadoSuContrasena: "Esqueceu sua senha?",
  haHabidoUnErrorAlConectarPruebeDeNuevo:
    "Ocorreu um erro ao conectar. Tente novamente",
  elEmailNoPuedeEstarEnBlanco: "O e-mail não pode estar em branco",
  elEmailNoEsValido: "O e-mail não é válido",
  laContrasenaNoPuedeEstarEnBlanco: "A senha não pode estar em branco",
  estaPaginaNoSeEncuentraEnElSistema:
    "Esta página não está disponível no sistema",
  volverAlInicio: "Voltar ao início",
  obtenerContrasena: "Obter senha",
  disculpeLasMolestiasEstamosDeMantenimiento:
    "Desculpe o transtorno, estamos em manutenção",
  funcionEnMantenimiento: "Função em manutenção",
  getDataCompanyMantenimiento: "Esta função está temporariamente em manutenção. Desculpe o transtorno.",
  vuelvaAIntentarloMasTarde: "Tente novamente mais tarde",
  acepto: "Aceito",
  categoriasDeClientes: "Categorias de clientes",
  categoriaDeCliente: "categoria de cliente",
  nombreCategoria: "Nome da categoria",
  noSeleccionada: "Não selecionada",
  cobradoMayusculas: "COBRADO",
  envioProgramadoPara: "Envio programado para",
  eliminarPedido: "Excluir pedido",
  aceptarPedido: "Aceitar pedido",
  pedidoConfirmado: "Pedido confirmado",
  archivarPedido: "Arquivar pedido",
  detallesPedido: "Detalhes do pedido",
  nota: "Nota",
  precioUd: "Preço Ud",
  gratis: "GRÁTIS",
  guardarYAceptarPedido: "Salvar e aceitar pedido",
  seleccionaGrupo: "Selecione grupo...",
  todosMayusculas: "TODOS",
  nombreOperario: "Nome do operário",
  apellidos: "Sobrenome",
  claveAcceso: "Chave de acesso",
  codigoDeTurnos: "Código de turnos",
  claveAccesoPDA: "Chave de acesso PDA",
  seleccionaIVA: "Selecione IVA",
  calcularCostoAPartirDeMateriasPrimas:
    "Calcular custo a partir de matérias-primas",
  seleccionaImpresoraDeComandasTPV: "Selecione impressora de comandas TPV",
  seleccionaImpresoraDeComandasPDA: "Selecione impressora de comandas PDA",
  buscarMateriaPrima: "Buscar matéria-prima",
  buscarProducto: "Buscar produto",
  nuevaMateriaPrima: "Nova matéria-prima",
  ordenarSubproductos: "Ordenar subprodutos",
  seleccionaEtiqueta: "Selecione etiqueta...",
  clonarProducto: "Clonar produto",
  clonarProductoCarta: "Clonar produto",
  buscarSinPuntos: "Buscar",
  sinProveedores: "Sem fornecedores",
  agregadas: "adicionadas",
  modificadas: "modificadas",
  materiaPrimaEliminadaCorrectamente: "Matéria-prima excluída com sucesso",
  asociacion: "associação",
  materiaPrimaOrdenadaCorrectamente: "Matéria-prima ordenada com sucesso",
  productosCopiadosCorrectamente: "Produtos copiados com sucesso",
  menuCopiadoCorrectamente: "Menu copiado com sucesso",
  responder: "Responder",
  administracion: "Administração",
  soporteTecnico: "Suporte técnico",
  horaInicioMayusculas: "Hora Início",
  horaFinal: "Hora Final",
  personaDeContacto: "Pessoa de contato",
  motivoVisita: "Motivo da visita",
  servicioBajoMantenimiento: "Serviço em manutenção",
  desplazamiento: "Deslocamento",
  ticketEnviadoCorrectamente: "Ticket enviado com sucesso",
  precioCompraConDescuento: "Preço de compra com desconto",
  introduzcaLasPartesDelStockMinimo: "Insira as partes do estoque mínimo",
  actualizarStockMinimoYOptimo: "Atualizar estoque mínimo e ótimo",
  subproductoDeVerdad: "Subproduto",
  entregado: "Entregue",
  retirada: "Retirada",
  subtotal: "Subtotal",
  pagosACuenta: "Pagamentos a conta",
  horaDeApertura: "Hora de abertura",
  horaInicio: "Hora início",

  condicionesDeNumierOnline: "Condições do Numier Online",
  descripcionDelServicio: "Descrição do Serviço",
  terminosIntroduccionParte1:
    "O serviço na nuvem do Numier oferecido pela NEXODO DIGITAL S.L. (doravante NEXODO), permite aos clientes acesso online às informações atualizadas de seus negócios.",
  terminosIntroduccionParte2:
    "Para isso, as aplicações de ponto de venda do Numier enviarão através da internet detalhes das vendas realizadas e outros tipos de informação que possam ser de interesse dos clientes.",
  terminosIntroduccionParte3:
    "O acesso a este serviço será realizado através do site https://www.numier.com/clientes, onde poderá consultar as informações enviadas pelos pontos de venda.",
  terminosIntroduccionParte4:
    "A NEXODO reserva-se o direito de melhorar, modificar ou cancelar o serviço a qualquer momento.",
  politicaDePrivacidad: "Política de privacidade",
  privacidadParte1:
    "1. A NEXODO fez a seguinte declaração de privacidade com o objetivo de manifestar seu firme propósito de proteger sua privacidade. Recomendamos que leia atentamente esta política antes de usar o serviço, pois isso implica que a NEXODO coletará e processará seus dados pessoais de acordo com esta política. A NEXODO reserva-se o direito de modificar a política a qualquer momento e se isso ocorrer, se compromete a informar as alterações que lhe afetem.",
  privacidadParte2:
    "2. A NEXODO respeita suas opções de privacidade. Caso forneça alguma informação, ela será tratada de acordo com esta política.",
  privacidadParte3:
    "3. A NEXODO recomenda discrição ao fornecer informações a operadores ou proprietários do site. Tenha em mente que fornecer dados pessoais em locais de acesso público, como chats, implica que qualquer pessoa com acesso à internet poderá ter acesso a eles. Recomendamos não inserir informações que não queira que outros vejam nesses locais públicos.",
  privacidadParte4:
    "4. Ao se registrar no NUMIER ONLINE, poderá ser necessário fornecer dados pessoais. Registre corretamente as informações na data de registro. Se suas informações mudarem após o registro, atualize-as imediatamente, caso contrário, poderá não receber serviços ou informações da NEXODO.",
  privacidadParte5:
    "5. A NEXODO pode utilizar suas informações pessoais com a finalidade de melhorar este site.",
  privacidadParte6:
    "6. A NEXODO coleta esses dados para obter informações para melhorar serviços e produtos. Podemos usar essas informações para enviar ofertas por e-mail ou correio que possam interessar ao usuário.",
  privacidadParte7:
    "7. Para cancelar a assinatura desses e-mails, entre em contato com a NEXODO. Caso contrário, a NEXODO manterá as informações do usuário até a anulação da assinatura ou até o vencimento do período exigido por lei.",
  privacidadParte8:
    "8. A NEXODO não revelará seus dados a terceiros sem seu consentimento, a menos que seja legalmente necessário.",
  privacidadParte9:
    "9. Você pode solicitar a exclusão de todos os dados da sua assinatura no banco de dados, entrando em contato com a empresa.",
  privacidadParte10:
    "10. A NEXODO tomou medidas para garantir que a informação esteja disponível apenas para o usuário que a inseriu originalmente.",
  privacidadParte11:
    "11. Só é possível acessar a informação após inserir a senha.",
  privacidadParte12:
    "12. Este site pode conter links para outros sites não associados à NEXODO. Esses sites têm suas próprias políticas de privacidade, pelas quais a NEXODO não se responsabiliza. O acesso a esses sites vinculados é de sua exclusiva responsabilidade.",
  privacidadParte13:
    "13. A NEXODO garante a segurança das informações dos usuários, exceto nos casos a seguir:",
  privacidadParte13dos: "- Se a NEXODO tiver seu consentimento.",
  privacidadParte13tres:
    "- Se a NEXODO for legalmente obrigada a fornecer informações, por determinação judicial ou procedimento jurídico.",
  privacidadParte13cuatro:
    "- Se a divulgação for necessária para proteger os direitos e a propriedade da NEXODO.",
  privacidadParte13cinco:
    "- Se a divulgação das informações for necessária para melhorar os serviços e produtos dos clientes, incluindo você.",
  privacidadParte14:
    "14. A NEXODO garante a manutenção adequada das informações em um servidor seguro e criptografado, acessível apenas a terceiros autorizados.",

  cartaDigital: "Carta digital",
  horarios: "Horários",
  zonas: "Zonas",
  modificarHorariosDeLaCarta: "Modificar horários da carta",
  modificarZonasDeLaCarta: "Modificar zonas da carta",
  diaDeLaSemana: "Dia da semana",
  esteNegocioNoTieneCarta: "Este negócio não tem carta",
  tipoDeEnvio: "Tipo de envio",
  nuevoHorario: "Novo horário",
  elCampoDiaDeLaSemanaEsRequerido: "O campo dia da semana é obrigatório",
  borrarHorario: "Excluir horário",
  laHoraInicioNoPuedeSerMayorQueLaHoraFin:
    "A hora de início não pode ser maior que a hora de fim",
  noHayHorariosEnEsteNegocio: "Não há horários neste negócio",
  deseaEliminarEsteHorario: "Deseja excluir este horário?",
  siBorrarHorario: "Sim, excluir horário",
  seleccioneDiaDeLaSemana: "Selecione o dia da semana",
  seleccioneTipoDeEnvio: "Selecione o tipo de envio",

  importacionSage: "Importação Sage",
  importacionContable: "Importação contábil",
  enlaceContable: "Link contábil",
  ejercicio: "Exercício",
  codigoEmpresa: "Código da empresa",
  asiento: "Lançamento",
  cargoAbono: "Débito / Crédito",
  codigoCuenta: "Código da conta",
  fechaAsiento: "Data do lançamento",
  comentario: "Comentário",
  importeAsiento: "Valor do lançamento",
  numeroPeriodo: "Número do período",
  delegacion: "Delegação",
  canal: "Canal",
  ejercicioFactura: "Exercício da fatura",
  serie: "Série",
  factura: "Fatura",
  suFacturaNo: "Sua fatura nº",
  fechaFactura: "Data da fatura",
  importeFactura: "Valor da fatura",
  tipoFactura: "Tipo de fatura",
  codigoCuentaFactura: "Código da conta da fatura",
  codigoRetencion: "Código de retenção",
  baseRetencion: "Base de retenção",
  porRetencion: "Por retenção",
  importeRetención: "Valor da retenção",
  baselva1: "Base IVA 1",
  porlva1: "Por IVA 1",
  cuotaIva1: "Quota IVA 1",
  porRecargoEquivalencia1: "Por sobretaxa de equivalência 1",
  recargoEquivalencia1: "Sobretaxa de equivalência 1",
  codigoTransaccion1: "Código de transação 1",
  descargarComoTxt: "Baixar como .txt",

  noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha:
    "Não há lançamentos contábeis neste TPV neste intervalo de datas",
  cargandoAsientosContables: "Carregando lançamentos contábeis",
  fechaDeAperturaDeCaja: "Data de abertura do caixa",
  fechaDeCierreDeCaja: "Data de fechamento do caixa",
  descargarVentas: "Baixar vendas",
  descargarGastos: "Baixar despesas",
  noHasCerradoEstaCaja: "Você não fechou este caixa",
  numeroDeCierres: "Número de fechamentos",
  introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE:
    "Insira o último número de lançamento contábil que possui no SAGE",
  porFavorRelleneElAsientoContable: "Por favor, preencha o lançamento contábil",
  descargar: "Baixar",
  elAsientoContableDebeSerUnNumero: "O lançamento contábil deve ser um número",
  elAsientoContableNoPuedeSerMayorA10Digitos:
    "O lançamento contábil não pode ter mais de 10 dígitos",
  TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos:
    "Tenha em conta que usaremos os números seguintes a este para completar os dados",
  noExistenVentasEsteDia: "Não existem vendas neste dia",
  noExistenGastosEsteDia: "Não existem despesas neste dia",
  enSage: "no SAGE",
  proyecto: "Projeto",
  codigoEmpresaHelp:
    "Lembre-se que o dado empresa é compartilhado entre todos os negócios da mesma empresa",
  cuentasDelTpvSeleccionado: "Contas do TPV selecionado",
  nuevaCuenta: "Nova conta",
  nombreDeCuenta: "Nome da conta",
  codigoCuentaMinuscula: "Código da conta",
  tipoDeCuenta: "Tipo de conta",
  noHayCuentasCreadasConElTpvSeleccionado:
    "Não há contas criadas com o TPV selecionado",
  crearNuevaCuenta: "Criar nova conta",
  codigoDeLaCuenta: "Código da conta",
  codigoDeLaSubcuenta: "Código da subconta",
  configuracionCuentasIva: "Configuração de contas IVA",
  configuracionCuentasEspeciales: "Configuração de contas especiais",
  cuenta: "Conta",
  subcuenta: "Subconta",
  editarCuenta: "Editar conta",
  sage200: "SAGE 200",
  exportarCAPTE: "Exportar CAPTE",
  losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos:
    "Os campos nome, código da conta e código da subconta devem estar preenchidos",
  estaSeguroDeQueDeseaEliminarEstaCuenta:
    "Tem certeza de que deseja excluir esta conta?",
  siBorrarCuenta: "Sim, excluir conta",
  cuentaEditadaCorrectamente: "Conta editada com sucesso",
  cuentaCreadaCorrectamente: "Conta criada com sucesso",
  configuracionSAGE: "Configuração Sage",
  sinCuentaAsociada: "Sem conta associada",
  loSientoSuNegocioNoTieneContratadoSAGE:
    "Desculpe, seu negócio não possui contrato com SAGE",
  loSientoSuNegocioNoTieneContratadoEsteModulo:
    "Desculpe, seu negócio não possui contrato com este módulo",
  paraMasInformacionContacteConComerciales:
    "Para mais informações, entre em contato com os comerciais",
  laLongitudMaximaDeLasSubCuentas:
    "O comprimento máximo da subconta deve ser de 12 caracteres",

  preparados: "Preparados",
  enReparto: "Em entrega",
  noHayPedidosPreparados: "Não há pedidos preparados",
  noHayPedidosEnReparto: "Não há pedidos em entrega",
  pedidoListo: "Pedido pronto",
  pedidoEnReparto: "Pedido em entrega",

  codigo: "Código",
  crearNuevoCodigoCuenta: "Criar novo código de conta",
  editarNuevoCodigoCuenta: "Editar novo código de conta",
  seleccioneUnaFormaDePagoParaElGasto:
    "Selecione uma forma de pagamento para a despesa",
  hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna:
    "Selecionou faturas com diferentes formas de pagamento, por favor selecione uma",
  seleccioneUnaFormaDePago: "Selecione uma forma de pagamento",
  zonasActualizadasCorrectamente: "Zonas atualizadas com sucesso",
  zonaCreadaCorrectamente: "Zona criada com sucesso",
  zonaEditadaCorrectamente: "Zona editada com sucesso",
  guardarCambios: "Salvar alterações",
  laZonaNoPuedeTenerElNombreEnBlanco: "A zona não pode ter o nome em branco",
  zonasDeReparto: "Zonas de entrega",
  editarZona: "Editar zona",
  color: "Cor",
  costeDeReparto: "Custo de entrega",
  pedidoMinimo: "Pedido mínimo",
  crearNuevaZona: "Criar nova zona",
  estasSeguroDeQueQuieresEliminarLaZona:
    "Tem certeza de que deseja excluir esta zona?",
  estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos:
    "Esta zona deixará de estar disponível imediatamente e não serão feitos pedidos nela",
  siEliminarZona: "Sim, excluir zona",
  zonaEliminadaCorrectamente: "Zona excluída com sucesso",
  ventasExportadas: "Vendas exportadas",
  gastosExportados: "Despesas exportadas",
  todosLosCierresDeEsteDiaHanSidoExportados:
    "Todos os fechamentos deste dia foram exportados",
  faltanVentasPorExportarEsteDia: "Faltam vendas a exportar neste dia",
  todosLosGastosDeEsteDiaHanSidoExportados:
    "Todas as despesas deste dia foram exportadas",
  faltanGastosPorExportarEsteDia: "Faltam despesas a exportar neste dia",
  exportar: "Exportar",

  // 10-02-2021
  otros: "Outros",
  restriccionHorarios: "Restrição de horários",
  restriccionHorariosDesc:
    "Restringir alguns intervalos de horário (fechado, cheio, sem entrega...)",
  borrar: "Excluir",
  restriccion: "Restrição",
  nMaximoPedidos: "Nº máximo de pedidos",
  cerrarFranja: "Fechar intervalo",
  limitePedidos: "Limite Nº Pedidos",
  loSentimosSuNegocioNoTieneContratadoEsteModulo:
    "Desculpe, seu negócio não possui contrato com este módulo",
  numeroPedidosPermitidos: "Número de pedidos permitidos",
  estaSeguroDeQueDeseaEliminarEstaRestriccion:
    "Tem certeza de que deseja excluir esta restrição?",
  siBorrarRestriccion: "Sim, excluir restrição",
  loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion:
    "Desculpe, para acessar este módulo, você precisa ativar a configuração",
  costeSinIVA: "Custo sem IVA",

  // 11.3.2021
  importeIVA: "Valor IVA",

  // 17.3.2021
  pasarAPreparacion: "Passar para preparação",
  pasarAPreparados: "Passar para preparados",
  pasarAEnReparto: "Passar para em entrega",
  finalizarPedido: "Finalizar pedido",

  // Tener en cuidado con los espacios, ya que son los espacios Braille
  domicilioActivado: "‏‏‎DOMICÍLIO⠀ATIVADO",
  domicilioDesactivado: "DOMICÍLIO⠀DESATIVADO",
  recogerActivado: "RETIRAR⠀ATIVADO",
  recogerDesactivado: "RETIRAR⠀DESATIVADO",

  conDetalles: "com detalhes",
  zonasRepartoActivadas: "ATIVADAS⠀",
  zonasRepartoDesactivadas: "DESATIVADAS⠀",
  siEliminarCategoria: "Sim, excluir categoria",
  confirmaEliminarCategoria:
    "Tem certeza de que deseja excluir esta categoria?",
  pedidoPreparado: "Pedido preparado",
  configuracionParaLaImportacionExportacionDeDatosDeSage:
    "Configuração para importação/exportação de dados do Sage",
  enEstaPantallaSeConfiguranLosCodigosDeLasCuentas:
    "Nesta tela configuram-se os códigos das contas",
  formadosPor3Digitos: "formados por 3 dígitos",
  estosSonNecesariosParaConfigurarLasCuentasContables:
    "Estes são necessários para configurar as contas contábeis",
  alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente:
    "Ao editar um código relacionado a uma conta contábil já existente",
  todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta:
    "qualquer alteração feita sobre ele afetará também a própria conta",
  aContinuacionSeListaranLasCuentasDeTipo:
    "A seguir serão listadas as contas do tipo",
  gastoMinuscula: "gasto",
  paraQue: "para que",
  asocieMinuscula: "associe",
  ventaMinuscula: "venda",
  unaParaSuPosterior: "uma para sua posterior",
  relacionEnSage: "relação no SAGE",
  relacionEnContabilidad: "relação na contabilidade",
  seleccioneUnaCuenta: "Selecione uma conta",
  aDomicilio: "Entrega a domicílio",
  aRecoger: "Retirada",
  tipoDeZona: "Tipo de zona",
  seleccioneUnTipo: "Selecione um tipo",
  kilometrosDelArea: "Kms da área",
  codigoEmpleado: "Código do empregado",
  exportarReservas: "Exportar reservas",
  importacionSinqro: "Importação Sinqro",
  configuracionParaLaImportacionDeDatosDeSinqro:
    "Configuração para a importação de dados do Sinqro",
  pasarelaDePago: "Gateway de pagamento",
  importeSinDescuento: "Valor sem desconto",
  desactivarZona: "Desativar zona",
  activa: "ATIVA",
  inactiva: "INATIVA",
  exportarPdfConMateriasPrimasAsociadas:
    "Exportar PDF com matérias-primas associadas",
  exportarExcelConMateriasPrimasAsociadas:
    "Exportar Excel com matérias-primas associadas",

  // Pedidos archivados 18/05/21
  informePedidosDetalle: "Detalhamento de pedidos",
  informePedidos: "Relatório de pedidos",
  tipoPago: "Forma de pagamento",
  tipoPedido: "Tipo de pedido",
  domicilio: "Entrega a domicílio",
  recoger: "Retirada no local",
  pagoLocal: "Pagamento no local",
  otro: "Outro",

  // 25/05/2021
  configuracionTurnos: "Configuração de turnos",

  // 2021/05/20
  estasSeguroDeImportarTusProductosASinqro:
    "Deseja importar seus produtos para o Sinqro?",
  esteProcesoPuedeTardarVariosMinutos:
    "Este processo pode levar vários minutos.",
  siImportarConSinqro: "Sim, importar para o Sinqro",
  estasSeguroDeDarDeBajaElProducto: "Deseja dar baixa no produto?",
  podraDarloDeAltaEnUnFuturo: "Você poderá ativá-lo novamente no futuro",
  siDarDeBaja: "Sim, dar baixa",
  estasSeguroDeDarDeAltaElProducto: "Deseja ativar o produto?",
  podraDarloDeBajaEnUnFuturo: "Você poderá desativá-lo no futuro.",
  siDarDeAlta: "Sim, ativar",
  laImportacionTardara: "Importando... este processo pode levar vários minutos",
  importacionFinalizada: "Importação concluída com sucesso",
  completo: "Concluído",
  vale: "Ok",
  importarSinqro: "Importar Sinqro",
  importandoProductos: "A importação está sendo realizada neste momento...",
  generandoCarta: "Um momento, por favor. Estamos gerando o seu cardápio.",
  procesoFin: "O processo foi concluído com sucesso",
  procesoCompletado: "Processo concluído",
  yaFaltaPoco: "Falta pouco...",
  estamosEnEllo:
    "Estamos trabalhando na importação. Por favor, não recarregue o navegador.",
  finProgres: "O progresso terminou com sucesso.",
  textoInfo: "Esta coluna mostra o preço de compra sem IVA",
  textoInfoImporteDTO:
    "Esta coluna mostra o preço total de compra com desconto (calculado a partir do preço sem IVA)",
  correosEnviados: "E-mails enviados",
  correosEnviadosCorrectamente: "Os e-mails foram enviados corretamente.",
  errorAlEnviar: "Erro ao enviar",
  noSePudieronEnviarTodosLosCorreos:
    "Não foi possível enviar todos os e-mails:",
  errorInesperadoEnvioCorreos:
    "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde",

  // 07/06/2021
  valorRecuento: "Valor Contagem",

  // 08/06/2021
  obligatorioEmail: "Preenchimento do e-mail obrigatório",
  datosCliente: "Dados do cliente",

  // 11/06/2021
  recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:
    "Lembre-se que realizar cobranças antecipadas pode gerar pequenos desalinhamentos",
  yQue: "e que",
  losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:
    "os descontos das vendas estão a 0% de IVA",

  // 16/06/2021
  totalValoresNegativos: "Total Valores Negativos",
  solamenteSeTieneEnCuentaValoresPositivos:
    "Somente valores positivos são considerados",
  totalValoresDiferencia: "Total Valores Diferença",
  totalValoresDiferenciaDto: "Total Valores Diferença Dto.",
  valorDiferencia: "Valor diferença",
  valorDifereciaDto: "Valor diferença dto.",
  precioDto: "Preço Dto.",

  // 24/06/2021
  exportarMateriasPrimasAsociadasAEsteProducto:
    "Exportar matérias-primas associadas a este produto",
  sinIVA: "Sem IVA",
  errorAlIntentarObtenerLosTpvs: "Erro ao tentar obter os TPVs",

  // 01/07/2021
  deseaguardarelproductoencarta:
    "A seguir, procederemos a replicar os nomes e preços das tarifas maiores que 0€, assim como o campo baixa. Essas alterações afetarão todos os produtos do NumierPEDIDOS relacionados a este produto.",
  leidoyacepto: "Entendi!",
  replicarencarta: "Tem certeza?",
  aceptarreplicarencarta: "Aceitar e replicar no cardápio",
  guardaryreplicar: "Salvar e replicar no cardápio",

  // Modal seleccionar categoría al crear en carta
  enlazarACategoria: "Vincular a uma categoria",
  deseaEnlazarProductoCategoria: "Deseja vincular o novo produto a uma categoria existente no cardápio?",
  categoria: "Categoria",
  seleccionarCategoria: "Selecionar categoria",
  omitirYCrear: "Ignorar e criar",
  aceptarYAgregar: "Aceitar e adicionar",

  // 01/07/2021
  porRangosHorarios: " por faixas de horário",

  // 22/07/2021
  recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal:
    "Lembre-se que as linhas de desconto não são somadas ao total",

  // 16/07/21
  destacado: "Destaque",
  sugerido: "Sugerido",

  // 23/07/2021
  totalSinDescuento: "Total sem desconto",

  // MENÚS
  menus: "Menus",
  descripcionMenus: "Grupo de produtos vendidos em conjunto",
  numeroDePlatos:
    "Número de pratos que o cliente poderá escolher para cada prato:",
  platosTip1: "Nesta tela você pode criar os diferentes pratos que",
  platosTip2: "compõem o menu para posterior associação com os produtos.",
  productosPlatosTip:
    "Nesta tela você pode relacionar pratos e produtos para posterior visualização no cardápio.",
  plato: "Prato",
  platos: "Pratos",
  primerPlato: "Primeiro prato",
  segundoPlato: "Segundo prato",
  tercerPlato: "Terceiro prato",
  cuartoPlato: "Quarto prato",
  quintoPlato: "Quinto prato",
  sextoPlato: "Sexto prato",
  seleccionaUnPlato: "Selecione um prato",
  noPuedeDejarEnBlancoElNombreDeUnPlato:
    "Não pode deixar o nome de um prato em branco",
  estaSeguroDeQueQuiereBorrarEstePlato:
    "Tem certeza de que deseja excluir este prato?",
  seBorraranTodasLasAsociacionesDeProductosConElMismo:
    "Todas as associações de produtos com ele serão excluídas",
  siEstoySeguro: "Sim, tenho certeza",
  estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado:
    "Tem certeza de que deseja desvincular este produto do prato selecionado?",
  dejaraDeFormarParteDelMenuDeFormaInstantanea:
    "Deixará de fazer parte do menu imediatamente",
  noMostrarSuelto: "Não mostrar isolado (somente disponível em menus)",
  clonarMenu: "Clonar menu",
  // 29/07/2021
  totalPedidosDevueltos: "Nº de devoluções",
  totalImportesDevueltos: "Total valor devolvido",

  // 06/08/2021
  NoMostrarRecargasSaldo: "Não mostrar recargas de saldo",
  // 10/08/2021
  noMostrarDescuento: "Não mostrar descontos",
  // 17/08/2021
  operarioApertura: "Operador abertura",
  aperturasPorOperarios: "Contas abertas por operador",
  aperturasPorOperariosMinuscula: "contas abertas por operador",
  aperturasOperarios: "Contas abertas",
  productosPorAperturaDe: "Produtos por abertura de",
  productosPorApertura: "Produtos por abertura",
  facturasEmitidasMinuscula: "faturas emitidas",

  // 18/08/21
  restriccionesProductos: "Restrições por produto",
  restriccionesProductosDesc:
    "Configurar restrições de horário para venda de produtos",
  // 19/08/21
  noHayRestriccionesParaProductos:
    "Não há restrições de horário para produtos neste negócio.",
  alcohol: "Álcool",
  // 20/08/21
  inforestriccionesproducto:
    "Depois de criar a restrição de venda por horário, você poderá atribuí-la na configuração dos produtos.",
  noMostrarDescuento: "Não mostrar descontos",

  // 17/08/2021
  rangosDeMesas: "Faixas de mesas",
  agrupacionesDeMesasParaConsultarVentas:
    "Agrupamentos de mesas para consultar vendas",
  verUnInformeDeRangosDeMesas: "Ver relatório de faixas de mesas",
  nuevoRangoMesa: "Nova faixa de mesa",
  mesaInicial: "Mesa inicial",
  mesaFinal: "Mesa final",
  noHayRangosDeMesasEnEsteTpv: "Não há faixas de mesas neste TPV",
  nombreRangoDeMesas: "Nome da faixa de mesas",
  borrarRangoMesas: "Excluir faixa de mesas",
  deseaEliminarEsteRangoDeMesas: "Deseja excluir esta faixa de mesas?",
  siBorrarEsteRangoDeMesas: "Sim, excluir esta faixa de mesas",
  ventasPorRangoDeMesas: "Vendas por faixa de mesas",
  porRangoDeMesas: " por faixa de mesas",
  numeroDeOperaciones: "Número de operações",
  precioMedioPorOperacion: "Preço médio por operação",
  propuestoParaCierre: "Proposto para fechamento",
  esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo:
    "Este ticket foi proposto para fechamento, você concorda?",
  siCerrarTicket: "Sim, fechar ticket",
  propuestaDeCierreDeTicket: "Proposta de fechamento do ticket",
  noEstoyDeAcuerdo: "Não concordo",
  ultimaRespuestaDelEquipoTecnico: "Última resposta da equipe técnica",
  escribaAquiSuRespuesta: "Escreva sua resposta aqui",
  enviarRespuesta: "Enviar resposta",
  tienesTicketsPendientesDeCerrar: "Você tem tickets pendentes de fechamento",

  // 27/08/2021
  cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV:
    "Quando um produto é do tipo Menu, um Menu é criado e sincronizado com o TPV",
  platosDelMenu: "Pratos do menu",
  productosDelMenu: "Produtos do menu",
  paraConfigurarUnProductoComoTipoMenu:
    "Para configurar um produto como tipo Menu, primeiro salve o produto",
  ocultarSaldo: "Ocultar produtos relacionados ao saldo",

  // 26/08/21
  resActiva: "Ativada",
  resInactiva: "Desativada",

  // 26/08/2021
  exportarExcelDeTodosLosTickets: "Exportar Excel de todos os tickets",
  soloPuedesSacarInformesDeUnMesComoMaximo:
    "Você só pode gerar relatórios de no máximo um mês",
  loSentimos: "Desculpe",
  noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas:
    "Você não tem nenhuma faixa de mesas criada. Deseja criar uma?",
  siCrearUnRangoMesas: "Sim, criar faixa de mesas",

  // 07/08/2021
  usuarioSinAcceso: "Seu usuário não tem acesso a este módulo",

  // 08/09/21
  pedidosHoras: "Pedidos por hora",
  graficaPedidosHoras:
    "Gráfico mostrando o número de pedidos agrupados por faixa de horário no dia de hoje",

  // 20/09/21
  personalizacionCarta: "Personalização do Cardápio Online",
  personalizacion: "Personalização",
  conLasOpcionesQueTeOfrecemos: "com as opções que oferecemos",
  opcionesConfiguracion: "Opções de configuração",
  vistaPrevia: "Visualização",
  imagenCargando: "Imagem carregando",

  // 21/09/21
  diagnosis: "Diagnóstico",
  diagnosticoProductos: "Diagnóstico de produtos",
  comprobacionProducts: "Verificação de produtos",
  diagnosticarProductos: "Diagnosticar produtos",
  productosSinRelacionEnElTpv: "Tudo correto!",
  pulseElBoton: "Pressione o botão desejado",
  paraRealizarDiagnosis: "para realizar o diagnóstico",
  productoRelacionadoConTpv: "Relacionado no TPV com",
  noTieneRelacion: "Não possui relação",
  hayProductosSinRelacion: "Existem produtos que não estão relacionados no TPV",

  // 20/09/21
  destacadosTitulo: "Título em destaque",
  nuevoTitulo: "Novo título",
  tituloActual: "Título atual",

  // 22/09/21
  textos: "Textos",

  // 21/09/21
  facturas: "Faturas",
  facturasMinusculas: "faturas",
  facturacionGeneral: "Faturamento geral",
  deTodasLasSeries: " de todas as séries",

  // 29/09/21
  permisoBusinessGestion:
    "Desculpe. Você não tem permissão para usar esta ferramenta neste negócio",
  permisoUsuarioGestion:
    "Desculpe. Este negócio não possui este módulo ativado.",
  traduccion: "Tradução",
  traduccionDe: "Tradução de",
  idioma: "Idioma",
  losDescuentosDeLasVentasEstanAlCeroDeIva:
    "Os descontos das vendas estão a 0% de IVA",
  recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo:
    "Lembre-se que ao realizar cobranças antecipadas os clientes serão atribuídos à forma de pagamento em dinheiro",
  mapasYZonas: "Mapas e zonas",
  idiomas: "Idiomas",
  permisoControlIdiomas:
    "Desculpe, este negócio não possui o controle de idiomas ativado.",
  idiomasCartaTip1:
    "Para ativar ou desativar um idioma, clique nos interruptores.",
  idiomasCartaTip2:
    "Para ordenar os idiomas no cardápio, você pode usar o campo ordem.",
  idiomasCartaTip3: "Idiomas com ordem menor aparecerão primeiro.",
  menu: "Menu",

  // 30/11/21
  totalVentasDevueltos: " total vendas e devoluções",

  // 24/11/21
  tpvOrigen: "TPV de origem",
  validez: "Validade (dias)",
  dateConsumo: "Data de consumo",
  dateCreacion: "Data de emissão",
  nombreTpvDestino: "TPV de troca",
  nombreTpvOrigen: "TPV de origem",
  hash: "CÓDIGO (hash)",
  proveedor: "Fornecedor",

  // 14/12/2021
  apuntes: "Apontamentos",
  apunte: "Apontamento",
  cuentaContableGastos: "Conta contábil de gastos",
  cuentaContableApuntes: "Conta contábil de apontamentos",
  retrocederEstado: "Retroceder estado",

  // 23/12/2021
  excluirDeSage: "Excluir do Sage",
  costeDeProductosPorAgencias: "Custo de produtos por agências",
  agrupadoPorAgencias: " agrupado por agências",

  // 27/10/21
  selectCategory: "Selecione as categorias para importação",
  errorCategorySelect: "ATENÇÃO",
  txtErrorCategorySelect:
    "A importação foi cancelada porque as categorias selecionadas contêm apenas menus.",

  // 24/01/22
  consultarPorAperturaDeCuenta: "Consultar por abertura de conta",
  consultarPorCierreDeCuenta: "Consultar por fechamento de conta",
  informeAperturaCuentas: "Relatório de abertura de contas",
  informeCierreCuentas: "Relatório de fechamento de contas",
  activado: "Ativado",
  desactivado: "Desativado",
  rango: "Faixa",
  pedidosPlataformaDePagoSinCompletar:
    "Pedidos de plataforma de pagamento não concluídos",
  estaAccionAnadiraUnPedidoEstaSeguro:
    "Esta ação adicionará um pedido, tem certeza de que foi pago?",
  estaAccionNoSePuedeDeshacerEstaSeguro:
    "Esta ação não pode ser desfeita, tem certeza?",
  haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas:
    "Houve um pedido com este telefone nas últimas 12 horas",
  interrogacionQuiere: "Quer ",
  elPedidoTemporalInterrogacion: " o pedido temporário?",
  aceptarMinuscula: "aceitar",
  eliminarMinuscula: "excluir",
  excluirPrecioMedioMenu:
    "Excluir do preço médio os produtos vendidos em menus",

  // 28/01/22
  categoriasPadre: "Categorias pai",
  quieresConvertirLaCategoria: "Quer converter a categoria",
  quieresQueLaCategoria: "Quer que a categoria",
  enUnaCategoriaPadre: "em uma categoria pai?",
  dejeDeSerUnaCategoriaPadre: "deixe de ser uma categoria pai?",
  porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion:
    "Por favor, adicione uma categoria pai antes de ativar a configuração",
  deseaActivarLasCategoriasPadreParaLaCartaDigital:
    "Deseja ativar as categorias pai para o cardápio digital?",
  deseaDesactivarLasCategoriasPadreParaLaCartaDigital:
    "Deseja desativar as categorias pai para o cardápio digital?",
  recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
    "Lembre-se que as categorias que não estiverem relacionadas a uma categoria pai não aparecerão no Numier Pedidos",
  activadas: "ATIVADAS",
  desactivadas: "DESATIVADAS",
  categoriasPadreTextoExplicativo:
    "As categorias pai servem para agrupar as categorias do Numier Pedidos em agrupamentos maiores. Exemplo: Você pode ter uma categoria pai 'Entradas' que contenha Carne, Peixe e Vegetariano",
  lasImagenesSoloSeraVisibleEnLasCategoriasPadre:
    "As imagens só serão visíveis nas categorias pai",

  // 09/02/2022
  consultarInventarioPorSectores: "Consultar inventário por setores",
  inicioReal: "Início real",
  precarga: "Pré-carga",
  mermas: "Perdas",
  finalBarra: "Final do bar",
  porSectores: "por setores",
  buscarPorRefONombreDelProducto:
    "Buscar por código de barras ou nome do produto",
  textoAyudaProductoCompleto:
    "Quando esta opção estiver desmarcada, será trabalhado com matérias-primas",
  accion: "Ação",

  metodoLiquidacionSinqro: "Método de liquidação Sinqro",
  metodoLiquidacionSinqroInfo:
    "A modificação deste campo deve ser solicitada ao suporte técnico.",
  horaRepartidorAsignado: "Hora entregador atribuído",
  envioProgramado: "Envio programado",
  tiempoEstimado: "Tempo estimado",
  gastosEnvio: "Custos de envio",
  buscarPedidoPorCliente: "Buscar pedido por cliente...",
  obligatorioApellidos: "Obrigatório preencher os dois campos de sobrenomes",

  // 13/06/2022
  introduzcaElPorcentajeDeLaPrimeraCuentaContable:
    "Insira a porcentagem da primeira conta contábil",
  porcentajeContable: "Porcentagem contábil",

  // 7/7/2022
  incidenciaOperario: "Incidências por operador",
  deIncidenciaOperario: "de incidências por operador",
  verIncidenciaOperario: "Ver incidências",
  Incidencia: "Incidência",

  // 11/07/2022
  nTickets: "Nº Ticket",
  propina: "Gorjeta",
  serviceCharge: "Service Charge",

  // 15/07/2022
  totalCompleto: "Total completo",

  // 31/08/2022
  sinConsumir: "Não consumido",

  // 06/09/2022
  integraciones: "Integrações",
  GStock: "G-Stock",

  // 13/09/2022
  estasSeguroDeExportarLasVentas:
    "Tem certeza de exportar as vendas para o G-Stock?",
  ventasExportadasExsitosamente: "Vendas exportadas com sucesso",
  rangoFechasExcedidoMaximo: "O intervalo de datas não pode exceder 3 meses",
  rangoSolicitadoMayorAlPermitido: "O intervalo solicitado é maior que o permitido (máximo 3 meses)",
  respuestaInvalida: "Resposta inválida do servidor",

  // 04/10/2022
  referenciaYaExiste: "A referência coincide com a de outro gasto",
  continuar: "Continuar?",
  guardarGasto: "Salvar gasto",
  maximoOpcionales: "Máximo opcionais",

  // 04/11/2022
  totalImpuestoIva: "Total imposto IVA",

  // 09/11/2022
  enviarFacturaECorreo: "Enviar fatura eletrônica por e-mail",

  // 10/11/2022
  baseImponible: "Base imponível",
  cuotaIVA: "Quota IVA",
  baseSinDto: "Base sem desc.",
  importeTotalSinDto: "Valor total sem desc.",

  // 17/11/2022
  identificador: "Identificador contábil",

  // 13/12/2022
  cambiarAgencia: "Alterar agência",
  facturaEditadaCorrectamente: "A fatura foi editada corretamente",
  editarNumeroComensales: "Editar número de clientes",
  buscarPorNombreDeAgencia: "Buscar por nome da agência",

  // 10/01/2023
  exportadoSage: "Exportado SAGE",
  updateExportadoSageCorrectamente: "Exportado SAGE atualizado corretamente",
  titleModificarExportadoSage: "Modificar exportado para SAGE",
  askUpdateExportadoSageTrue:
    "Tem certeza de que deseja marcar o gasto como exportado?",
  askUpdateExportadoSageFalse:
    "Tem certeza de que deseja marcar o gasto como NÃO exportado?",

  // 01/02/2023
  ProgramacionCarta: "Planejador do cardápio",
  guardados: "Salvos",
  publicados: "Publicados",
  dePublicacion: "de Publicação",
  sinPublicar: "Não publicado",
  publicado: "publicado",
  publicar: "Publicar",
  Ocultar: "Ocultar",
  Publicado: "Publicado",
  aliasMayuscula: "Alias",

  // 03/02/2023
  porcentajeRespectoTotal: "% em relação ao total",

  // 13/02/2023
  ultimoPrecioCompra: "Último preço de compra",

  // 21/02/2023
  basePropina: "Base gorjeta",
  impuestoPropina: "Imposto gorjeta",
  baseServiceCharge: "Base Service Charge",
  impuestoServiceCharge: "Imposto Service Charge",

  // 02/03/2023
  socios: "Sócio",
  noSocios: "Não sócio",

  // 20/04/2023
  productoCartaSinRelacionar: "Sem relação",

  // 21/04/2023
  precioTarifa: "Preço / Tarifa 1",

  resetearDias: "Resetar dias",
  resetearButton: "Resetar",
  fechaIni: "Data de início",
  fechaFin: "Data de fim",
  reseteoExitoso: "Reset realizado com sucesso",
  reseteoError: "Ocorreu um erro ao realizar o reset",

  productosNoRelacionados: "Produtos sem PLU",
  productosNoRelacionadosDescripcion:
    "Ferramenta para encontrar produtos sem PLU",

  // 23/05/2023
  verDetallesDeCuentaAnulada: "Ver detalhes da conta anulada",
  desgloseDeCuenta: "Detalhes da conta",

  // 29/03/2023
  exportarExcelValderrama: "Exportar Excel completo",

  // 20/04/2023
  productoCartaSinRelacionar: "Sem relação",

  // 21/04/2023
  precioTarifa: "Preço / Tarifa 1",

  // 29/05/2023
  pendientePago: "Pendente de pagamento",
  fechaVencimiento: "Data de vencimento",
  pendientePagoCambiadoCorrectamente:
    "Pendente de pagamento alterado com sucesso",
  numeroTickets: "Número de tickets",

  // 06/06/2023
  mensajePorcentajeCompraAumento:
    "O preço aumentou em relação à porcentagem de compra estabelecida",
  avisoPorcentajeCompra: "Aviso de porcentagem de compra",

  // 19/06/2023
  conIvaDesglosado: "com IVA detalhado",

  // 21/06/2023
  ventasPorProductos: "Vendas por produtos",
  sinRecoger: "Não recolhido",
  sinDomicilio: "Sem entrega",
  recogerEnPedidos: "Recolher",
  domicilioEnPedidos: "Entrega",
  informeDeVentasDeProductosDePedidos:
    "Relatório de vendas de produtos de pedidos",

  // 22/06/2023
  numeroPedidosDomicilio: "Nº pedidos entrega",
  numeroPedidosRecoger: "Nº pedidos recolher",

  // 25/07/2023
  exportarSage200Fechas: "Exportar Sage200 por datas",
  fechas: "Datas",
  soloExportarGastos: "Somente exportar gastos",

  // 05/09/2023
  noMostrarInformeSectores: "Não mostrar relatório por setores",
  totalCargar: "Total a carregar",
  deshabilitar: "Desabilitar",
  noMostrar: "Não mostrar",

  // 19/09/2023
  verificarTodo: "Verificar tudo",
  estaSeguroDeVerificarTodosLosGastos:
    "Tem certeza de verificar todos os gastos?",
  gastosVerificadosCorrectamente: "Gastos verificados com sucesso",

  // 26/09/2023
  siVerificarGastos: "Sim, verificar gastos",
  seleccionarTodosDelMismoProveedor: "Selecionar todos do mesmo fornecedor",

  // 28/09/2023
  mostrarSinIva: "Mostrar sem IVA",
  modificarPrecio: "Modificar preço",

  // 05/10/2023
  nDeComensales: "Nº de clientes",

  // 13/10/2023
  archivoEnFormatoExcel: "Arquivo em formato Excel",
  importarExcelClientes: "Importar Excel clientes",
  importarExcelSaldoClientes: "Importar Excel saldo clientes",
  importarClientes: "Importar clientes",

  // 31/10/2023
  ticketMedioRecoger: "Ticket médio recolher:",
  ticketMedioDomicilio: "Ticket médio entrega:",

  // 23/11/2023
  ultimoPrecioCompraSinIva: "Último preço de compra sem IVA",

  // 08/01/2024
  ventaDeProductosPorRangoDeMesas: "Vendas de produtos por faixa de mesas",
  filtradoPorRangoDeMesas: " filtrado por faixa de mesas",
  vecesQueSeHaVendidoDentroDeMenus: "Vezes vendido dentro de menus",
  delMenu: "do menu",
  cEnMenus: "C. em Menus",
  cFueraDeMenus: "C. Fora de Menus",
  rangoDeMesas: "Faixa de mesas",

  // 10/01/2024
  // ToolTip
  tolTipLogo:
    "Adicione o logo do seu restaurante para que apareça na tela inicial e no seu cartão QR. O tamanho recomendado é 90 x 90 px.",
  tolTipFondo:
    "Adicione uma foto de alta qualidade para aparecer como capa no seu menu QR. O tamanho recomendado é 1280 x 1024 px",
  tolTipImagenProducto:
    "Adicione uma imagem de alta qualidade para mostrar seu produto de forma visual e atrativa. Para produtos no menu, crie um novo com resolução ideal de 500 x 500 pixels ou 12 cm x 12 cm.",
  tolTipNombreMostrado: "Digite aqui o nome que deseja exibir do seu negócio.",
  tolTipEmail: "Forneça um e-mail de contato para seus clientes.",
  tolTipTelefono: "Forneça um telefone de contato.",
  tolTipDescripcion:
    "Descreva brevemente seu restaurante: o conceito e a experiência oferecida.",
  tolTipDireccion:
    "Forneça o endereço do restaurante pertencente a este cardápio.",
  tolTipPresentacion:
    "Escreva uma chamada adequada para que seus clientes queiram abrir seu cartão na tela inicial.",
  tolTipHorario:
    "Apresente seu horário ou compartilhe informações extras (férias, fora de serviço...).",
  tolTipMostrarCategoriaDeBaja:
    "Se marcado, categorias desativadas serão exibidas, mas não aparecerão no cardápio.",
  tolTipMostrarProductoDeBaja:
    "Se marcado, produtos desativados serão exibidos, mas não aparecerão no cardápio.",
  tolTipTraducirCategoria:
    "Traduzir o título das categorias para o idioma desejado",
  tolTipConvertirCategoriaPadre: "Converter em categoria pai",
  tolTipOrdenCategorias:
    "Se quiser que esta categoria apareça primeiro, o número deve ser “1”, e assim consecutivamente de acordo com a ordem.",
  tolTipBajaCategoria:
    "Ao ativar esta opção, a categoria selecionada deixará de aparecer no menu digital. A desativação de uma categoria também tornará invisíveis todos os produtos nela incluídos.",
  tolTipVerQr: "Acesse e baixe o código QR do seu cardápio",
  tolTipDisponibleProducto:
    "Marcar a disponibilidade do produto: Indica se o produto está disponível no cardápio.",
  tolTipIdiomaProducto:
    "Escolha o idioma no qual deseja que o produto também seja apresentado",
  tolTipOrdenProducto:
    "Escolha a ordem de exibição do produto dentro da categoria selecionada.",
  tolTipProductoDestacado:
    "Se selecionado, o produto aparecerá em destaque no início do cardápio. Destaque produtos especiais ou promoções.",
  tolTipBaja: "Este produto não será exibido no cardápio (se ativado).",
  tolTipDisponible:
    "Ative se o produto estiver disponível. Desative se o produto estiver 'Fora de estoque' (sem unidades).",
  tolTipImagenCarga:
    "Imagem exibida durante os segundos em que o cardápio carrega.",
  tolTipTituloDestacado:
    "Defina o texto que nomeará a seção de produtos em destaque. Ex: 'Sugestões do Chef', 'Nossos Top Vendas' ou 'Imperdíveis'.",
  tolTipIdiomaMateriaPrima:
    "Escolha o idioma no qual deseja que a matéria-prima também seja apresentada",
  guiaUsuario: "Guia do usuário",

  // 14/02/24
  pedidosPorRepartidores: "Pedidos por entregadores",
  nombreRepartidor: "Nome do entregador",
  cantidadDePedidos: "Quantidade de pedidos",

  // 13/02/2024
  herramientaControlStockControlComprasInventarios:
    "Ferramenta de controle de estoque, compras e inventário",
  fidelizacion: "Fidelização",
  cheerfy: "Cheerfy",
  plataformaGestionPromocionesClientes:
    "Plataforma de gestão de promoções de clientes",
  nuevaPromocion: "Nova promoção",
  noHayPromocionesEnEsteTpv: "Não há promoções neste TPV",
  tolTipDisponiblePromocion:
    "Marque a disponibilidade da promoção: indica se a promoção está disponível ou não.",
  promocion: "promoção",
  fechaCreacion: "Data de criação",
  activo: "Ativo",
  inactivo: "Inativo",
  borrarPromocion: "Excluir promoção",
  promociones: "Promoções",
  codigoPromocion: "Código da promoção",
  elCampoCodigoEsRequerido: "O campo código é obrigatório",
  deseaEliminarEstaPromocion: "Deseja excluir esta promoção?",
  siBorrarEstaPromocion: "Sim, excluir esta promoção",

  // 12/03/24
  basesFree: "Bases extras grátis",
  extrasFree: "Bases / Extras grátis",
  tooltipBaseExtra:
    "Se a base estiver ativada, não soma extra grátis. Se o extra estiver ativado, não contará como grátis ao ser adicionado.",

  // 09/04/24
  permisoControlModulos:
    "Desculpe. Este negócio não possui este módulo ativado.",
  calcularCosteTodosLosProductos: "Calcular custo de todos os produtos",
  trabajarSinIva: "Trabalhar sem IVA",
  filtrarPorAgencias: "Filtrar por agência",
  seleccioneLaTarifaParaMostrarSuNombre:
    "Selecione a tarifa para mostrar seu custo",
  conIVA: "Com IVA",
  calcular: "Calcular",
  productosIncluidosConEsteMenu: "Produtos incluídos neste menu",
  abonarFacturaQr: "Pagar Fatura QR",
  deseasAbonarEstaFacturaQR: "Deseja pagar esta fatura QR?",
  abonarFactura: "Pagar fatura",

  exportar: "Exportar",
  codigoBarras: "Código de barras",
  codBarras: "C.Barras",

  // 18/08/24
  listadoTicketRepartidor: "Tickets por entregador",

  // WALLET
  passbooks: "Passbooks",
  sharePassbooks: "Compartilhar wallets",
  copyToClipboard: "Copiar para área de transferência",
  shareViaEmail: "Enviar por e-mail",
  shareViaWhatsapp: "Enviar via Whatsapp",
  copied: "Copiado para área de transferência",
  selectBusinessForWallet: "Escolha o negócio para enviar as Wallets",
  sendMethod: "Método de envio",
  share: "Enviar",
  sendAndSaveButton: "Sim, enviar e salvar",
  sendAndNoSaveButton: "Não, enviar e não salvar",
  titleSaveInfoModalText:
    "As informações do cliente mudaram. Deseja salvar estas informações?",
  verifyNumberText: "Verifique o telefone",
  verifyEmailText: "Verifique o e-mail",
  selectOption: "Selecione uma opção",
  clipboardCopied: "Copiado para área de transferência",
  clipboardFailedToCopy:
    "A API da área de transferência não está disponível neste navegador.",
  enviarWallet: "Enviar Wallet",
  confirmacionEnvioWallet: "Confirmação de envio de Wallet",
  confirmacionTextoEnviarWallet:
    "Tem certeza que deseja enviar a wallet para todos os clientes?",
  mensajeConfirmacion:
    "Esta ação não pode ser desfeita e só será enviada para clientes cujo e-mail esteja registrado e possuam código de barras.",
  enviar: "Enviar",
  noHayCorreosElectronicos: "Não há e-mails.",
  ningunClienteConCorreoElectronico:
    "Nenhum cliente possui e-mail configurado.",
  clientHasNoBarcode: "O cliente não possui um código de barras definido.",
  exportarCarta: "Exportar Carta",
  exportarSimplifiedExcel: "Exportar como Excel (Sem cabeçalhos)",

  // GESTIÓN DE IMPUESTOS
  taxes: "Impostos",
  tax: "Imposto",
  gestionImpuestos: "Gestão de Impostos",
  administracionTiposTasas: "Administração",
  administracionTiposTasasImpositivas: " de tipos e taxas de impostos",
  agregarImpuesto: "Adicionar Imposto",
  taxRate: "Imposto Aplicado",
  taxDescription: "Descrição",
  taxType: "Tipo de Imposto",
  taxBoldType: "impostos",
  impuestoAplicadoEsCero: "O imposto aplicado não pode ser menor que ",
  impuestoYaCreado: "Este imposto já existe e não pode ser criado novamente",

  // IMPORTAR CLIENTES
  previewClientData: "Pré-visualização de Clientes",
  editarCliente: "Editar cliente",
  importarData: "Importar dados",
  importandoDatos: "Importando dados",
  preview: "Pré-visualizar",
  importacionRealizada: "Importação realizada",
  datosImportados: "Os dados foram importados corretamente",
  confirmarImportacion: "Confirmar importação",
  seguroContinuarImportacion:
    "Tem certeza que deseja continuar? Esta ação é irreversível",

  // 18/11/24 - Update-Logo
  inserteImagen: "Insira uma imagem",
  seleccioneArchivoImagen: "Selecione um arquivo de imagem",
  archivoDemasiadoGrande:
    "O arquivo é muito grande. O tamanho máximo permitido é 5MB.",
  dimensionesExcedenLimite:
    "As dimensões da imagem excedem o limite permitido (2000x2000px).",
  mensajeconfirmacion:
    "Você está prestes a substituir a imagem existente. Deseja salvar?",
  botonGuardar: "Salvar",
  botonCancelar: "Cancelar",
  Guardado: "Salvo",
  guardarOvisualizarLogo: "Visualizar ou salvar logo",
  configurarLogoNegocio: "Configurar logo do negócio",
  seleccionLogo: "Clique para selecionar um logo",
  volver: "Voltar",
  noExisteLogoNegocio: "Não existe logo para o negócio.",
  informacion: "Informação: ",
  tamaño: "Tamanho: ",
  dimensiones: "Dimensões: ",
  restriccionesLogo: "Restrições do logo:",
  tamañoMaximo: "Tamanho máx: ",
  dimensionesMaximas: "Dimensões máx: ",

  // 13/12/24 - ProductosNoRelacionados
  mensajeAviso:
    "Tem certeza que deseja gerar automaticamente os PLUs? Este processo criará um código para cada produto e tarifa não configurados, e será salvo automaticamente.",
  mensajeAvisoSubProducto:
    "Tem certeza que deseja gerar automaticamente os PLUs? Este processo criará um código para cada matéria-prima não configurada e será salvo automaticamente.",
  generarPlu: "Gerar PLUs automaticamente",
  botonAceptar: "Aceitar",
  PLUsGenerados: "PLUs gerados com sucesso!",
  errorGenerandoPLUs: "Erro ao gerar PLUs",

  // 21/01/2025
  nosmudamos: "Mudamos-nos!",
  noscambiamosaselfi:
    "Seu negócio deu um grande passo: agora seu cardápio faz parte da família Selfibar. A partir de agora, todas as configurações e gestões relacionadas ao cardápio poderão ser feitas diretamente no Selfibar.",
  esteNegocioEsSelfi: "Este negócio é Selfibar",
  paraContinuar:
    "Para continuar, clique em Selfibar e acesse sua conta com seu usuário e senha",
  irASelfibar: "Ir para Selfibar",
  barcodeUnico: "Código de barras único",
  barcodeNecesarioSeActualizara:
    "O código de barras é necessário para esta ação e será atualizado para este cliente ao enviar ou copiar para a área de transferência.",
  emailenviado: "E-mail enviado",

  // ListadomateriaPrima-Proveedor
  // 14/01/25
  verListado: "Listagem de matérias-primas",
  listadoMateriaPrimaProveedor: "Listagem de matéria-prima por fornecedor",
  noTiene: "Não possui ",
  esteProveedor: " este fornecedor",
  precioAcordado: "Preço acordado com fornecedor",
  porcentajeAcordado: "Percentual acordado ",
  filtrarPorEtiqueta: "Filtrar por etiqueta: ",
  precioAcordadoGuardadoCorrectamente: "Preço fixado. Salvo com sucesso!",
  fijarprecio: "Fixar preço ",
  preciofijado: "(Fixar o preço da matéria-prima)",
  mensajePrecioFijado: "O preço da matéria-prima é de  ",
  explicacionFijarPrecio:
    "Ao ativar, o preço da matéria-prima e o percentual de desconto permanecerão fixos. Ao fazer uma nova despesa, nem o preço nem o desconto serão alterados.",
  porcentajeAcordado: "Percentual de aviso",
  porcentajeAcoradoGuardado: "Percentual acordado. Salvo com sucesso!",
  losSubproductosSeHanIncrementado:
    "Foi detectado um aumento no preço das seguintes matérias-primas em relação ao percentual acordado com o fornecedor",
  errorverificar: "Erro ao verificar",
  mensajeErrorVerificarTodo:
    "Foi detectado, nas seguintes despesas, um aumento no preço da matéria-prima em relação ao percentual acordado com o fornecedor",
  explicacionPorcentajeAcordado:
    "Este é o percentual acordado para o fornecedor, para controle do preço das matérias-primas ao registrar uma despesa.",
  generarBusinessHash: "Gerar URL para operadores",
  enlaceFicharTurnosOperario: "Acesso para registrar e consultar turnos",
  enlaceFicharTurnosOperarioDescripcion:
    "Os trabalhadores do negócio poderão fazer login com as mesmas credenciais do TPV para registrar início e fim de turno, além de consultar os últimos 14 turnos realizados junto com seus horários.",

  // KIOSKOS
  kioskos: "Quiosques",
  stockBreak: "Falta de estoque",
  kiosksMenu: "Quiosques do cardápio",
  barcode: "CÓDIGO DE BARRAS",

  sort: "Ordenar",
  productSorted: "Produto ordenado com sucesso",
  subproductSorted: "Matéria-prima ordenada com sucesso",
  categorySorted: "Categoria ordenada com sucesso",

  saldoAnterior: "SALDO ANTERIOR",
  saldoActual: "SALDO ATUAL",

  // 31/01/2025
  guardarOreplicar:
    "Este produto está em um cardápio. Deseja salvar as alterações do produto ou salvá-las e replicá-las no cardápio?",
  guardarYreplicar: "Salvar e replicar no cardápio",
  CrearProductoEnCarta: "Salvar e criar produto no cardápio",
  tienesProductosSinActualizar:
    "Você tem produtos e/ou matérias-primas no cardápio sem relacionar ou desativados no TPV",
  porFavorDirijaseADiagnosticoParaActualizar:
    "Por favor, vá para Cardápio Digital > Configuração do Cardápio > Diagnóstico > Diagnóstico para revisar os produtos e matérias-primas pendentes de atualização",
  irAdiagnosis: "Ir para Diagnóstico",
  realizarDespues: "Realizar depois",
  actualizarProductos: "Pendentes de revisão ",
  activoEnCarta: "Ativo no cardápio",
  activoEnTPV: "Ativo no TPV",
  relacionarProducto: "Relacionar produto do cardápio com TPV",
  editarProductoCarta: "Editar produto do cardápio",
  editarProductoTpv: "Editar produto TPV",
  editarMateriaPrimaCarta: "Editar matéria-prima do cardápio",
  editarMateriaPrimaTpv: "Editar matéria-prima TPV",
  sinErroresProductos:
    "Não foram encontrados erros potenciais nos produtos do cardápio",
  sinErroresMateriasPrimas:
    "Não foram encontrados erros potenciais nas matérias-primas do cardápio",

  // Sinqro refactor
  seleccionePrecioAgenciaSinqro: "Preço da agência que deseja sincronizar",
  iniciandoImportacion: "Iniciando importação",
  limpiandoSinqro: "Removendo registros do Sinqro",
  obteniendoCategorias: "Obtendo categorias",
  obteniendoProductos: "Obtendo produtos",
  obteniendoSubproductos: "Obtendo subprodutos",
  sincronizandoConSinqro: "Sincronizando com Sinqro",
  finalizandoSincro: "Finalizando sincronização",
  errorSincronizacion: "Erro ao sincronizar com Sinqro",
  estamosTrabajandoEnEllo: "Estamos trabalhando nisso, por favor aguarde...",
  creandoCategoriasSinqro: "Criando categorias no Sinqro",
  errorSincronizacionPruebeOtraVez:
    "Erro ao sincronizar com Sinqro. Por favor, tente novamente.",
  losentimos: "Lamentamos!",
  estamosPreparandoTuCarta: "Estamos preparando seu cardápio",
  borrandoCartasObsoletas: "Removendo cardápios obsoletos",
  creandoCarta: "Criando cardápio no Sinqro",
  ultimoPasoCasiTerminado: "Último passo, estamos quase terminando",

  exportarPdfSinDesglose: "Exportar como PDF (Sem Detalhes)",
  exportarPdfConDesglose: "Exportar como PDF (Detalhado)",
  exportarExcelSinDesglose: "Exportar como Excel (Sem Detalhes)",
  exportarExcelConDesglose: "Exportar como Excel (Detalhado)",

  // 14/07/2025
  replicarPLUs: "Replicar PLUs",
  pluReplicadosExitosamente: "PLUs replicados com sucesso",
  replicarPLUPRod: "Replicar PLUs de produtos em TPVs",
  replicarPLUSubPRod: "Replicar PLUs de matérias-primas em TPVs",
  replicarPLUsaBusinesses: "Replicar PLUs de produtos em negócios",
  replicarPLUaBusinesses: "Replicar PLU de matérias-primas em negócios",
  noSeActualizoNingunProducto: "Nenhum produto foi atualizado",
  productosActualizadosCorrectamente: "Produto atualizado com sucesso",

  importarExcelTarjetas: "Importar Excel Cartões",
  importarTarjetas: "Importar Cartões",
  editarTarjeta: "Editar Cartão",
  previewTarjetasData: "Pré-visualização de Cartões",

  estaSeguroPLU: "Tem certeza que deseja replicar o PLU?",
  conEstaAcciónPLU:
    "Com esta ação, o PLU será replicado em todos os negócios selecionados.",

  porDiaNatural: "por dia natural",
  actualizados: "Atualizados",
  conErrores: "Com Erros",
  estasSeguro: "Tem certeza?",
  conEstaAccionPLUTpvs:
    "Com esta ação, o PLU será replicado em todos os TPVs relacionados a este negócio",
  advertenciaPLUTexto1Prod:
    "Este processo de replicação de PLUs entre negócios utiliza o nome do produto para funcionar.",
  advertenciaPLUTexto2Prod:
    "Se houver nomes duplicados em produtos, este processo não poderá ser realizado para eles.",
  advertenciaSubPLUTexto1:
    "Este processo de replicação de PLUs de matérias-primas utiliza o nome da matéria-prima para funcionar.",
  advertenciaSubPLUTexto2:
    "Se houver nomes duplicados em matérias-primas, este processo não poderá ser realizado para eles.",

  advertenciaPLUsDuplicadosProductos:
    "⚠️ PLUs de produtos com nomes duplicados não puderam ser replicados porque o nome é usado como referência neste processo.",
  advertenciaPLUsDuplicadosSubproductos:
    "⚠️ PLUs de subprodutos com nomes duplicados não puderam ser replicados porque o nome é usado como referência neste processo.",

  productosActualizadosResumen: "Produtos Atualizados",
  productosNoEncontradosResumen: "Produtos Não Encontrados",
  productosSinCambiosResumen: "Produtos Sem Alterações",

  subproductosActualizadosResumen: "Subprodutos Atualizados",
  subproductosNoEncontradosResumen: "Subprodutos Não Encontrados",
  subproductosSinCambiosResumen: "Subprodutos Sem Alterações",

  seRepite: "se repete",

  ordenarProductosAlfabeticamenteDesc:
    "Ordenar produtos alfabeticamente de forma ascendente.",
  ordenarMateriasPrimasAlfabeticamenteDesc:
    "Ordenar matérias-primas alfabeticamente de forma ascendente.",
  configurarFechaCaducidadFacturas: "Data de vencimento das FATURAS QR",
  configurarFechaCaducidadFacturasDesc:
    "Configura o tempo que os clientes terão para pagar as FATURAS QR antes de vencerem.",
  configurarLogoNegocioDesc:
    "Configura o logo do negócio que será exibido nas faturas.",
  cambiarPreciosAProductosDesc: "Alterar preços de produtos em massa.",
  calcularCostoProductos: "Custo dos produtos",
  calcularCostoProductosDesc: "Calcular o custo dos produtos por TPV.",
  gestionAvanzadaHerramientas: "Gestão avançada de ferramentas",
  gestionAvanzadaHerramientasDesc:
    "Configuração avançada de impressoras, categorias e monitor de cozinha para seu negócio.",
  hora: "Hora",
  cancelaciones: "Cancelamentos",
  totalNeto: "Total Líquido",
  identificadorPostit: "Identificador Post-it",

  // VentasNegocios internationalization
  totalMesasPostit: "Total de Mesas de Post-it",
  noHayVentasDisponibles: "Não há vendas disponíveis para o plano selecionado",
  intentaSeleccionarOtroPlano:
    "Tente selecionar outro plano ou verifique os dados do período selecionado",
  loSentimos: "Lamentamos",
  esteNegocioNoCuentaConModulo: "Este negócio não possui este módulo ativado",
  mesasDePostit: "Mesas de Post-it",
  totalConsolidado: "Total Consolidado",
  totalMesa: "Total da Mesa",
  pagosaldo: "Pagamento de saldo",
  desgloseVentasPorMesasHoras: "Detalhamento de Vendas por Mesas e Horas",

  configurar: "Configurar",
  configurarLogoFacturas: "Logo das faturas",
  configurarFechaDeVencimientoDeFacturas:
    "Configurar data de vencimento das faturas",
  introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas:
    "Insira o número de dias para o vencimento das faturas.",
  datoInformativo:
    "Esta data não terá efeito no sistema, é apenas informativa para o cliente.",
  calcularCostoDeTodosLosProductos: "Calcular custo de todos os produtos",

  // Business Central
  summary: "Resumo de baixas de produtos",
  productDowngrades: "Foram encontradas baixas em produtos",
  subproductDowngrades: "Foram encontradas baixas em matérias-primas",
  totalDowngrades: "Total de baixas",
  totalAffectedRecipes: "Total de receitas afetadas",
  downgradedProducts: "Produtos desativados",
  downgradedSubproducts: "Matérias-primas desativadas",
  noRecipesAffected: "Nenhuma receita afetada",

  actualizar: "Atualizar",
  crear: "Criar",
  terminar: "Finalizar",

  departamentosSeleccionados: "Departamentos selecionados",

  seleccionarProducto: "Selecionar\nproduto",
  seleccionarDepartamentos: "Selecionar\ndepartamentos",
  completarCampos: "Preencher\ncampos",
  asignarMateriasPrimas: "Matérias\n-primas",
  seleccionaMateriasPrimasBusinessCentralAlertInfo:
    "Esta é a lista de matérias-primas vendáveis do Business Central pendentes de criação ou atualização no Numier. Seleciona a matéria-prima da lista para continuar. <strong>Tens {PRODUCT_LIST_LENGTH} matérias-primas pendentes.</strong>",
  seleccionaProductosBusinessCentralAlertInfo:
    "Esta é a lista de produtos do Business Central pendentes de criação ou atualização no Numier. Selecione o produto da lista para continuar. <strong>Você tem {PRODUCT_LIST_LENGTH} produtos pendentes.</strong>",
  seleccionaDepartamentosBusinessCentralAlertInfo:
    "<strong>Onde o produto {PRODUCT_NAME} deve estar disponível?</strong> Selecione os departamentos onde deseja que o produto {PRODUCT_NAME} esteja disponível.",
  completarCamposProductosBusinessCentralAlertInfo:
    "Em seguida, <strong>preencha os campos e tarifas</strong> de {PRODUCT_NAME}.",
  asignarMateriasPrimasProductosBusinessCentralAlertInfo:
    "Foram detetadas as seguintes matérias-primas para <strong>{PRODUCT_NAME}</strong>. Estas serão adicionadas automaticamente ao produto ao finalizar o processo.",
  estasMateriasPrimasSeAnadiranAlProducto:
    "Foram detetadas as seguintes matérias-primas para <strong>{PRODUCT_NAME}</strong>. Estas serão adicionadas automaticamente ao produto ao finalizar o processo.",
  completarTarifasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME} pode ter diferentes categorias, IVA e preços dependendo do departamento</strong>. Por exemplo, um preço de 2,50€ para a Tarifa 1 no Departamento 1 e 3,00€ no Departamento 2. Se a opção de replicar valores estiver marcada e você inserir um valor, a coluna inteira será preenchida com esse valor.",
  CategoriayTarifasPorDepartamento: "Categoria, IVA e Tarifas por departamento",
  replicarValoresTarifasEnTodaLaColumnaCheckbox:
    "Replicar valores de tarifa em toda a coluna",
  sincronizado: "sincronizado",
  swalSalirFromProductosBusinessCentralTitle: "Antes de continuar...",
  swalSalirFromProductosBusinessCentralText:
    "Se sair agora, você perderá o progresso atual.",
  swalSalirFromProductosBusinessCentralButtonConfirm: "Sim, sair",
  swalCamposObligatoriosFromProductosBusinessCentralText:
    "Você deve preencher todos os campos marcados com *",
  swalNombreProductoObligatorioFromProductosBusinessCentralText:
    "Nome do produto",
  swalColorObligatorioFromProductosBusinessCentralText: "Cor do botão",
  swalCategoriaObligatorioFromProductosBusinessCentralText:
    "Categoria em cada departamento",
  swalTipoIvaObligatorioFromProductosBusinessCentralText:
    "IVA em cada departamento",
  noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos:
    "Os valores dos códigos de barras não podem coincidir entre formatos diferentes.",
  swalYaExisteUnProductoConEseCodigoDeBarras:
    "Já existe um produto com este código de barras.",

  swalProductoSincronizadoTitle: "Produto sincronizado!",
  swalProductoSincronizadoTextNPendientes:
    "Deseja continuar sincronizando produtos ou prefere finalizar por enquanto?",
  swalProductoSincronizadoText0Pendientes:
    "Todos os produtos foram sincronizados.",
  swalProductoSincronizadoButtonSeguir: "Continuar sincronizando",
  swalProductoSincronizadoButtonTerminar: "Finalizar",
  swalProductoActualizadoTitle: "Produto atualizado!",
  swalProductoActualizadoText0Pendientes:
    "Todos os produtos foram atualizados.",
  swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText:
    'Falta preço de SUPLEMENTO (Tarifa 1) no departamento/TPV "{tpv}".',

  modalUnidadesMedidaTitle: "ℹ️ IMPORTANTE",
  modalUnidadesMedidaTextIntro:
    "{PRODUCT_NAME} possui {UD_COUNT} unidades de medida no Business Central ({UD_LIST}). Existem 2 opções:",
  modalUnidadesMedidaOpcionMultiples:
    "🔹 Criar {UD_COUNT} produtos → Ideal se forem matérias-primas diferentes (ex: Água BOT500ML e Água BOT1L são matérias-primas diferentes).",
  modalUnidadesMedidaOpcionUnico:
    "🔹 Criar 1 produto e usar até 4 tarifas → Melhor se for a mesma matéria-prima com quantidades diferentes (ex: usar tarifas 'Tapa' e 'Porção' da Salada).",
  modalUnidadesMedidaRecomendacion:
    "Recomendação: Se for a mesma base (ex: Salada em diferentes quantidades), use 1 produto. Se forem matérias-primas diferentes, crie {UD_COUNT} produtos.",
  modalUnidadesMedidaButtonMultiples: "Criar {UD_COUNT} produtos",
  modalUnidadesMedidaButtonUnico: "Criar 1 produto",

  modalConfirmarDatosTitle: "ℹ️ CONFIRME OS DADOS DO PRODUTO",
  modalConfirmarDatosIntro:
    "{PRODUCT_NAME} já havia sido sincronizado e salvo no Numier, mas foi modificado no Business Central.",
  modalConfirmarDatosExplicacion:
    "Agora, vamos carregar no formulário os dados que temos no Numier deste produto para que você confirme e clique em continuar se estiverem corretos.",
  continuar: "Continuar",

  cargandoListaProductos: "Carregando lista de produtos...",
  seHaDetectadoCambioUdmEsNecesarioActualizarPorFormato: "Foi detectada uma alteração nas unidades de medida. É necessário atualizar os preços por formato para esta nova unidade de medida.",
  productoYaCreadoMateriasPrimasIguales: "O produto já existe no Numier, por isso as matérias-primas serão as mesmas.",
  seHanDetectadoMasUdmQueSoportaNumierSeCrearanProductosIndividuales: "Foram detetadas mais unidades de medida no Business Central do que as suportadas pelo Numier. Serão criados produtos individuais para cada unidade de medida.",
  error: "Erro",
  serverError: "Ocorreu um problema ao se comunicar com o servidor",
  errorRecetasBC: "Não foi possível obter as receitas do Business Central.",
  erroresAddTipoMateriaPrima:
    "Você deve escolher o tipo de cada matéria-prima.",
  erroresAddTodasMateriasPrimas: "Você deve adicionar todas as matérias-primas",
  redirigidoIntegracionesBC:
    "Você foi redirecionado ao ponto de partida para confirmar que a empresa selecionada está correta.",
  redirigidoFaltanDatos:
    "Você foi redirecionado porque faltavam dados necessários.",
  unknownProduct: "Produto desconhecido",

  // BussinessCentral MateriasPrimas
  nombreMateriaPrima: "Nome da Matéria-Prima",
  descripcion: "Descrição",
  codigoDeBarra: "Código de Barras",
  seleccionaCategoria: "Selecione uma Categoria",
  seleccionaTipo: "Selecione um Tipo",
  precioCompraSinIva: "Preço de Compra (sem IVA)",
  baja: "Desativado",
  escandallo: "Escandallo",
  quieresSeguirSincronizando: "Deseja continuar sincronizando?",
  seguirSincronizando: "Continuar sincronizando",
  seleccionar: "Selecionar",
  materiaPrimaGuardada: "Matéria-prima salva!",
  seleccionarMateriaPrima: "Selecionar\nmatéria-prima",
  completarCamposMateriaPrima: "Preencher\ncampos e atribuir\nmatérias-primas",
  queQuieresHacerAhora: "Deseja continuar sincronizando matérias-primas?",
  seguirEditando: "Continuar editando",
  materiaPrimaSincronizadaCorrectamente:
    "Matéria-prima sincronizada com sucesso",
  estaMateriaPrimaTieneMateriasPrimasRelacionadasAlertInfo:
    "A matéria-prima <strong>{MATERIA_PRIMA_NAME}</strong> tem outras matérias-primas associadas. Adicione-as para completar a sincronização.",
  finalizar: "Finalizar",
  seleccionaLosDepartamentos: "Selecione os departamentos",
  noHayEtiquetasTPV: "Não há etiquetas para este POS",
  aniadir: "Adicionar",
  aniadirTodas: "Adicionar todas",
  listo: "pronto",
  errorDesconocido: "Erro desconhecido",
  nombreMateriaPrimaObligatorio: "O nome da matéria-prima é obrigatório.",
  submateriasPrimasObligatorio: "Deve adicionar todas as submatérias-primas.",

  actualizacionMateriaPrima: "Atualização de Matéria-Prima",
  mensajeCambioMateriaPrimaInfo:
    "Foram detectadas alterações nesta matéria-prima no Business Central.",
  antesContinuarMateriaPrimaInfo:
    "Antes de continuar, verifique os departamentos em que esta matéria-prima deve estar disponível, caso haja mudanças.",
  accionNecesariaMateriaPrimaInfo:
    "Esta ação é necessária para manter as informações atualizadas corretamente.",
  entendido: "Entendi",
  noVolverAMostrarEsteAviso: "Não mostrar este aviso novamente",
  cerrarYNoVolverAMostrar: "Fechar e não mostrar novamente",
  preferenciasGuardadas: "Preferências salvas com sucesso",
  errorAlGuardarPreferencias: "Erro ao salvar as preferências",
  seleccioneCategoria: "Selecione a categoria...",

  // Formulario combinado de productos
  precioRequerido: "Preço obrigatório",
  introduzcaPrecio: "Introduza o preço do suplemento",
  errorValidandoCodigosBarras: "Erro validando códigos de barras",
  asignaPreciosMateriasPrimas: "Asigne precios a las materias primas",
  rateNameRequired: "É obrigatório indicar o nome da tarifa nº: ",
  categoryRequiredForDept: "É obrigatório selecionar uma categoria para o departamento: ",
  validationError: "Erro de validação dos campos",
  pleaseFillRequiredFields: "Por favor, preencha todos os campos obrigatórios.",
  configuracionPorDepartamento: "Configuração por departamento",
  productoNormal: "Produto Normal",
  productoCON: "Produto COM",
  productoSUPL: "Produto SUPLEMENTO",
  esProductoCON: "É produto COM",
  esProductoSUPL: "É produto SUPLEMENTO",
  categoriaNormal: "Normal",
  categoriaCON: "COM",
  categoriaSUPL: "SUPL",
  suplemento: "SUPLEMENTO",
  mensajeProductoCON:
    "Você está criando um produto COM. 2 produtos serão gerados: um normal e um COM.",
  mensajeProductoSUPL:
    "Você está criando um produto SUPLEMENTO. 2 produtos serão gerados: um normal e um SUPLEMENTO.",
  mensajeProductosCONySUPL:
    "Você está criando produtos COM e SUPLEMENTO. 3 produtos serão gerados: um normal, um COM e um SUPLEMENTO.",
  completeCamposObligatorios:
    "Por favor, preencha todos os campos obrigatórios.",
  completeNombreProductoCON: "Por favor, insira o nome para o produto COM.",
  completeNombreProductoSUPL:
    "Por favor, insira o nome para o produto SUPLEMENTO.",
  productosGuardadosCorrectamente: "Produtos salvos com sucesso.",
  errorAlGuardarProductos: "Ocorreu um erro ao salvar os produtos.",

  dataNegocioVisualizar: "Departamentos",
  formaPagoFiltrado: "Filtrar por forma de pagamento",
  fechaExportacionDisponible: "Data de exportação detectada",
  todasLasFormasPago: "Todas as formas de pagamento",
  seleccioneSubtipoFormaPago:
    "Por favor, selecione um tipo específico de pagamento (como Visa, Mastercard ou cheque).",
  noCambiosFormaPago: "Não houve alterações na forma de pagamento",
  finalizarProcesoActualizar:
    "Finalizar processo de atualização da matéria-prima",
  actualizarFinalizarText:
    "Para completar o processo e atualizar corretamente a matéria-prima, clique no botão 'Atualizar e finalizar' abaixo.",
  cambiosDepartamentosMateriaPrimaInfo:
    "Se houver alterações nos departamentos onde esta matéria-prima deve estar ativa — seja para adicionar ou remover — essas mudanças serão aplicadas automaticamente durante a atualização.",
  actualizarFinalizar: "Atualizar e finalizar",
  verDetallesFormaPago: "Ver detalhes da forma de pagamento",
  detallesFormaPago: "Detalhes da forma de pagamento",
  formaDePago: "Forma de pagamento",
  medioDePago: "Meio de pagamento",
  medioPagoFiltrado: "Filtrar por meio de pagamento",
  advertenciaExportacionVentas: "Aviso sobre exportação de vendas",
  seExportaranTodosLosDepartamentos:
    "As vendas de TODOS os departamentos serão exportadas",
  advertenciaExportacionTodosLosDepartamentos:
    "Ao continuar, serão exportadas as vendas de todos os departamentos, incluindo suas formas de pagamento, não apenas as do departamento atual.",
  noHayVueltaAtras:
    "Uma vez realizada a exportação, não será possível desfazer.",
  reviseYEditeFormasPagoAntes:
    "Revise e edite as formas de pagamento antes de prosseguir.",
  eleccionModoExportacion: "O modo de exportação apenas define se as vendas serão enviadas em lotes ou todas juntas. Em qualquer caso, serão enviadas as vendas de todos os pontos de venda.",
  estaSeguroDeExportar: "Tem certeza de que deseja continuar com a exportação?",
  todosLosMediosPago: "Todos os meios de pagamento",
  tpv: "TPV",
  department: "Departamento",
  department: "Departamento",
  productoEspecialDetectado: "Produto especial detectado",
  productoEspecialDetectadoMensaje: "Um produto especial foi detectado.",
  seCrearanTresProductos: "Serão criados {cantidad} produtos no Numier: um normal, um COM e um SUPLEMENTO.",
  seCrearanDosProductosCon: "Serão criados {cantidad} produtos no Numier: um normal e um COM.",
  seCrearanDosProductosSuplemento: "Serão criados {cantidad} produtos no Numier: um normal e um SUPLEMENTO.",
  relleneFormularios: "Por favor, preencha os formulários correspondentes abaixo.",
  categoriaEnlazada: "Categoria vinculada",
  dadoDeBaja: "Inativo",
  refrescar: "Atualizar",
  errorAlRefrescar: "Não foi possível atualizar os dados. Tenta de novo.",
  sinPermisoExportacionBC: "Não tens permissão para aceder à exportação de vendas para o Business Central. Fala com o teu administrador.",
  productoDeBajaTitulo: "Produto inativo",
  productoDeBajaTexto: "Este produto está inativo e não pode ser adicionado como prato do menu. Ativa-o no Business Central e sincroniza de novo: o Numier vai reativá-lo na próxima sincronização.",
  categoriaFijadaPorTipo: "Definida pelo tipo {TIPO}",
  categoriaFijadaPorTipoAviso: "A categoria não pode ser escolhida: um {TIPO} é sempre criado na categoria que tem no negócio de origem. Se não existir no destino, é criada.",
  sinNegociosParaReplicar: "Não há nenhum outro negócio disponível para replicar este produto.",
  negocioSinCategorias: "Sem categorias criadas",
  resultadoReplicacion: "Resultado da replicação",
  replicados: "Replicados",
  replicaFamiliaAviso: "Este produto faz parte de uma família. Serão replicados:",
  replicaTipoDetectado: "Tipo de produto detetado:",
  productosPorNegocio: "produtos por negócio",
  faltaCategoriaEnNegocios: "Seleciona uma categoria nestes negócios:",
  seleccionaAlMenosUnNegocio: "Seleciona pelo menos um negócio.",
  seleccionaPreviamenteCategoria: "Selecione previamente uma categoria",

  // Producto solo con/suplemento
  crearProductoSinNormal: "Criar produto normal como inativo",
  crearProductoSinNormalExplicacion: "Se ativares esta opção, o produto normal será criado mas com estado 'inativo'. Isto é útil quando o produto só faz sentido vender como COM ou SUPLEMENTO, pois não será vendido como um produto individual por si só. Só estará visível no POS se o ativares manualmente.",
  crearProductoSinNormalDetalle: "O produto normal será sempre criado, mas com esta opção ativada aparecerá desativado. Os produtos COM e SUPLEMENTO estarão ativos para uso imediato.",
  crearProductoSinNormalImportante: "IMPORTANTE: Deverás selecionar uma categoria obrigatoriamente antes de marcar esta caixa, pois é requerida para manter a integridade dos dados mesmo que o produto esteja inativo.",
  productoNormalOculto: "Produto normal oculto",
  productoNormalOcultoExplicacion: "Este formulário está oculto porque o produto normal será criado como inativo",
  activarProducto: "Ativar produto",

  // Business Central - Exportación de ventas
  exportacionVentasBC: "Exportar vendas",
  noHayDiasParaExportar: "Não há dias para exportar",
  dailyExportCardTitle: "Exportação diária de vendas",
  dailyExportCardSubtitle: "Revise as vendas e exporte para o Business Central",
  todoExportadoCorrectamente:
    "Todas as vendas foram exportadas com sucesso ou não existem vendas para este departamento.",
  hayVentasPendientesExportar: "Existem vendas pendentes de exportação.",
  debesExportarPrimeroDiasAnteriores:
    "Você deve exportar primeiro os dias anteriores para manter a correlação.",
  fechaExportacion: "Data de exportação",
  formapago: "Forma de pagamento",
  noPuedeCambiarFechaSinExportarPrimero:
    "Não é possível exportar uma nova data sem antes exportar o dia mais antigo pendente.",
  trabajador: "Funcionário",
  exportData: "Exportar vendas",
  exportacionExitosa: "A exportação foi realizada com sucesso",
  errorExportarDatos: "Erro ao exportar os dados",
  falloExportarDatos: "Falha ao exportar os dados",
  exportacionRealizada: "Exportação realizada",
  exportacionRealizadaParcial: "Exportação realizada parcialmente",
  exportacionExitosaConErrores: "A exportação foi realizada com sucesso com alguns erros",
  editarFormaPago: "Editar forma de pagamento",
  noExistenDatosNoPudieronCargar:
    "Não existem dados ou não puderam ser carregados",
  mensajeEfectivoSeleccionado:
    "Foi selecionado dinheiro como forma de pagamento. Não é necessário fornecer mais detalhes.",
  guardarFormaPago: "Salvar forma de pagamento",
  tipoFormaPago: "Tipo de forma de pagamento",
  seleccioneUnTipo: "Selecione um tipo",
  formaPagoTarjeta: "Forma de pagamento com cartão",
  formaPagoCheque: "Forma de pagamento com cheque",
  updatePagoCorrecto: "Forma de pagamento atualizada com sucesso",
  noSePudoActualizarFormaPago:
    "Não foi possível atualizar a forma de pagamento",
  errorAlGuardarFormaPago: "Erro ao salvar a forma de pagamento",
  noHayVentasConEstaFormaPago: "Não há vendas com esta forma de pagamento",
  formaPagoNoEncontrada:
    "Forma de pagamento não detectada para este departamento",
  totalCash: "Total dinheiro",
  totalCard: "Total cartão",
  totalCheque: "Total cheque",
  totalPagosaldo: "Total pagamento saldo",
  totalAvanzado: "Total avançado",
  avanzadoEfectivo: "Avançado dinheiro",
  avanzadoTarjeta: "Avançado cartão",
  avanzadoCheque: "Avançado cheque",
  avanzadoPagosaldo: "Avançado pagamento saldo",
  avanzadoOtros: "Avançado outros",
  cashPaymentMethod: "Forma de pagamento em dinheiro",
  cardPaymentMethod: "Forma de pagamento cartão",
  chequePaymentMethod: "Forma de pagamento cheque",
  importeTotal: "Valor total",
  sinDatos: "SEM DADOS",

  // Integración Business Central > Business Central
  businessCentral: "Business Central",
  sincronizacionBusinessCentralSubtitle:
    "Sincronização de produtos, departamentos e mais em tempo real",
  sincronizaMateriasPrimasBusinessCentralSubtitle:
    "Você tem <strong>{MATERIAS_PRIMAS_LENGTH}</strong> matérias-primas pendentes de atualização",
  noHayParaActualizar: "Não há nada pendente de atualizar ou sincronizar",
  obteniendoDatos: "A obter dados...",
  relacionesProcesadas: "Relações processadas",
  exportacionDeshabilitada: "Exportação desativada",
  sincronizaProductosBusinessCentralSubtitle:
    "Você tem <strong>{NUMERO_PRODUCTOS_PENDIENTES}</strong> produtos pendentes de sincronização",
  sincronizaFormasDePagoBusinessCentralSubtitle:
    "Você tem <strong>{NUMERO_FORMAS_PAGO_PENDIENTES}</strong> formas de pagamento pendentes de sincronização",
  productoFormCompleto: {
    info: "Edição de produto: {productName}",
  },
  completaProductosBussinessCentralSubtitle:
    "Complete primeiro a sincronização das matérias-primas para começar com os produtos",

  seleccionaMateriaPrimaBusinessCentralAlertInfo:
    "Esta é a lista de matérias-primas do Business Central pendentes de criação ou atualização no Numier. Selecione a matéria-prima da lista para continuar. <strong>Você tem {PRODUCT_LIST_LENGTH} matérias-primas pendentes.</strong>",
  seleccionaDepartamentosMateriasPrimasBusinessCentralAlertInfo:
    "<strong>Onde a matéria-prima {PRODUCT_NAME} deve estar disponível?</strong> Selecione os departamentos onde deseja que {PRODUCT_NAME} esteja disponível.",
  completarCamposMateriasPrimasBusinessCentralAlertInfo:
    "Para finalizar, preencha os campos de {PRODUCT_NAME}.",
  materiaPrimaDisabledByPendingsChildrenTooltip:
    "Esta matéria-prima é uma receita cujas matérias-primas ainda estão pendentes de sincronização.",

  swalMateriaPrimaSincronizadaTitle: "Matéria-prima sincronizada!",
  swalMateriaPrimaSincronizadaTextNPendientes:
    "Deseja continuar sincronizando matérias-primas ou prefere finalizar por enquanto?",
  swalMateriaPrimaSincronizadaText0Pendientes:
    "Todas as matérias-primas foram sincronizadas.",
  swalMateriaPrimaSincronizadaButtonSeguir: "Continuar sincronizando",
  swalMateriaPrimaActualizadaTitle: "Matéria-prima atualizada!",
  swalMateriaPrimaActualizadaText0Pendientes:
    "Todas as matérias-primas foram atualizadas.",

  // Integración Business Central > Empty entidades pendientes
  esteNegocioNoTieneProductosParaSincronizar: "Todos os produtos sincronizados",

  // Integración Business Central > Formas de pago
  formasDePagoBC: "Formas de pagamento",
  swalTipoObligatorioFormasDePago:
    "Você deve selecionar um tipo para cada forma de pagamento antes de finalizar.",
  formasDePagoBusinessCentralAlertInfo:
    "Relacione as formas de pagamento do Business Central com as formas de pagamento (tipos) Dinheiro, Cartão ou Cheque do Numier. <strong>Só é possível selecionar um único tipo como Dinheiro, os restantes como Cartão e Cheque.</strong>",
  noHayFormasDePagoPorConfigurar:
    "Não há formas de pagamento pendentes para configurar.",
  formasDePagoConfiguradasCorrectamente:
    "Todas as formas de pagamento foram configuradas corretamente.",
  formaPagoGuardada: "Formas de pagamento guardadas!",
  todasFormasPagoConfiguradas:
    "Todas as formas de pagamento foram configuradas",
  formasPagoDarDeBajaMensaje:
    "Os seguintes métodos de pagamento devem ser desativados no Numier porque já não estão disponíveis no sistema Business Central",
  pulsaDarDeBaja: "Clique em desativar para confirmar",
  darDeBaja: "Desativar",
  dandoDeBajaFormasPago: "Desativando métodos de pagamento...",
  formasPagoDadasDeBaja: "Métodos de pagamento desativados corretamente.",
  errorDarDeBajaFormasPago: "Erro ao desativar métodos de pagamento.",
  errorServidorDarDeBaja: "Erro ao comunicar com o servidor ao desativar.",

  // Verifactu Dashboard
  verifactu: "VERI*FACTU",
  verifactu2: "Verifactu",
  declaracionesResponsables: "Declarações responsáveis",
  conectaNumierConHacienda: "Conecta o Numier à Autoridade Tributária em apenas alguns cliques.",
  solicitar: "Solicitar",
  esperandoRespuestaNumier: "Aguardando resposta do Numier",
  seleccionarCertificado: "Selecionar certificado.",
  enviarCertificado: "Enviar certificado.",
  subeTuCertificadoParaConectarConHacienda: "Carrega o teu certificado para ligar o teu negócio à Autoridade Tributária.",
  seleccionarArchivo: "Selecionar ficheiro.",
  ustedYaHaGuardadoElCertificadoDigital: "Já guardaste corretamente o certificado digital neste negócio.",

  paraComenzarVerifactuSeleccionaNegocio: "Para começar com o VERI*FACTU, por favor <strong>seleciona um negócio</strong> na lista abaixo.",
  bienvenidoA: "Bem-vindo a",
  verifactuDescripcion: "<strong>Verifactu</strong> é o sistema da Agência Tributária (AEAT) que permite a verificação automática de faturas, garantindo a sua autenticidade e integridade perante a Autoridade Tributária.",
  informacionSobreVerifactu: "Informação sobre VERI*FACTU",

  importanteEmpresasSII: "Importante: Empresas inscritas no SII",
  siTuEmpresaEstaAdscritaSII: "Se a tua empresa está inscrita no Sistema de Fornecimento Imediato de Informação (SII), está isenta de utilizar o VERI*FACTU.",
  masInformacionAqui: "Mais informações aqui",

  automatizacionInteligente: "Automatização Inteligente",
  automatizacionInteligenteDesc: "Verificação automática de faturas sem intervenção manual. O sistema processa e valida cada documento instantaneamente.",
  automatizacionInteligenteDetalle: "Poupa até 8 horas semanais de trabalho manual",
  automatizacionInteligenteStat: "100% Automático",

  cumplimientoNormativo: "Conformidade Legal",
  cumplimientoNormativoDesc: "Total conformidade com as normas fiscais. Atualização automática conforme alterações legislativas.",
  cumplimientoNormativoDetalle: "Compatível com todos os regulamentos AEAT em vigor",
  cumplimientoNormativoStat: "Conforme AEAT",

  controlDeCalidad: "Controlo de Qualidade",
  controlDeCalidadDesc: "Elimina erros humanos e previne fraudes através da validação avançada de dados.",
  controlDeCalidadDetalle: "Deteção automática de inconsistências e anomalias",
  controlDeCalidadStat: "-95% Erros",

  seguridadAvanzada: "Segurança Avançada",
  seguridadAvanzadaDesc: "Máxima proteção em todas as tuas transações com encriptação de nível bancário.",
  seguridadAvanzadaDetalle: "Certificados SSL e autenticação de dois fatores",
  seguridadAvanzadaStat: "Encriptação SSL",

  configuracionDeVerifactu: "Configuração do Verifactu",
  paraComenzarNecesitasCertificado: "Para começar a trabalhar com o VERI*FACTU, precisas de carregar o teu <strong>certificado digital.</strong>",
  certificadoPermiteAutenticacion: "Este certificado permite a autenticação segura com a AEAT.",
  formatosSoportados: "Formatos suportados: <code>.pfx</code>, <code>.p12</code>.",
  aunNoTienesCertificado: "Ainda não tens certificado digital?",
  puedesObtenerCertificadoEn: "Podes obter o teu certificado digital em:",
  fabricaNacionalMonedaTimbre: "Casa da Moeda (FNMT)",
  yaTienesCertificadoListo: "Já tens o teu certificado digital pronto?",
  hazClickAbrirSelector: "Clica aqui para abrir o seletor de ficheiros.",
  tengoUnCertificado: "Tenho um certificado",
  hazClickSeleccionarCertificado: "Clica e seleciona o teu certificado",
  formatosMaximo: "Formatos: .pfx, .p12 (máx. 60KB)",
  subirCertificado: "Carregar certificado",
  debeSeleccionarFechaInicioVerifactu: "Deves selecionar uma data de início para o VERI*FACTU antes de continuar.",
  porFavorSeleccionaFechaInicioNuevamente: "Foi encontrado um erro. Por favor, seleciona a data de início novamente.",
  porFavorSeleccionaCertificadoNuevamente: "Por favor, selecione o certificado novamente.",

  certificadoConfiguradoCorrectamente: "Certificado Configurado com Sucesso!",
  certificadoValidadoConfigurado: "O teu certificado digital foi validado e configurado.",
  certificadoValidoHasta: "Certificado válido até",
  noSeHaPodidoVerificarFecha: "Não foi possível verificar a validade do certificado",
  facturasComplianNormativa: "As tuas faturas cumprem a norma VERI*FACTU.",
  sistemaListoVerificacion: "Sistema pronto para verificação automática.",
  comoFuncionaVerifactu: "Como funciona o VERI*FACTU?",

  generacionAutomatica: "Geração Automática",
  generacionAutomaticaDesc: "As faturas serão geradas automaticamente com o formato e requisitos do VERI*FACTU",

  codigoQRenTickets: "Código QR nos Talões",
  codigoQRenTicketsDesc: "Cada talão incluirá um código QR para verificar a fatura no portal da AEAT",

  comprobacionInstantanea: "Verificação Instantânea",
  comprobacionInstantaneaDesc: "O estado de cada fatura pode ser verificado ao digitalizar o QR em qualquer dispositivo",

  seguridadGarantizada: "Segurança Garantida",
  seguridadGarantizadaDesc: "Todas as transações são registadas e protegidas com assinatura eletrónica avançada",

  contrasenaCertificado: "Palavra-passe do Certificado",
  introduceContrasenaDesc: "Por favor, introduz a palavra-passe do teu certificado digital para processá-lo corretamente.",
  contrasena: "Palavra-passe:",
  introduceContrasenaPlaceholder: "Introduz a palavra-passe do certificado",
  contrasenaRequerida: "A palavra-passe é obrigatória",
  procesando: "A processar…",
  continuar: "Continuar",
  cancelar: "Cancelar",

  exito: "Sucesso",
  seleccionaArchivoAntes: "Por favor, seleciona um ficheiro antes de enviar.",
  errorNegocioNoValido: "Erro: Nenhum negócio válido selecionado.",

  // Textos para negocio exento
  negocioExentoVerifactu: "Negócio Isento de VERI*FACTU",
  negocioRegistradoComoExento: "Este negócio está registado como isento do VERI*FACTU.",
  noRequiereVerifactu: "Não requer certificado nem configuração adicional.",
  facturacionNormalContinua: "A tua faturação continuará a funcionar normalmente.",
  queSignificaExento: "O que significa isto?",
  queSignificaExentoDesc: "O teu negócio não precisa de cumprir os requisitos do VERI*FACTU. Isto pode dever-se ao facto de estar inscrito no SII ou cumprir outros critérios de isenção definidos pela lei fiscal.",
  siHayAlgunError: "Ocorreu algum erro?",
  siHayAlgunErrorDesc: "Se achas que esta classificação está incorreta ou tiveste algum problema, contacta a nossa equipa de suporte para te ajudarmos.",
  noSePudoObtenerIdUsuario: "Não foi possível obter o ID do utilizador.",
  verificandoCertificado: "A verificar certificado...",
  certificadoEnviadoCorrectamente: "Certificado enviado com sucesso",
  respuestaInesperadaServidor: "Resposta inesperada do servidor",

  verifactuError449: "Palavra-passe incorreta ou ficheiro inválido.",
  verifactuError552: "Ocorreu um erro inesperado. Por favor, tenta novamente.",
  errorAlEnviarCertificado: "Erro ao enviar o certificado",
  noSeRecibioRespuestaServidor: "Não foi recebida resposta do servidor",
  errorDeConfiguracion: "Erro de configuração:",
  noSeSeleccionoArchivo: "Nenhum ficheiro selecionado.",
  formatoArchivoNoValido: "Formato de ficheiro inválido. Usa .pfx ou .p12",
  archivoDemasiadoGrande: "O ficheiro é demasiado grande. Tamanho máximo permitido: 60KB",

  // Selector de fecha de inicio Verifactu
  cuandoDebeComenzarTuNegocio: "Quando deve o teu negócio começar com o VERI*FACTU?",
  antesDeConfigurarDebesIndicar: "Antes de configurar o VERI*FACTU, deves indicar a data obrigatória de início conforme o tipo de negócio.",
  consultarInformacionOficial: "Consultar informação oficial",
  paraContribuyentesSociedades: "Para contribuintes do Imposto sobre Sociedades",
  restoNegociosAutonomos: "Restantes negócios e trabalhadores independentes. Para facilitar a adaptação ao novo sistema.",
  miNegocioAdscritoSII: "O meu negócio está inscrito no Sistema de Informação Imediata",
  estoyExentoSII: "Estou isento (SII)",
  seleccionar: "Selecionar",
  fechaInicioSeleccionada: "Data de início selecionada",
  exentoSII: "Isento (SII)",
  cambiar: "Alterar",
  negocioExentoVerifactu: "Negócio isento de VERI*FACTU",
  tuNegocioNoRequiereVerifactu: "O teu negócio não requer configuração do VERI*FACTU por estar inscrito no SII.",
  alEstarEnSIINoNecesitas: "Por estar no SII, não precisas de implementar o VERI*FACTU",
  confirmacionExencionSII: "Confirmação de isenção SII",
  antesDeConfirmar: "Antes de confirmar, certifica-te de que:",
  miNegocioEstaAdscritoSistemaInmediato: "O meu negócio está inscrito no Sistema de Informação Imediata (SII)",
  tengoDocumentacionQueLoAcredita: "Tenho documentação que o comprova",
  entiendoQueNoDebereUsarVerifactu: "Compreendo que não devo usar o VERI*FACTU se estiver no SII",
  siNoEstasSegurotConsultaAsesor: "Se não tens a certeza, consulta o teu contabilista ou consultor fiscal",
  confirmarExencion: "Confirmar isenção",
  negocioMarcadoComoExento: "Negócio marcado como isento de VERI*FACTU",
  errorAlMarcarExencion: "Ocorreu um erro ao marcar a isenção. Por favor, tenta novamente mais tarde.",

  certificadoExpiradoAlerta: "<strong>Atenção:</strong> O certificado digital deste negócio <strong>expirou</strong>. Deves renová-lo urgentemente para manter a conformidade com o VERI*FACTU.",
  certificadoProximoExpirarAlerta: "<strong>Aviso:</strong> O certificado digital deste negócio está <strong>prestes a expirar</strong>. Recomendamos que o renoves em breve para evitar interrupções.",
  certificadoExpirado: "Certificado Expirado",
  certificadoProximoExpirar: "Certificado Prestes a Expirar",
  certificadoExpiroEl: "O certificado expirou em",
  certificadoExpiraEl: "O certificado expira em",
  certificadoYaNoValido: "O certificado digital já não é válido. É necessário renová-lo urgentemente.",
  certificadoProntoVencera: "O certificado digital vai expirar em breve. Recomenda-se renovação o quanto antes.",
  sinCertificadoNoEsPosibleVerificar: "Sem um certificado válido, não é possível realizar a verificação automática de faturas.",
  EsperarAExpiracionPuedeProvocarErrores: "Não renovar a tempo pode provocar erros na verificação automática.",
  pongaseEnContactoConSoporteParaProceder: "Se ocorrer algum erro, contacta o suporte para saber como proceder.",
  renovarCertificado: "Renovar Certificado",

  // unidades de medida dadas de baja
  unidadesMedidaDadasDeBaja: "Foram encontradas desativações de produtos",
  bajasDeProductos: "Desativações de produtos",

  // 21/05/2025 - Listado productos por operario
  listadoDeProductosPorOperario: "Venda de produto por operador",
  listadoProductosOperario: "Venda por operador",

  // 29/10/2025 - Bajas
  bajaEntidades: "Baixas de entidades",
  checkBajaEntidades: "Visualize e aplique exclusões de entidades excluídas no Business Central",

  bajaProductos: "Baixas de produtos",
  bajaSubproductos: "Baixas de matérias-primas",
  bajaFormasPago: "Baixas de formas de pagamento",
  bajaUdMedida: "Baixas de unidades de medida",
  bajaLineaProd: "Baixas de linhas de produto",

  checkBajaProductos: "Consultar baixas de produtos",
  checkBajaSubproductos: "Consultar baixas de matérias-primas",
  checkBajaFormasPago: "Consultar baixas de formas de pagamento",
  checkBajaUdMedida: "Consultar baixas de unidades de medida",
  checkBajaLineaProd: "Consultar baixas de linhas de produto",

  loadingBajaProductos: "Consultando baixas de produtos...",
  loadingBajaSubproductos: "Consultando baixas de matérias-primas...",
  loadingBajaFormasPago: "Consultando baixas de formas de pagamento...",
  loadingBajaUdMedida: "Consultando baixas de unidades de medida...",
  loadingBajaLineaProd: "Consultando baixas de linhas de produto...",

  emptyBajaUdMedida: "Não foram encontradas unidades de medida desativadas.",
  errorUnidadMedidaNoConfigurada: "Não se pode criar o produto porque não tem unidade de medida configurada desde Business Central.",
  errorUnidadMedidaMateriasPrimas: "As seguintes matérias-primas não têm unidade de medida configurada desde Business Central",

  configurarVerifactuUrgente: "Numier TPV já está certificada com VERI*FACTU",
  debesConfigurarVerifactuAntes15Nov: "Já temos tudo pronto para conectar o teu negócio com <span><i>VERI*FACTU</i></span>.<br />Para isso só precisamos que carregues o teu <strong>certificado digital em cada um dos teus negócios</strong>, dessa forma, quando chegar a data teremos a tua versão atualizada à nova <strong>normativa obrigatória da AEAT</strong>.<br />Se precisas de mais informação, visita as nossas <i><a href='#/novedades' style='color: #1E22AA; text-decoration: underline; font-weight: 600;'>Novidades</a></i>.",
  subirCertificadoVerifactu: "Carregar certificado <i class='fas fa-file-upload ml-1'></i>",
  verNovedades: "Ver Novidades",
  verifactuAplazadoTitulo: "VERI*FACTU adiado até 2027",
  verifactuAplazadoMensaje: "Devido ao <strong><a style='text-decoration: underline; font-weight: 600;' href='https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/nota-informativa-ampliacion-plazo-adaptacion-facturacion.html' target='_blank' rel='noopener noreferrer'>adiamento da normativa VERI*FACTU</a></strong> até ao ano de 2027, todos os certificados digitais alojados nos servidores da <b><i>Numier</i></b> foram <strong>eliminados</strong> por motivos logísticos.<br/><br/>As novas datas de implementação serão:<br/><strong>• 1 de janeiro de 2027</strong> para contribuintes e sociedades.<br/><strong>• 1 de julho de 2027</strong> para os restantes negócios e autónomos.<br/><br/>À medida que nos aproximamos das novas datas, comunicaremos qualquer <b>novidade</b> ou <b>mudança importante</b>.",

  verifactuProximoTitulo: "Prepare-se para VERI*FACTU 2027",
  verifactuProximoMensaje: "A data de implementação do <span><i>VERI*FACTU</i></span> está se aproximando. Em <strong>janeiro</strong> e <strong>julho de 2027</strong> entrará em vigor a nova regulação obrigatória de faturação eletrónica.<br/><br/>Para garantir o correto funcionamento do teu negócio, é fundamental que <strong>carregues os certificados digitais</strong> em cada uma das tuas filiais o mais breve possível.<br/><br/>Se precisares de ajuda, não hesites em <strong>contactar o suporte</strong>.",

  errorVariasUdsMedidasProductoConSuplemento:
    "Não se pode criar o produto porque o produto base tem várias unidades de medida configuradas desde Business Central.",

  //17/11/25 Diagnostico PLU
  diagnosticoPLU: "Diagnóstico de PLU",
  todosPluIguales: "Todos os PLU iguais",
  pluDiferentes: "PLU diferente",
  noExiste: "Não existe",
  productoNoDisponible: "Produto não encontrado",
  subproductoNoDisponible: "Matéria-prima não encontrada",
  productoNoEncontrado: "Produto não encontrado neste negócio",
  coincide: "Mesmo PLU",
  noCoincide: "PLU diferente",
  //12/12/25
  tipoRol: "Tipo de função",
  updatedPaymentMethod: "As seguintes formas de pagamento foram atualizadas:",
  paymentMethodNameChanged: "O nome da forma de pagamento mudou de <strong>{oldName}</strong> para <strong>{newName}</strong>.",
  updatedPaymentMethod: "Foram atualizados os seguintes métodos de pagamento:",
  noEsProductoValidoParaMutarProductoConSuple: "Este produto não cumpre os requisitos para poder ser aceite como produto COM ou produto SUPLEMENTO.",

  paymentMethodDowngrades: "Se han encontrado bajas en formas de pago",
  downgradedPaymentMethods: "Formas de pago dadas de baja",
  unknownPaymentMethod: "Forma de pago desconocida",
  configuracionRol: "(Esta configuração aplica-se apenas ao Numier TURNOS)",
  sinIdDeProducto: "Sem detalhes",

  addSupplementPriceTitle: "Definir preço do suplemento",
  addSupplementPriceText: "Foi detectado que o produto <strong>{PRODUCT_NAME}</strong> agora pode ser um suplemento, quando anteriormente não podia. Para concluir a atualização, é necessário especificar a variação de preço que será aplicada ao selecionar este produto como suplemento. Isso é usado para calcular o preço final do produto incluindo o suplemento.",
  addSupplementPriceInputLabel: "Variação de preço: ",
  productComputedInfo: "O produto selecionado foi detetado com mais de uma unidade de medida e, ao mesmo tempo, é do tipo COM ou SUPLEMENTO, o que não é permitido. Por esse motivo, as unidades de medida serão ignoradas e será criado um produto do tipo com/suplemento. Pode continuar a preencher o formulário ou alterá-lo no Business Central.",
  materiaPrimaComputedInfo:
    "A matéria-prima vendável selecionada foi detetada com mais de uma unidade de medida e, ao mesmo tempo, é do tipo CON ou SUPLEMENTO, o que não é permitido. Portanto, as unidades de medida serão ignoradas e será criado um produto do tipo con/suplemento. Pode continuar a preencher o formulário ou modificá-lo no Business Central.",

  ocultarDTOInvitaciones: "Ocultar descontos e convites",

  modalUnidadesMedidaOpcionUnicoMasDeCuatro:
    "⚠️ Atenção → É obrigatório criar um produto independente para cada unidade de medida, pois o sistema admite um máximo de 4 tarifas por produto.",

  exportarPorLotesTPV: "Exportar por lotes TPV",
  modoExportacion: "Modo de exportação",
  exportacionNormal: "Exportação normal",
  exportarDatos: "Exportar dados",
  descripcionExportacionNormal: "Exporta todas as vendas juntas numa única operação",
  descripcionExportacionTPV: "Exporta as vendas agrupadas por ponto de venda (TPV)",
  importeSinDto: "Valor sem desc.",

  //28/07/26
  actualizandoCartaSinqro : "Actualizando carta de productos en Sinqro...",
  cartaActualizadaSinqro : "Carta de productos actualizada correctamente en Sinqro.",

  businessCentralCode : "Código do Business Central",

  errorCargandoDatos: "Error al cargar los datos",

  listaPresentaMateriasPrimasNoSincronizadas: "A lista contém matérias-primas que não foram sincronizadas com o seu TPV. Por favor, tente novamente mais tarde.",

  noTieneProveedor: "Sem fornecedor, será selecionado durante a gravação do pedido.",
  seleccionarProveedorMateriasPrimas: "Selecionar fornecedor para os subprodutos",
  lasSiguientesMateriasPrimasNoTienenProveedor: "Os seguintes subprodutos não têm um fornecedor atribuído. Selecione um fornecedor para cada um antes de guardar o pedido:",
  seleccioneUnProveedor: "Selecione um fornecedor",
  guardarYEnviar: "Guardar e enviar",
  dividirPedidoEntreProveedores: "Dividir o pedido entre fornecedores",
  modalTextMp0: "Tem matérias-primas com unidades e partes a 0. Deseja excluí-las do pedido?",
  pedidoSinMp: "O pedido ficou vazio após excluir as matérias-primas.",
  excluir: "Excluir",

  materiaPrimaNoSincronizada: "Este subproduto ainda não foi sincronizado com o seu TPV",

  noHayProductosAutoEditables: "Não há produtos que possam ser sincronizados automaticamente neste momento",
  confirmarSincronizacionMasivaTitle: "Sincronizar todos os produtos automáticos?",
  confirmarSincronizacionMasivaText: "{COUNT} produtos serão sincronizados automaticamente sem necessidade de revisá-los um a um. Deseja continuar?",
  siSincronizar: "Sim, sincronizar",
  sincronizando: "Sincronizando",
  sincronizacionMasivaCompletadaTitle: "Sincronização em massa concluída",
  sincronizadosCorrectamente: "Sincronizados com sucesso",
  errorDesconocido: "Erro desconhecido",
  sincronizarTodosAuto: "Sincronizar todos ({COUNT})",
  sincronizarTodos: "Sincronizar todos",
  sincronizarTodosAutoTooltip: "Sincroniza de uma vez todos os produtos cujas alterações não exigem preencher o formulário.",
  // Exportação de vendas para o Business Central: tabela unificada, resumos e avisos
  exportacionPorLotesFija: "A exportação é enviada por lotes de POS.",
  resumenPorMedioPago: "Por meio de pagamento",
  resumenPorTpv: "Por POS",
  resumenPorTipoDocumento: "Por tipo de documento",
  documento: "Documento",
  verDetalle: "Ver detalhe",
  facturaQR: "Fatura gerada a partir de um pedido por QR: não pertence a nenhum dia de caixa",
  rectificaA: "Retifica o documento",
  socio: "Sócio",
  variasFormas: "Várias formas",
  verDetallesVenta: "Ver detalhes da venda",
  editarMedioPago: "Editar meio de pagamento",
  desglosePagos: "Detalhe dos pagamentos",
  valesRegalo: "Vales de oferta",
  valesDelDocumentoOriginal: "do documento retificado",
  avisos: "Avisos",
  totalDeVenta: "Total de venda:",
  ticket: "Talão",
  rectificativa: "Nota de crédito",
  origenImporteVales: "valor do vale",
  origenImporteValesOriginal: "vale do documento retificado",
  origenImporteCobrosAvanzados: "soma do pagamento avançado",
  seleccioneUnMedioPago: "Selecione um meio de pagamento",
  importesNoEditables: "Os valores não podem ser alterados aqui.",
  buscarClientePorNombreCodigoODni: "Procurar por nome, código de sócio ou NIF",
  medioPagoRequiereClienteTexto: "Este meio de pagamento é cobrado a um cliente, por isso é preciso atribuir um.",
  medioActual: "Meio atual",
  detallesVenta: "Detalhes da venda",
  tipoDocumento: "Tipo de documento",
  dni: "NIF / CIF",
  codigoSocio: "Código de sócio",
  pago: "Pagamento",
  edicion: "Edição",
  ventaSinCliente: "A venda não tem cliente atribuído.",
  ventaNoEditable: "Esta venda não permite alterar o meio de pagamento.",
  errorCargandoFormasPago: "Não foi possível carregar as formas de pagamento.",
  avisoFacturaSinNombre: "Fatura sem nome de cliente",
  avisoFacturaSinDocumento: "Fatura sem NIF / CIF",
  avisoSocioSinCodigo: "Sócio sem código: a exportação vai rejeitá-lo",
  avisoSocioSinCodigoSalesforce: "Sócio sem código: será pedido ao Salesforce ao exportar",
  avisoMedioPagoSinCliente: "Meio de pagamento sem cliente atribuído",
  avisoCuentaCasaClienteGenerico: "Conta casa sem cliente: será exportada com o cliente genérico de contas casa",
  avisoValeSinRegistro: "Vale de oferta sem registo na tabela de vales",
  avisoVentaSinImporte: "Venda sem valor: seguiria sem qualquer pagamento",
  avisoRectificativaSinOriginal: "Não se encontra o documento que retifica",
  avisoProductoSinMapeoBC: "Produto sem código de integração",
  avisoProductoSinUnidadMedida: "Produto sem unidade de medida",
  motivoVentaAvanzada: "Venda com pagamento avançado: a repartição dos valores não se edita aqui.",
  motivoVentaConVale: "Venda com vale de oferta: o vale já está consumido e registado.",
  motivoRectificativa: "Nota de crédito: tem de ser cobrada como o documento que corrige.",
  motivoDestinoVale: "Não se pode passar uma venda para vales de oferta: o vale é consumido no POS.",
  debeCambiarFormaPagoParaGuardar: "Tem de alterar o meio de pagamento ou o cliente para poder guardar.",
  // Exportacion BC: resumen de avisos, filtros y paginacion de la tabla
  evCargandoVentas: "A carregar as vendas pendentes de exportação...",
  evDocumentosPendientes: "Documentos pendentes",
  evDelDiaDeCaja: "do dia de caixa",
  evConAvisos: "Com avisos",
  evNoSeExportaran: "Não serão exportadas",
  evSinAvisos: "Sem avisos",
  evFiltrarPorAviso: "Clique num aviso para ver apenas essas vendas na tabela.",
  evVerDetalles: "Ver detalhes",
  evOcultarDetalles: "Ocultar detalhes",
  evErrorCargaVentas: "Não foi possível carregar as vendas",
  evErrorCargaVentasTexto: "Não sabemos se há vendas pendentes: a consulta falhou. Tente novamente dentro de alguns segundos.",
  evYOtros: "e mais {n}",
  evBuscarVenta: "Pesquisar por documento ou cliente",
  evFiltroTodas: "Todas",
  evFiltroListas: "Prontas para exportar",
  evFiltroConAvisos: "Com avisos",
  evFiltroBloqueantes: "Não serão exportadas",
  evTodosLosTpv: "Todos os TPV",
  evQuitarFiltros: "Limpar filtros",
  evFiltroAviso: "Aviso",
  evSinCoincidencias: "Nenhum documento corresponde aos filtros.",
  evMostrandoRango: "{desde}–{hasta} de {total}",
  evPorPagina: "por página",
  evIrAlDocumento: "Ir para o documento",
  evOriginalYaExportado: "exportada",
  evOriginalYaExportadoTexto: "O documento original (de {fecha}) já foi exportado",
  evRectificadaPor: "Retificada por",
  evNivelBloqueante: "Não será exportada",
  evNivelRevisar: "Rever",
  evNivelBloqueanteTexto: "Esta venda não será enviada: fica pendente até ser corrigida.",
  evNivelRevisarTexto: "A venda é exportada, mas convém revê-la.",
  evConNotasInformativas: "Com notas informativas",
  evCuentasSinCobrar: "Contas por cobrar",
  evCuentasSinCobrarTitulo: "Contas por cobrar neste dia de caixa",
  evCuentasSinCobrarTexto: "Somam {importe}. Não são exportadas enquanto continuarem por cobrar.",
  evNivelInfo: "Informação",
  evNivelInfoTexto: "É apenas informativo: a venda é exportada normalmente.",
  evExportando: "A exportar…",
  evExportandoTexto: "A exportar vendas. Pode demorar alguns minutos: não feche esta página.",
  evExportarUnTpv: "Exportar um TPV",
  evExportarUnTpvDesc: "Exporta apenas as vendas do TPV que escolher",
  evEligeTpv: "Escolha um TPV",
  evPrimeraPagina: "Primeira página",
  evUltimaPagina: "Última página",
  evSoloSeExportaraTpv: "Só será exportado o TPV {tpv}.",
  evQueSeEnviara: "O que será enviado",
  evSeEnviaran: "Serão enviadas",
  evQuedaranPendientes: "Ficam pendentes até serem corrigidas",
  evCifrasDelTpv: "Valores do TPV {tpv}.",
  evCifrasDelDepartamento: "Valores deste departamento; os restantes departamentos da empresa também são exportados.",
  evFiltrosNoAfectanExportacion: "Os filtros da tabela não afetam a exportação: é enviado tudo o que está pendente.",
  evExportados: "Exportadas",
  evRechazadosPorBC: "Rejeitadas pelo BC",
  evOmitidosPorValidacion: "Omitidas pelo BC",
  evResultadoPendientesTexto: "O que não foi exportado continua pendente e aparece na tabela com os seus avisos.",
  evResultadosExportacion: "Resultados da exportação",
  evDescargarInformeExcel: "Transferir Excel",
  evInformeEstaTanda: "Última exportação",
  evActualizarInformes: "Atualizar",
  evSinInformes: "Ainda não há relatórios. Se a exportação continua em curso, o relatório aparecerá aqui quando terminar.",
  evSinRespuestaTanda: "Não foi recebida resposta do servidor. A exportação pode continuar em curso: os estados das vendas e o relatório Excel aparecerão quando terminar. Atualize a lista dentro de alguns minutos.",
  evDepartamentos: "Departamentos",
  evEligeDepartamentos: "Escolha departamentos",
  evTodosLosDepartamentos: "Todos os departamentos",
  evTpvsAExportar: "POS a exportar",
  evTpvsAyuda: "Entre parênteses, documentos por exportar.",
  evAperturasAExportar: "Aberturas de caixa a exportar",
  evAperturaMasAntigua: "A abertura pendente mais antiga",
  evAperturaMasAntiguaCadaTpv: "A abertura pendente mais antiga de cada POS",
  evIncluirFacturasQR: "Incluir faturas QR",
  evPendientesCorto: "pend.",
  evRechazadosCorto: "rejeitados BC",
  evOmitidosCorto: "omitidos",
  evExcluidosCorto: "excluídos",
  evSeExportaraSeleccion: "Serão exportados os seguintes dados",
  evResumenSeleccion: "Departamentos: {departamentos}. POS: {tpvs}. Aberturas: {aperturas}. {qr}.",
  evConFacturasQR: "Com as faturas QR pendentes",
  evSinFacturasQR: "Sem faturas QR",
  evExportacionTpvATpv: "Envia-se POS a POS e por blocos; o rejeitado ou omitido fica pendente com o seu motivo no Excel da ronda.",
  evCifrasDeLaSeleccion: "Números da seleção atual.",
  evEstadoRechazadoBC: "Previamente rejeitada",
  evEstadoOmitido: "Omitida",
  evEstadoExcluido: "Excluída",
  evExcluirDeExportacion: "Excluir da exportação",
  evIncluirEnExportacion: "Voltar a incluir na exportação",
  evVentaExcluida: "Venda excluída da exportação",
  evVentaIncluida: "Venda incluída de novo na exportação",
  evVentasIncluidasN: "{n} vendas incluídas de novo na exportação",
  evVentasExcluidasN: "{n} vendas excluídas da exportação",
  evIncluirSoloEste: "Incluir esta",
  evIncluirTambienAsociados: "Incluir associadas",
  evExcluirSoloEste: "Excluir esta",
  evExcluirTambienAsociados: "Excluir associadas",
  evAsociadosIncluirPregunta: "Quer voltar a incluir também os associados ou só este documento?",
  evAsociadosExcluirPregunta: "Quer excluir também os associados ou só este documento?",
  evAsociadosIncluirTexto: "O documento {doc} tem {n} documentos associados excluídos da exportação:",
  evAsociadosExcluirTexto: "O documento {doc} tem {n} documentos associados por exportar que não podem ser exportados sem ele:",
  evAsociadosTitulo: "Documentos associados",
  evFechaDoc: "Data doc.",
  avisoOriginalNoExportado: "O documento a que faz referência não está exportado; será enviado quando entrar o original",
  avisoExcluidaManual: "Excluídas da exportação",

  evCargarVentas: "Carregar vendas",
  evSeleccionCambiada: "Seleção alterada, prima para atualizar a lista.",
  evCambiosSinCargar: "Alterou a seleção e a lista não está atualizada. Prima Carregar vendas antes de exportar.",
  evModoAvanzadasTitulo: "Como contar as vendas com vários pagamentos (avançadas)",
  evAvanzadasTodas: "Todas as vendas",
  evAvanzadasSolo: "Só avançadas",
  evAvanzadasSin: "Sem avançadas",
  evMasEnExcel: "… e {n} mais. O detalhe completo está no Excel de exportação.",
  evMensajeEjemploParcial: "Envio parcial: algumas vendas omitidas por validação e outras rejeitadas (dados de exemplo)",
  evPrevisualizarRespuesta: "Pré-visualizar resposta",
  evExcluidaTexto: "Excluída pelo utilizador: não será exportada até voltar a ser incluída.",
  evActualizandoVentas: "A atualizar as vendas com a seleção nova...",
  evActualizarVentas: "Atualizar vendas",
  evTramoNotaDefecto: "Em ambas as opções a exportação faz-se em lotes de 100 documentos, salvo se for configurado outro tamanho abaixo.",
  evDocumentosCada: "documentos (mínimo 50)",
  evTramoDeN: "Em lotes de",
  evTramoTodoDeUnaVez: "Tudo de uma vez",
  evPersonalizarTramos: "Configurar o tamanho do lote por envio",
  evTramoNotaTodo: "Toda a exportação irá num único lote.",
  evTramoNota: "Em ambas as opções a exportação faz-se em lotes de {n} documentos.",
  evQrNoIncluidas: "Não incluídas",
  evQrIncluidas: "Incluídas na exportação",
  evFacturasQR: "Faturas QR",
  evCargandoInformes: "A carregar relatórios...",
  evConteoNoDisponible: "Contagem não disponível",
  evVentasExportadasN: "{n} vendas exportadas",
  evEnvioTodoJuntoDesc: "As vendas de todos os POS escolhidos são enviadas juntas, pela ordem em que foram feitas.",
  evEnvioTodoJunto: "Todos os TPV juntos",
  evEnvioPorTpvDesc: "Percorre os POS escolhidos um a um: cada POS é enviado e resolvido em separado.",
  evEnvioPorTpv: "Por TPV",
  evModoEnvio: "Envio",
  evInformesExportacion: "Últimos relatórios de exportação",
  evLineasVenta: "Linhas da venda",
  evCargandoLineas: "A carregar as linhas…",
  evErrorCargandoLineas: "Não foi possível carregar as linhas.",
  evVolverAIntentar: "Tentar novamente",
  evSinLineas: "A venda não tem linhas.",
  evCodigoBC: "Código BC",
  evUds: "Qtd.",
  evUnidadBC: "Unidade",
  evMenu: "Menu",
  evIncluidoEnMenu: "Incluído",
  evTotalLineas: "Total",
  evImporteDeLaVenta: "Valor da venda",
  evDescuento: "Desc.",
  // Relatório de fecho de caixa (Z)
  cierreCajaZDescripcion: "Apuramento completo de cada Z: vendas, meios de pagamento, impostos, produtos e talões",
  todaLaEmpresa: "Toda a empresa",
  estadoZ: "Estado do Z",
  zCerradas: "Só fechados",
  zAbiertas: "Só abertos",
  zAbierta: "Aberto",
  zCerrada: "Fechado",
  consultarRangoFechas: "Consultar um intervalo de datas",
  ocultarFilasSinDatos: "Ocultar linhas sem dados",
  zEnElInforme: "Z no relatório",
  ocultarDetalle: "Ocultar detalhe",
  quitarFranja: "Remover faixa horária",
  documentos: "Documentos",
  buscarDocumento: "Pesquisar documento (nº, cliente, operador, mesa)",
  limpiar: "Limpar",
  sector: "Setor",
  seleccionaSector: "Selecione um setor",
  desplazarIzquierda: "Deslocar para a esquerda",
  desplazarDerecha: "Deslocar para a direita",
  verIncidencias: "Ver incidências",
  incidenciasTexto: "Preços, quantidades e linhas alteradas ou eliminadas no TPV durante o Z",
  todasLasIncidencias: "Todas as incidências",
  todasLasZ: "Todos os Z",
  caja: "Caixa",
  sinIncidencias: "Não há incidências com esse filtro",
  bloqueResumen: "Resumo",
  bloqueAnalisisVentas: "Análise de vendas",
  fechaCaja: "Data de caixa",
  propinas: "Gorjetas",
  ventasSinPropinas: "Vendas sem gorjetas",
  formaPagoTipoSaldo: "Pagamento com saldo",
  incidenciasPrecioModificado: "Preço alterado",
  incidenciasLineaEliminada: "Linha eliminada",
  incidenciasCantidadModificada: "Quantidade alterada",
  incidenciasDescuentoModificado: "Desconto alterado",
  incidenciasOtras: "Outras incidências",
  rangoNoDisponibleSectores: "Com setores só é possível consultar um dia: o setor agrupa muitos TPV e um intervalo de datas tornaria o relatório incontrolável. Para filtrar por TPV use o filtro da barra de vista, depois de carregar o relatório.",
  analisisNegocio: "Análise de negócio",
  analisisNegocioDescripcion: "Comparativos de vendas, formas de pagamento, incidências e rentabilidade entre meses e anos",
  anPeriodo: "Período",
  anModoMes: "Mês",
  anModoRango: "Intervalo",
  anModoAnio: "Ano",
  anMes: "Mês a analisar",
  anCompararCon: "Comparar com",
  anMesAnteriorYAnioAnterior: "Mês anterior e mesmo mês do ano anterior",
  anMesAnterior: "Mês anterior",
  anMismoMesAnioAnterior: "Mesmo mês do ano anterior",
  anSinComparar: "Sem comparar",
  anPeriodoA: "Período A",
  anPeriodoB: "Período B",
  anPeriodoC: "Período C",
  anAnio: "Ano a analisar",
  anAnioAnteriorMismaFecha: "Ano anterior até à mesma data",
  anRecalcular: "Recalcular",
  anRecalcularAyuda: "Recalcular ignorando os dados guardados. Use-o se um TPV voltou a enviar dados. No máximo uma vez por hora e três por dia.",
  anRecalcularEspera: "Já foi recalculado há pouco. Poderá voltar a fazê-lo em {tiempo}.",
  anRecalcularEsperaDia: "Já foram feitos três recálculos nas últimas 24 horas. Poderá voltar a recalcular em {tiempo}.",
  anRecalcularConfirmacion: "Os dados guardados dos TPV e meses consultados serão apagados e recalculados. Pode demorar alguns segundos.",
  anCalculandoPeriodos: "A calcular os períodos selecionados…",
  anSinDatos: "Sem vendas no período",
  anSinDatosTexto: "Não há sessões de caixa nem documentos no âmbito e período selecionados.",
  anPeriodosDistintaLongitud: "Períodos de duração diferente: compare as médias",
  anPestanaVentas: "Vendas",
  anPestanaFormasPago: "Formas de pagamento",
  anPestanaIncidencias: "Incidências",
  anPestanaRentabilidad: "Rentabilidade",
  anProximamente: "Disponível na próxima fase",
  anEvolucionMensual: "Evolução mensal",
  anUltimos13Meses: "últimos 13 meses",
  anMediaDiaria: "Média diária",
  anCalculandoMesesAntiguos: "A calcular meses anteriores…",
  anVentasPorDia: "Vendas por dia",
  anAlinearPorDiaSemana: "Alinhar por dia da semana",
  anVentasPorDiaSemana: "Vendas por dia da semana",
  anMediaPorDiaConVentas: "média por dia com vendas",
  anVentasPorHora: "Vendas por hora",
  anPorNegocioYTpv: "Por negócio e TPV",
  anVariacion: "Variação",
  sesiones: "Sessões",
  anCompletaPeriodo: "Preencha o período para consultar",
  anPeriodoInvertido: "O fim do período é anterior ao início",
  anMaximo12Meses: "Cada período pode abranger no máximo 12 meses",
  anCalculadosAhora: "{n} de {total} TPV·mês calculados agora; o resto dos dados guardados",
  anDatosDeCache: "Dados guardados (calculados em {fecha})",
  anHasta: "até",
  anNotaDistintaLongitud: "Os períodos não têm a mesma duração: repare nas médias",
  anNotaAlineadoSemana: "Alinhado por dia da semana: o dia 1 é a primeira segunda-feira de cada período",
  anNotaBisiesto: "{periodo} inclui 29 de fevereiro de {anio}, sem correspondência no outro período",
  anDia: "Dia",
  anFormasPagoMesesCompletos: "A distribuição por forma de pagamento é calculada sobre meses completos: o corte por dia do período não se aplica aqui.",
  anRepartoPorTipo: "Distribuição por tipo de pagamento",
  anTiposPorPeriodo: "Tipos de pagamento por período",
  anEvolucionFormasPago: "Evolução das formas de pagamento",
  anEnPorcentaje: "Em percentagem",
  anPorTipoYMedio: "Por tipo e meio de pagamento",
  formaPago: "Forma de pagamento",
  anPorcentajeMediosNota: "A % de cada tipo é sobre o total do período; a de cada meio, sobre o seu tipo.",
  anRatioIncidencias: "{n} incidências por cada 100 documentos",
  anRatioFrenteA: "rácio face a",
  anTipoPredominante: "Tipo predominante",
  anEvolucionIncidencias: "Evolução das incidências",
  anBarrasTotalLineaRatio: "barras: total · linha: por 100 documentos",
  anIncidenciasPorDia: "Incidências por dia",
  anPulsaDiaParaCierreZ: "clique num dia para abrir o seu Fecho de caixa Z",
  anIncidenciasPorTipo: "Incidências por tipo",
  anIncidenciasPorOperario: "Incidências por operador",
  anIncidenciasPorProducto: "Incidências por produto afetado",
  anAQueSeDeben: "a que se devem",
  anPor100Docs: "Por 100 docs.",
  anVariacionRatio: "Variação do rácio",
  anCoberturaCoste: "{conCoste} de {total} itens vendidos têm custo de ficha técnica ({pct} % das vendas sem IVA); só esses são classificados.",
  anCosteActualNota: "O custo é o atual da ficha técnica de cada produto, não o que tinha no período.",
  anRentabilidadMesesCompletos: "A rentabilidade é calculada sobre meses completos: o corte por dia não se aplica aqui.",
  anPorProductoYTarifa: "Produto × tarifa",
  anPorProducto: "Produto",
  anTodasLasCategorias: "Todas as categorias",
  anTodosLosCuadrantes: "Todos os quadrantes",
  anSinCoste: "Sem custo",
  anItems: "itens",
  anMargenContribucion: "Margem de contribuição",
  anUmbrales: "Limiares do período",
  anIndicePopularidadMedio: "Índice de popularidade médio",
  anRentabilidadMedia: "Rentabilidade média (MC por unidade)",
  anMediaCoste: "Média de custo",
  anMatrizPopularidadMargen: "Matriz popularidade × margem",
  anMatrizExplicacion: "cada bolha é um item; o tamanho, a sua margem total; as linhas, os limiares",
  anMargenPorCuadrante: "Margem total por quadrante",
  anTopMargen: "Maior margem total",
  anCambiosCuadrante: "Mudanças de quadrante",
  anTablaIngenieriaMenu: "Engenharia de menu",
  anNumeroVentas: "Nº vendas",
  anCosteProducto: "Custo",
  anPrecioVentaSinIva: "PVP sem IVA",
  anIndicePopularidad: "Índice de popularidade",
  anCosteProductoPct: "% custo",
  anTotalCoste: "Total custo",
  anTotalVentas: "Total vendas",
  anMargenContribucionTotal: "MC total",
  anClasifRentabilidad: "Rentabilidade",
  anClasifPopularidad: "Popularidade",
  anClasifFinal: "Classificação",
  anTarifaNoIdentificada: "Tarifa não identificada: atribuída à tarifa 1",
  anNuevo: "novo",
  anAlta: "Alta",
  anBaja: "Baixa",
  anSinUnidades: "Sem unidades líquidas",
  anPrincipiosOmnes: "Preços: princípios de Omnes",
  anTodaLaCarta: "Toda a carta vendida",
  anDispersionPrecios: "Dispersão de preços",
  anDispersionTexto: "Preço mais alto {max} / mais baixo {min}",
  anDispersionIdeal: "Ideal entre 2,5 e 3 em gamas de mais de 12 pratos",
  anDispersionNoAplica: "O critério (2,5–3) aplica-se a gamas de mais de 12 pratos",
  anAmplitudGama: "Amplitude de gama",
  anAmplitudTexto: "Bandas de igual largura; cortes em {bajo} e {alto}. Ideal 25 / 50 / 25 %.",
  anRelacionCalidadPrecio: "Relação qualidade-preço",
  anPrecioMedioSolicitado: "Preço médio solicitado",
  anPrecioMedioOfertado: "Preço médio oferecido",
  anSimularCambioPrecios: "Simular alteração de preços",
  anBandaBaja: "Banda baixa",
  anBandaMedia: "Banda média",
  anBandaAlta: "Banda alta",
  anActual: "Atual",
  anIdeal: "Ideal",
  anRecomendableSubir: "Recomendável subir preços (rácio > 1,00)",
  anRecomendableBajar: "Recomendável baixar preços (rácio < 0,90)",
  anRecomendableMantener: "Preços adequados: manter (rácio 0,90–1,00)",
  anCuadranteLider: "Líder",
  anCuadrantePopular: "Popular",
  anCuadranteRentable: "Rentável",
  anCuadranteRevisar: "A rever",
  anCuadranteLiderAyuda: "Popularidade alta e margem alta: os pratos que sustentam o negócio. Manter e destacar.",
  anCuadrantePopularAyuda: "Vende muito mas deixa pouca margem: rever custo ou preço.",
  anCuadranteRentableAyuda: "Boa margem mas vende pouco: dar-lhe visibilidade ou reposicioná-lo na carta.",
  anCuadranteRevisarAyuda: "Nem vende nem deixa margem: candidato a mudar ou retirar.",
  anExportarPdfAyuda: "Exportar a aba atual para PDF (gráficos e tabelas)",
  anExportarExcelAyuda: "Exportar a aba atual para Excel (uma folha por bloco)",
  verAnalisisNegocio: "Ver análise",
  verAnalisisNegocioAyuda: "Abrir 'Análise de negócio' com esta empresa, estes negócios e o mês da data consultada",
  proximamente: "Em breve",
  verAnalisisNegocioProximamente: "O relatório 'Análise de negócio' estará disponível em breve",
  anPeriodosReordenados: "Os períodos são apresentados do mais recente ao mais antigo: {reciente} é o período principal e a variação indica quanto mudou em relação a {antiguo}.",
  anVariacionDireccion: "Variação de {antiguo} para {reciente}: quanto mudou o período recente em relação ao anterior.",
  anExportarEsperaCarga: "Aguarde que a aba termine de carregar para a exportar.",
  sinSesionesDeCaja: "Não há sessões de caixa",
  sinSesionesDeCajaTexto: "Nenhum POS do âmbito abriu caixa na data selecionada. O Z pertence ao dia em que abre, mesmo que feche depois da meia-noite.",
  tpvsSinApertura: "POS sem abertura",
  facturasQRExcluidasTexto: "As faturas QR não pertencem a nenhum Z e não entram neste relatório: têm o seu próprio relatório.",
  franjaHoraria: "Intervalo horário",
  franjaHorariaSoloAnalisis: "O intervalo só filtra produtos e talões. O apuramento é da sessão completa e não é afetado.",
  aplicar: "Aplicar",
  productosVendidos: "Produtos vendidos",
  productosVendidosTexto: "Quantidade de cada produto vendido por Z. Não inclui anulações, stock nem quebras.",
  todosLosDocumentos: "Todos os documentos",
  formasPago: "Meios de pagamento",
  invitacion: "Oferta",
  cuentaCasa: "Conta casa",
  valeRegalo: "Vale de oferta",
  bloqueIdentificacion: "Identificação",
  bloqueVentas: "Vendas",
  bloqueFormasPago: "Meios de pagamento",
  bloqueArqueo: "Apuramento",
  bloqueImpuestos: "Impostos",
  numeroZ: "N.º do Z",
  operarioCierre: "Operador",
  duracionHoras: "Duração (horas)",
  primerDocumento: "Primeiro documento",
  ultimoDocumento: "Último documento",
  numIncidencias: "Incidências",
  numAnulados: "Documentos anulados",
  ventasBrutas: "Vendas",
  abonos: "Notas de crédito",
  ventasTotales: "Vendas totais",
  numDocumentos: "N.º de documentos",
  numTickets: "Talões",
  numFacturas: "Faturas",
  numRectificativas: "Notas de crédito",
  ticketMedio: "Talão médio",
  mediaPorComensal: "Média por cliente",
  numInvitaciones: "N.º de ofertas",
  importeInvitaciones: "Valor das ofertas",
  formaPagoTipoEfectivo: "Numerário",
  formaPagoTipoTarjeta: "Cartão",
  formaPagoTipoCheque: "Cheque",
  formaPagoTipoOtros: "Outros",
  totalFormasPago: "Total meios de pagamento",
  ventaSegunTpv: "Venda segundo o POS",
  diferenciaConDocumentos: "Diferença com os documentos",
  cambioInicial: "Fundo de caixa inicial",
  gastosCaja: "Despesas de caixa",
  totalCalculado: "Total calculado",
  totalDeclarado: "Total declarado",
  retirado: "Retirado",
  nuevaFianza: "Novo fundo de caixa",
  baseImponibleIva: "Base tributável IVA",
  cuotaIva: "Valor IVA",
  baseImponibleTotal: "Base tributável total",
  totalImpuestos: "Total impostos",
  avisoZAbierta: "Z por fechar: não se pode apurar",
  avisoZDuracionExcesiva: "Z aberto mais tempo do que o normal",
  avisoZConIncidencias: "Z com incidências",
  avisoZSinVentas: "Z sem vendas",

  // --- Horario de disponibilidad Sinqro ---
  configurarHorarioSinqro: "Configurar horário de disponibilidade",
  horarioSinqroOnAyuda: "Escolha um horário ou crie um novo; o ativo é o que é enviado ao Sinqro.",
  horarioSinqroOffAyuda: "Se não configurar um horário, no Sinqro a carta ficará disponível 24 h.",
  copiarATodosLosDias: "Copiar para os restantes dias",
  anadirTramo: "Adicionar intervalo",
  horarioSinqroSinTramos: "Ativou o horário mas há dias sem intervalos válidos. Preencha as horas ou desative o horário.",
  horarioSinqroRangoInvalido: "Há intervalos cuja hora de fim é anterior ou igual à de início.",

  // --- Biblioteca de horarios Sinqro ---
  seleccionaHorario: "Selecione um horário",
  crearNuevoHorario: "Criar novo horário",
  nombreHorario: "Nome do horário",
  guardarHorario: "Guardar horário",
  horarioGuardado: "Horário guardado",
  horarioEliminado: "Horário eliminado",
  confirmarEliminarHorario: "Eliminar este horário? Esta ação não pode ser anulada.",
  sinHorarios: "Este negócio ainda não tem horários. Crie um novo.",
  nombreHorarioObligatorio: "Dê um nome ao horário.",
  horarioActivoAyuda: "O horário selecionado é o que é enviado ao Sinqro.",

  // --- Etiquetas do negócio (ecrã novo) ---
  etiquetasDelNegocio: "Etiquetas do negócio",
  etiquetasClasifican: "Classificam matérias-primas e fornecedores.",
  etiquetasDosFamilias: "Duas famílias que não se misturam: uma matéria-prima só leva etiquetas de matéria-prima.",
  deMateriaPrima: "De matéria-prima",
  deProveedor: "De fornecedor",
  conProblema: "Com problema",
  familiasDeEtiquetas: "Famílias de etiquetas",
  sinTipo: "Sem tipo",
  verTodas: "Ver todas",
  sinNombre: "(sem nome)",
  sinEtiquetaExplica: "matérias-primas que não têm nenhuma etiqueta atribuída",
  sinEtiquetasEnEstaFamilia: "Este negócio não tem etiquetas desta família.",
  notaEtiquetas: "As etiquetas vivem no POS servidor do negócio, não uma por terminal. Este ecrã mostra-as todas, incluindo as que o resto do painel não chega a mostrar.",
  estadoRaiz: "etiqueta principal",
  estadoDentroDe: "dentro de «{padre}»",
  estadoDeBaja: "desativada",
  estadoNombreRepetido: "há mais do que uma etiqueta com este nome",
  estadoSinTipo: "não é de matéria-prima nem de fornecedor",
  estadoBucle: "é a sua própria etiqueta pai",
  estadoHuerfana: "depende da etiqueta {code}, que não existe ou não é desta família",
  estadoNoSeVe: "não se vê no resto do painel: o seu ramo corta-se antes de chegar a ela",
  avisoEtiquetasOcultas: "<b>Uma etiqueta de matéria-prima não se vê no resto do painel</b>, «{nombre}», com {m} matérias-primas dentro. Aparece na lista, mas não se pode escolher ao editar uma ficha. | <b>{n} etiquetas de matéria-prima não se veem no resto do painel</b>, entre elas «{nombre}», com {m} matérias-primas dentro. Aparecem na lista, mas não se podem escolher ao editar uma ficha.",
  avisoMpConEtiquetaProveedor: "<b>Uma matéria-prima leva uma etiqueta de fornecedor.</b> São duas famílias distintas: essa etiqueta não devia poder escolher-se aqui. | <b>{n} matérias-primas levam uma etiqueta de fornecedor.</b> São duas famílias distintas: essas etiquetas não deviam poder escolher-se aqui.",
  avisoMpConEtiquetaSinTipo: "<b>Uma matéria-prima leva uma etiqueta sem tipo.</b> Não é de matéria-prima nem de fornecedor, por isso não se agrupa em lado nenhum. | <b>{n} matérias-primas levam uma etiqueta sem tipo.</b> Não são de matéria-prima nem de fornecedor, por isso não se agrupam em lado nenhum.",
  avisoMpConEtiquetaDeBaja: "<b>Uma matéria-prima tem uma etiqueta inativa.</b> A etiqueta existe, mas a ficha já não a oferece, por isso não há como a retirar de lá a partir do painel. | <b>{n} matérias-primas têm uma etiqueta inativa.</b> As etiquetas existem, mas a ficha já não as oferece, por isso não há como as retirar de lá a partir do painel.",
  avisoMpConEtiquetaInexistente: "<b>Uma matéria-prima aponta para uma etiqueta que não existe.</b> A referência está quebrada: não aparece em nenhum relatório por etiqueta. | <b>{n} matérias-primas apontam para uma etiqueta que não existe.</b> As referências estão quebradas: não aparecem em nenhum relatório por etiqueta.",
  avisoEtiquetasSinTipo: "<b>Há uma etiqueta sem tipo.</b> Não sai em nenhuma lista, e as que dependem dela também não. | <b>Há {n} etiquetas sem tipo.</b> Não saem em nenhuma lista, e as que dependem delas também não.",
  avisoMpSinEtiqueta: "<b>Uma matéria-prima não tem etiqueta.</b> Não aparece agrupada em nenhum relatório por etiqueta. | <b>{n} matérias-primas não têm etiqueta.</b> Não aparecem agrupadas em nenhum relatório por etiqueta.",
  avisoEtiquetaRepetida: "<b>Há {n} etiquetas chamadas «{nombre}»</b> em {familia}. Ao escolher uma não há forma de saber qual é qual.",

  // --- Criação de etiqueta ---
  familia: "Família",
  queEsCadaFamilia: "O que é cada família",
  ayudaFamiliaMateriaPrima: "classifica as matérias-primas do armazém. É a única que se pode atribuir a uma matéria-prima, e a que agrupa os relatórios de compras e inventário.",
  ayudaFamiliaProveedor: "classifica os fornecedores, para os agrupar nos relatórios de despesa. Não se pode atribuir a uma matéria-prima.",
  ningunaEsPrincipal: "Nenhuma — será uma etiqueta principal",
  ayudaEtiquetaPadre: "Só se oferecem etiquetas ativas da mesma família: uma etiqueta que depende de outra família deixa de se ver no resto do painel.",
  nombreEtiquetaObligatorio: "Dê um nome à etiqueta.",
  etiquetaCreada: "Etiqueta criada.",
  noSeHaPodidoGuardar: "Não foi possível guardar. Tente novamente.",

  // --- Edicao e baixa de etiqueta ---
  editarEtiqueta: "Editar etiqueta",
  reactivar: "Reativar",
  padreCode: "código {code} (não existe)",
  laFamiliaNoSeCambia: "A família não se altera: as matérias-primas que já a têm deixariam de cumprir a regra. Se precisar de outra, crie uma etiqueta nova.",
  etiquetaGuardada: "Etiqueta guardada.",
  etiquetaDadaDeBaja: "Etiqueta desativada.",
  etiquetaReactivada: "Etiqueta reativada.",
  darDeBajaEtiqueta: "Desativar «{nombre}»",
  bajaConMateriasPrimas: "Tem 1 matéria-prima dentro, que ficará a apontar para uma etiqueta desativada. | Tem {n} matérias-primas dentro, que ficarão a apontar para uma etiqueta desativada.",
  bajaConHijas: "Depende dela 1 etiqueta, que ficará sem pai válido. | Dependem dela {n} etiquetas, que ficarão sem pai válido.",
  bajaSinConsecuencias: "Não tem matérias-primas nem outras etiquetas dentro. Poderá reativá-la quando quiser.",
  aQueEtiquetaVan: "Para que etiqueta vão?",
  bajaHijasSuben: "1 etiqueta depende dela e passará a {padre}. | {n} etiquetas dependem dela e passarão a {padre}.",
  ningunaSeranPrincipales: "ser etiquetas principais",
  bajaDejarSinEtiqueta: "Deixá-la sem etiqueta em vez de a reatribuir | Deixar as {n} sem etiqueta em vez de as reatribuir",
  bajaMpReasignadas: "1 matéria-prima reatribuída. | {n} matérias-primas reatribuídas.",
  bajaMpSinEtiqueta: "1 matéria-prima ficou sem etiqueta. | {n} matérias-primas ficaram sem etiqueta.",
  bajaHijasMovidas: "1 etiqueta subiu de nível. | {n} etiquetas subiram de nível.",

  // --- Materias-primas a revisar (modal do ecra de etiquetas) ---
  verYAsignar: "Ver e atribuir",
  asignarFamilia: "Atribuir família",
  tituloSinTipo: "Etiquetas sem família",
  ayudaSinTipo: "Não são de matéria-prima nem de fornecedor, por isso não aparecem em nenhuma lista, e o que depende delas também não. Marca as que quiseres e escolhe a família que lhes corresponde.",
  queFamiliaLesCorresponde: "Que família lhes corresponde?",
  pistaMateriasPrimas: "1 matéria-prima dentro | {n} matérias-primas dentro",
  pistaHijas: "1 etiqueta dentro, de {familia} | {n} etiquetas dentro, de {familia}",
  pistaNadie: "ninguém a usa",
  sinTipoNadaQueVer: "Todas as etiquetas têm a sua família.",
  familiaAsignada: "Família atribuída a 1 etiqueta. | Família atribuída a {n} etiquetas.",
  tituloRevisar_sinEtiqueta: "Matérias-primas sem etiqueta",
  tituloRevisar_etiquetaProveedor: "Matérias-primas com etiqueta de fornecedor",
  tituloRevisar_etiquetaSinTipo: "Matérias-primas com etiqueta sem tipo",
  tituloRevisar_etiquetaDeBaja: "Matérias-primas com etiqueta inativa",
  tituloRevisar_etiquetaInexistente: "Matérias-primas com etiqueta inexistente",
  ayudaRevisar_sinEtiqueta: "Não estão agrupadas em nenhum relatório por etiqueta. Marca as que quiseres e escolhe abaixo para que etiqueta vão.",
  ayudaRevisar_etiquetaProveedor: "Levam uma etiqueta de outra família. Marca as que quiseres e escolhe abaixo uma etiqueta de matéria-prima.",
  ayudaRevisar_etiquetaSinTipo: "A sua etiqueta não é de matéria-prima nem de fornecedor, por isso não agrupa em parte alguma. Marca as que quiseres e escolhe abaixo uma etiqueta de matéria-prima.",
  ayudaRevisar_etiquetaDeBaja: "A sua etiqueta está inativa, por isso a ficha da matéria-prima já não a oferece. Marca as que quiseres e escolhe abaixo uma etiqueta ativa.",
  ayudaRevisar_etiquetaInexistente: "Apontam para uma etiqueta que já não existe. Marca as que quiseres e escolhe abaixo para que etiqueta vão.",
  seleccionarNinguna: "Nenhuma",
  revisarTruncado: "Mostra-se a primeira de {total}. Usa a pesquisa para chegar às restantes. | Mostram-se as primeiras {n} de {total}. Usa a pesquisa para chegar às restantes.",
  revisarSinPermiso: "Podes ver a lista, mas não tens permissão para editar matérias-primas, por isso não as podes reatribuir.",
  revisarNadaQueVer: "Não resta nenhuma neste estado.",
  asignarEtiqueta: "Atribuir esta etiqueta",
  elegirEtiquetaDestino: "Escolhe uma etiqueta de matéria-prima",
  etiquetasDeMateriaPrima: "Etiquetas de matéria-prima",
  quitarEtiqueta: "Remover a etiqueta",
  sinResultados: "Nenhuma etiqueta coincide",
  dejarSinEtiqueta: "Deixar sem etiqueta",
  asignarACuantas: "Atribuir | Atribuir a {n}",
  confirmarDejarSinEtiqueta: "Ficará sem nenhuma etiqueta e não aparecerá agrupada nos relatórios por etiqueta. | As {n} ficarão sem nenhuma etiqueta e não aparecerão agrupadas nos relatórios por etiqueta.",
  materiasPrimasAsignadas: "Etiqueta atribuída a 1 matéria-prima. | Etiqueta atribuída a {n} matérias-primas.",
  etiquetaSinNombre: "(etiqueta sem nome)",
  destinoOculto: "Não aparecem no resto do painel",
  avisoDestinoOculto: "Essa etiqueta não aparece no resto do painel: o seu ramo corta-se antes de chegar a ela. As matérias-primas ficarão agrupadas, mas continuarás sem a poder escolher ao editar uma ficha.",
  errorInesperado: "Aconteceu algo inesperado. Tenta de novo.",
  // Pausas en el informe de turnos (app de gestión de turnos)
  tpPausas: "Pausas",
  tpPorDias: "Por dias",
  tpPorTurnos: "Por turnos",
  tpHorario: "Horário",
  tpDesayuno: "Pequeno-almoço",
  tpCigarro: "Cigarro",
  tpDescanso: "Descanso",
  tpOtra: "Outra",
  tpEnCurso: "em curso",
  tpTurnoDe: "turno de",
  tpJornadaPartida: "Jornada partida",
  tpParon: "Paragem entre turnos",
  tpDias: "dias",
  tpNota: "Clique num dia para ver o detalhe. As pausas são informativas: não alteram as horas nem o salário.",
  // --- Categorias del negocio (Configuracion > Categorias) ---
  terminales: "Terminais",
  desiguales: "Desiguais",
  gruposDeCategorias: "Grupos de categorias",
  vistaListado: "Vista em lista",
  vistaColumnas: "Vista em colunas",
  verLos4Grupos: "Ver os 4 grupos",
  catDe: "de",
  pantallaDelTerminal: "{n}.ª página do TPV",
  reindexar: "Reindexar",
  grupoCompleto: "Grupo completo",
  seGuardaEnTerminales: "Será guardada no terminal do negócio. | Será guardada nos {n} terminais do negócio.",
  sinCategoriaExplica: "produtos deste grupo que não estão em nenhuma categoria",
  huecoConBajasExplica: "só lhe restam produtos inativos; liberte-a para a poder reutilizar",
  liberarRanura: "Libertar",
  liberarRanuraTitulo: "Libertar esta posição?",
  liberarRanuraTexto: "Os seus produtos inativos ficam sem categoria e a posição fica livre para uma categoria nova ou para reindexar. Os produtos ativos não são alterados.",
  ranuraLiberada: "Posição libertada",
  huecoLibreExplica: "aqui havia uma categoria; o seu lugar continua reservado",
  verProductos: "Ver produtos",
  usarEsteHueco: "Usar este espaço",
  nombreCategoriaNueva: "Nome da nova categoria",
  seCrearaAlFinalDelGrupo: "Será criada vazia, no fim do grupo {g}, no terminal do negócio. | Será criada vazia, no fim do grupo {g}, nos {n} terminais.",
  grupoVacio: "Este grupo está vazio. As categorias que criar aqui aparecerão na {n}.ª página do TPV.",
  fueraDeLosGrupos: "Fora dos quatro grupos",
  fueraDeLosGruposExplica: "o terminal usa-as, mas a sua tecla não é das 40 habituais",
  verDeUnoEnUno: "Ver os grupos um a um",
  mostrarLos4Grupos: "Mostrar os 4 grupos",
  notaGruposTerminal: "Os quatro grupos são os que o empregado vê no terminal. Uma categoria é criada dentro de um grupo e fica lá; adicionar coloca-a no fim do seu grupo, e editar ou eliminar não move as outras.",
  productosAsignados: "1 produto atribuído a «{categoria}». | {n} produtos atribuídos a «{categoria}».",
  reordenar: "Reordenar",
  avisoOrdenDistinto: "<b>Em 1 terminal as categorias estão noutras teclas que no servidor.</b> Reordene-as antes de mais nada: entretanto, os outros avisos podem não estar certos. | <b>Em {n} terminais as categorias estão noutras teclas que no servidor.</b> Reordene-as antes de mais nada: entretanto, os outros avisos podem não estar certos.",
  avisoOtroNombre: "<b>Um terminal chama «{otro}» à categoria «{nombre}», do grupo {g}.</b> Os empregados que usem esse terminal veem outro nome para a categoria.",
  unificar: "Unificar",
  avisoNombreRepetido: "<b>Há duas categorias chamadas «{nombre}»</b>, no grupo {g1} e no {g2}, com {p1} e {p2} produtos.",
  avisoDesiguales: "<b>Uma categoria não chegou a todos os terminais.</b> Está criada no negócio mas falta o nome nalgum, pelo que aí os seus produtos não aparecem agrupados. | <b>{n} categorias não chegaram a todos os terminais.</b> Estão criadas no negócio mas falta o nome nalgum, pelo que aí os seus produtos não aparecem agrupados.",
  avisoDesigualesSinNinguna: "O terminal {terminales} não tem nenhuma. | Os terminais {terminales} não têm nenhuma.",
  aplicarATodos: "Aplicar a todos",
  avisoTerminalesSinCategorias: "<b>Um terminal não tem nenhuma categoria.</b> Um produto criado aí não aparecerá em nenhuma. | <b>{n} terminais não têm nenhuma categoria.</b> Um produto criado aí não aparecerá em nenhuma.",
  avisoProductosSinCategoria: "<b>Um produto não está em nenhuma categoria.</b> Vende-se, mas os empregados só chegam a ele procurando. | <b>{n} produtos não estão em nenhuma categoria.</b> Vendem-se, mas os empregados só chegam a eles procurando.",
  avisoTerminalPendiente: "<b>O terminal {terminales} é novo e ainda não enviou a sua carta.</b> Vai copiá-la do servidor ao arrancar e enviá-la; até lá não se lhe escreve nada daqui nem conta nestes avisos. | <b>Os terminais {terminales} são novos e ainda não enviaram a sua carta.</b> Vão copiá-la do servidor ao arrancar e enviá-la; até lá não se lhes escreve nada daqui nem contam nestes avisos.",
  unTerminalLaLlama: "um terminal chama-lhe «{otro}»",
  pendienteEnTerminales: "pendente em 1 terminal | pendente em {n} terminais",
  enOtraTeclaEnTerminal: "num terminal está noutra tecla; corrige-se ao reordenar",
  avisoSoloEnClientes: "<b>«{nombre}», do grupo {g}, só existe no terminal {terminales}.</b> O servidor não a tem, e é ele que manda: crie-a nele se estiver certa, ou retire-a do terminal. | <b>«{nombre}», do grupo {g}, só existe nos terminais {terminales}.</b> O servidor não a tem, e é ele que manda: crie-a nele se estiver certa, ou retire-a desses terminais.",
  crearEnServidor: "Criar no servidor",
  quitarDelTerminal: "Retirar do terminal | Retirar dos terminais",
  soloEnTerminalSinServidor: "só em {terminales}; o servidor não a tem",
  crearEnServidorTitulo: "Criar «{nombre}» no servidor?",
  crearEnServidorExplica: "O servidor não a tem. Será criada nele e nos terminais onde faltar.",
  bajaSoloEnClientes: "Só {terminales} a tem. O servidor não muda.",
  enTodosLosTerminales: "no único terminal | nos {n} terminais",
  nombreVacio: "O nome não pode ficar vazio. Se quiser retirá-la, use Eliminar.",
  categoriaGuardada: "Categoria guardada no terminal. | Categoria guardada nos {n} terminais.",
  categoriaCreada: "Categoria criada no terminal. | Categoria criada nos {n} terminais.",
  productosMovidos: "1 produto movido para a outra categoria. | {n} produtos movidos para a outra categoria.",
  productosSinCategoriaAhora: "1 produto ficou sem categoria. | {n} produtos ficaram sem categoria.",
  categoriaEliminada: "Categoria eliminada no terminal. | Categoria eliminada nos {n} terminais.",
  yaEstabanOrdenadas: "As categorias deste grupo já estavam seguidas.",
  categoriasReindexadas: "1 categoria movida. O grupo já não tem espaços. | {n} categorias movidas. O grupo já não tem espaços.",
  categoriasReordenadas: "1 categoria colocada na sua tecla. | {n} categorias colocadas na sua tecla.",
  reordenarSaltados: "Não foi possível reordenar em: {terminales}.",
  categoriasIgualadas: "1 categoria igualada em todos os terminais. | {n} categorias igualadas em todos os terminais.",
  categoriasSaltadas: "1 categoria tem nomes diferentes entre terminais: escolha qual vale. | {n} categorias têm nomes diferentes entre terminais: escolha qual vale.",
  huecoConBajas: "Ranhura ocupada",
  huecoLibre: "Espaço livre",
  eliminarCategoria: "Eliminar «{nombre}»",
  eliminarConProductos: "Tem 1 produto dentro. Escolha para onde vai antes de a eliminar. | Tem {n} produtos dentro. Escolha para onde vão antes de a eliminar.",
  eliminarSinProductos: "Não tem produtos dentro. Será eliminada no terminal. | Não tem produtos dentro. Será eliminada nos {n} terminais.",
  eliminarHuecoSeQueda: "O espaço fica no seu lugar: nenhuma outra categoria é reposicionada.",
  eligeDestino: "Escolha para onde vão os seus produtos.",
  moverProductosA: "Mover os seus produtos para...",
  sinResultadosCategoria: "Nenhuma categoria corresponde",
  grupoNumero: "Grupo {g}",
  dejarlosSinCategoria: "Deixá-los sem categoria",
  confirmarSinCategoriaTexto: "Esse produto deixará de aparecer agrupado no terminal. Continuará a vender-se, mas os empregados só chegarão a ele procurando-o. | Esses {n} produtos deixarão de aparecer agrupados no terminal. Continuarão a vender-se, mas os empregados só chegarão a eles procurando-os.",
  productosSinCategoriaTitulo: "Produtos sem categoria",
  productosSinCategoriaAyuda: "Não saem agrupados no terminal, por isso os empregados só chegam a eles procurando. Marca os que quiseres e escolhe abaixo para que categoria vão.",
  productoSinNombre: "(sem nome)",
  enNTerminales: "em 1 de {t} terminais | em {n} de {t} terminais",
  sinProductosSinCategoria: "Não resta nenhum produto sem categoria.",
  asignarEstaCategoria: "Atribuir esta categoria",
  elegirCategoriaDestino: "Escolhe uma categoria",
  reindexarTitulo: "Reindexar o grupo {g}?",
  reindexarQuitaHuecos: "Retira-se 1 espaço: as categorias ficam seguidas no início do grupo. | Retiram-se {n} espaços: as categorias ficam seguidas no início do grupo.",
  reindexarCambiaTecla: "1 categoria muda de tecla: no terminal aparecerá noutro sítio. | {n} categorias mudam de tecla: no terminal aparecerão noutro sítio.",
  reindexarProductosSeQuedan: "Os produtos não mudam de categoria: vão com a sua.",
  reindexarComoQueda: "Como fica:",
  reindexarSinCambios: "Este grupo já está seguido: não há nada para reindexar.",
  unificarTitulo: "Unificar «{nombre}»?",
  aplicarTodosTitulo: "Aplicar as categorias a todos os terminais?",
  unificarTodosLaLlaman: "Todos os terminais passarão a chamá-la «{nombre}».",
  unificarPorServidor: "Fica o nome que o terminal servidor tem.",
  unificarPorMayoria: "Fica o nome que mais terminais usam.",
  unificarCambiaEn: "Muda em 1 terminal: os seus empregados verão o nome novo e o anterior perde-se. | Muda em {n} terminais: os seus empregados verão o nome novo e o anterior perde-se.",
  igualarProductosSeQuedan: "Os produtos não são alterados: continuam na sua categoria.",
  aplicarTodosEscribe: "Será escrito o nome de 1 categoria nos terminais onde falta. | Será escrito o nome de {n} categorias nos terminais onde falta.",
  aplicarTodosSaltadas: "1 categoria com nomes diferentes entre terminais fica como está: unifique-a a partir do seu aviso. | {n} categorias com nomes diferentes entre terminais ficam como estão: unifique-as a partir do seu aviso.",
  igualarQueCambia: "O que muda:",
  unificarOtroNombreBueno: "Se o nome certo for outro, cancele e mude-lhe o nome com o lápis: o nome que puser será guardado em todos os terminais.",
  aplicarTodosFaltaEn: "falta em {terminales}",
  aplicarTodosNada: "Não há nada a aplicar: as categorias pendentes têm nomes diferentes entre terminais e é preciso unificá-las antes.",
  igualarSeCrea: "não a tem",
  igualarSinNombre: "sem nome",
  reordenarTitulo: "Reordenar as categorias como no servidor?",
  reordenarMandaServidor: "Manda a ordem do servidor «{servidor}»: nos outros terminais, cada categoria passa para a tecla que tem lá.",
  reordenarCambianTecla: "1 categoria muda de tecla: no seu terminal aparecerá noutro sítio. | {n} categorias mudam de tecla: no seu terminal aparecerão noutro sítio.",
  reordenarApartadas: "1 categoria que o servidor não tem é afastada para outra tecla para dar lugar. | {n} categorias que o servidor não tem são afastadas para outra tecla para dar lugar.",
  reordenarProductosSeVan: "Os produtos vão com a sua categoria: nenhum muda de categoria.",
  reordenarNombresNoSeTocan: "Nenhum nome é alterado. Se depois ficar alguma diferença de nome, resolve-se com Unificar.",
  reordenarSinSitio: "Este terminal não é reordenado: não resta nenhuma tecla livre para afastar as categorias que estorvam.",
  reordenarSeAparta: "é afastada",
  reordenarAmbiguos: "Não se movem porque o seu nome está repetido: {nombres}.",
  reordenarSinCambios: "As categorias já estão nas mesmas teclas que no servidor.",
  ordenPrimeroTitulo: "Antes convém reordenar",
  ordenPrimeroTexto: "Há terminais com as categorias noutras teclas que no servidor. Convém reordená-las antes de fazer isto: caso contrário, podem produzir-se alterações erradas —por exemplo, pôr um nome em cima de outra categoria— e não se garante que tudo funcione bem depois.",
  continuarIgualmente: "Continuar mesmo assim",
  reordenarPrimero: "Reordenar primeiro",
  // Os "Como resolvo?" dos avisos. Texto fixo: pinta-se com v-html.
  comoLoSoluciono: "Como resolvo?",
  consejoOrdenAvisos: "Resolva-os de cima para baixo: cada correção pode alterar ou eliminar os avisos de baixo. Recarregue a página depois de cada uma.",
  consejoOrdenDistinto: "<p>Costuma acontecer quando alguém criou ou moveu categorias no próprio TPV: a mesma categoria está numa tecla no servidor e noutra nesse terminal.</p><ol><li>Prima <b>Reordenar</b>. É mostrado, terminal a terminal, que categoria passa para que tecla.</li><li>Confirme. Os produtos vão com a sua categoria: não é preciso voltar a colocá-los.</li><li>Espere que o terminal sincronize e confirme nele que cada tecla tem os seus produtos.</li><li>Recarregue a página e continue com os restantes avisos: agora já estão certos.</li></ol><p>Se um terminal aparecer como «não foi possível reordenar», tem as 40 teclas ocupadas. Elimine nele as categorias que sobram e volte a reordenar.</p><p>Enquanto este aviso estiver ativo, não unifique nomes: poria o nome na tecla errada.</p>",
  consejoOtroNombre: "<p>Quase sempre alguém a mudou de nome no TPV. Quem manda é o servidor.</p><ul><li><b>Se o nome certo é o do servidor:</b> prima <b>Unificar</b> e todos os terminais passam a chamá-la assim.</li><li><b>Se o certo é o do terminal:</b> edite-a com o lápis e escreva esse nome. Fica guardado em todos os terminais.</li><li><b>Se os dois nomes parecem de categorias diferentes</b> (por exemplo, «GARRAFAS» e «SHOTS»), não é um nome alterado, são teclas trocadas: reordene primeiro.</li></ul><p>Enquanto não estiver resolvido, esse grupo não pode ser reindexado.</p>",
  consejoSoloEnClientes: "<p>Foi criada num terminal cliente e não no servidor. Antes de decidir, veja quantos produtos tem e, se tiver dúvidas, pergunte no estabelecimento se a usam.</p><ul><li><b>Se a usam:</b> prima <b>Criar no servidor</b>. É criada nele e nos terminais onde falte, na mesma tecla.</li><li><b>Se sobra:</b> prima <b>Retirar do terminal</b> e escolha para que categoria passam os seus produtos, para não ficarem sem categoria.</li></ul>",
  consejoNombreRepetido: "<p>Duas teclas com o mesmo nome confundem o empregado, e Reordenar não as move porque não sabe qual é qual.</p><ul><li><b>Se fazem falta as duas:</b> edite uma com o lápis e dê-lhe um nome que a distinga (por exemplo, «VINHOS BRANCOS»).</li><li><b>Se uma sobra:</b> elimine-a com o X e passe os seus produtos para a outra.</li></ul><p>Normalmente a certa é a que tem mais produtos.</p>",
  consejoDesiguales: "<p>Acontece com terminais que estavam desligados ou sem ligação quando a categoria foi criada, ou com terminais adicionados depois. Em cada linha, o estado a âmbar diz em quantos terminais falta.</p><ol><li>Se houver avisos vermelhos de nome diferente, resolva-os primeiro: essas categorias são ignoradas.</li><li>Prima <b>Aplicar a todos</b>. Antes de escrever, mostra que terminal recebe o quê.</li><li>Confirme e espere que os terminais sincronizem.</li></ol><p>Se depois de sincronizar continuar a faltar num terminal, confirme que está ligado e com ligação.</p>",
  consejoTerminalesSinCategorias: "<p>O negócio ainda não tem categorias para lhe enviar. Crie-as com <b>Adicionar categoria</b> em cada grupo: são criadas ao mesmo tempo em todos os terminais.</p><p>Se esse terminal já não é usado, peça que o desativem para deixar de contar aqui.</p>",
  consejoProductosSinCategoria: "<p>Costumam vir de eliminar uma categoria sem escolher destino, ou de produtos criados no TPV sem categoria. Continuam à venda, mas o empregado só chega a eles pesquisando.</p><ol><li>Se a categoria onde deviam ficar não existir, crie-a primeiro com <b>Adicionar categoria</b>.</li><li>Prima <b>Ver produtos</b>, marque os que vão juntos e escolha a categoria.</li><li>Prima <b>Atribuir esta categoria</b>. São movidos em todos os terminais.</li><li>Repita com os restantes.</li></ol><p>Os de um grupo concreto também se veem a partir do olho da sua linha «Sem categoria».</p>",
  consejoTerminalPendiente: "<p>Não há nada a fazer aqui. Ligue o terminal com ligação à rede: copiará a carta do servidor e, ao enviá-la, passará a contar aqui como os outros.</p><p>Se o tempo passar e continuar a aparecer, confirme que o terminal foi ligado e tem ligação.</p>",
};



// WEBPACK FOOTER //
// ./src/language/portuguese.js